/**
 * THIS IS GENERATED FILE. DO NOT MODIFY IT DIRECTLY, RUN 'npm run types' INSTEAD.
 */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Color: { input: any; output: any };
  Cursor: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  Time: { input: any; output: any };
  TimeZone: { input: any; output: any };
};

export enum Approval_State {
  Approved = "APPROVED",
  Needed = "NEEDED",
  Private = "PRIVATE",
  Rejected = "REJECTED",
  Unneeded = "UNNEEDED",
}

export enum App_Id {
  IbgNok = "IBG_NOK",
  IbgNotifications = "IBG_NOTIFICATIONS",
  IbgVideocall = "IBG_VIDEOCALL",
}

export enum App_Module {
  Activity = "ACTIVITY",
  Booking = "BOOKING",
  Gallery = "GALLERY",
  Groups = "GROUPS",
  Library = "LIBRARY",
  Meal = "MEAL",
  Meeting = "MEETING",
  MyArchive = "MY_ARCHIVE",
  MyDay = "MY_DAY",
  News = "NEWS",
  Profiles = "PROFILES",
  WhatsHappening = "WHATS_HAPPENING",
  WorkSchedule = "WORK_SCHEDULE",
}

export enum Audit_Event_Entity {
  PlannerRepeatTask = "PLANNER_REPEAT_TASK",
  PlannerSubtask = "PLANNER_SUBTASK",
  PlannerTask = "PLANNER_TASK",
}

export enum Audit_Event_Type {
  Approve = "APPROVE",
  Complete = "COMPLETE",
  Create = "CREATE",
  Delete = "DELETE",
  Reject = "REJECT",
  Uncomplete = "UNCOMPLETE",
  Update = "UPDATE",
}

export type AccessToken = {
  __typename?: "AccessToken";
  id: Scalars["ID"]["output"];
  ttl: Scalars["String"]["output"];
  user?: Maybe<User>;
};

export type Activity = RepeatingActivity | SingleActivity;

export type ActivityCalendar = {
  __typename?: "ActivityCalendar";
  date: Scalars["Date"]["output"];
  empty?: Maybe<Scalars["Boolean"]["output"]>;
  participating?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ActivityInput = {
  category?: InputMaybe<Scalars["ID"]["input"]>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employeesResponsible?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  employeesSignedUp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  groups?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  maxSignup?: InputMaybe<Scalars["Int"]["input"]>;
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  notifyNokOnSignup?: InputMaybe<Scalars["Boolean"]["input"]>;
  pdf?: InputMaybe<Scalars["ID"]["input"]>;
  pictograms?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  pictures?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  price?: InputMaybe<Scalars["Int"]["input"]>;
  repeat?: InputMaybe<Scalars["ID"]["input"]>;
  residentsResponsible?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  residentsSignedUp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  rset?: InputMaybe<RRuleSetInput>;
  /** @deprecated Is always the same as endDate */
  showDateEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Use showFrom instead */
  showDateStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  showFrom?: InputMaybe<Scalars["Int"]["input"]>;
  signup?: InputMaybe<Scalars["Boolean"]["input"]>;
  signupClose?: InputMaybe<Scalars["Int"]["input"]>;
  /** @deprecated use signupClose instead */
  signupEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** @deprecated Not used */
  signupStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updateGroupPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
  vacation?: InputMaybe<Scalars["Boolean"]["input"]>;
  videos?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ActivityMutation = {
  __typename?: "ActivityMutation";
  delete?: Maybe<DefaultResponse>;
  save?: Maybe<DefaultResponse>;
  saveNotificationSettings?: Maybe<DefaultResponse>;
};

export type ActivityMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
  type?: InputMaybe<Delete_Type>;
};

export type ActivityMutationSaveArgs = {
  activity: ActivityInput;
  handleRepeats?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ActivityMutationSaveNotificationSettingsArgs = {
  settings: NotificationSettingsInput;
};

export type ActivityQuery = {
  __typename?: "ActivityQuery";
  getActivities?: Maybe<Array<Activity>>;
  getActivitiesByFilters?: Maybe<Array<Activity>>;
  /** @deprecated use category.get instead */
  getCategories?: Maybe<Array<Category>>;
};

export type ActivityQueryGetActivitiesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type ActivityQueryGetActivitiesByFiltersArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
  filter: Filter;
  visibility?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ActivityQueryGetCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  institutionId: Scalars["ID"]["input"];
};

export type ActivitySubscription = {
  id: Scalars["ID"]["input"];
};

export type Address = {
  __typename?: "Address";
  city?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
};

export type App = AppExternalActivity;

export type AppExternalActivity = {
  __typename?: "AppExternalActivity";
  icon: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  /** @deprecated Use `institution` entity instead */
  institutionId: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type AppExternalActivityInput = {
  departmentId?: InputMaybe<Scalars["ID"]["input"]>;
  fromInstitutionId?: InputMaybe<Scalars["ID"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institutionId?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  resourceId?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AppMutation = {
  __typename?: "AppMutation";
  deleteAppConnectionsScreen?: Maybe<DefaultResponse>;
  saveAppConnectionsScreen?: Maybe<DefaultResponse>;
};

export type AppMutationDeleteAppConnectionsScreenArgs = {
  id: Scalars["ID"]["input"];
};

export type AppMutationSaveAppConnectionsScreenArgs = {
  app: AppExternalActivityInput;
};

export type Archive = {
  __typename?: "Archive";
  documents?: Maybe<Array<Document>>;
  galleries?: Maybe<Array<Gallery>>;
  pictures?: Maybe<Array<GalleryPicture>>;
  videos?: Maybe<Array<GalleryVideo>>;
};

export type ArchiveQuery = {
  __typename?: "ArchiveQuery";
  getDocumentsByFilters?: Maybe<Array<Document>>;
};

export type ArchiveQueryGetDocumentsByFiltersArgs = {
  filter: Filter;
};

export type AuditLog = Node & {
  __typename?: "AuditLog";
  created: Scalars["DateTime"]["output"];
  entityId: Scalars["ID"]["output"];
  entityType: Scalars["String"]["output"];
  event: Audit_Event_Type;
  id: Scalars["ID"]["output"];
  profileId?: Maybe<Scalars["ID"]["output"]>;
  profileType?: Maybe<Profile_Type>;
  userId: Scalars["ID"]["output"];
};

export type AuditLogFilter = {
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  entityId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  entityType?: InputMaybe<Audit_Event_Entity>;
  event?: InputMaybe<Audit_Event_Type>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AuditLogQuery = {
  __typename?: "AuditLogQuery";
  getByFilters: Array<AuditLog>;
};

export type AuditLogQueryGetByFiltersArgs = {
  filters?: InputMaybe<AuditLogFilter>;
};

export enum Booking_Authentication {
  EmployeeOnly = "EMPLOYEE_ONLY",
  None = "NONE",
  Password = "PASSWORD",
}

export enum Booking_Slot_State {
  Available = "AVAILABLE",
  Booked = "BOOKED",
  Expired = "EXPIRED",
  Locked = "LOCKED",
}

export enum Bump_Type {
  Commented = "COMMENTED",
  EditedPost = "EDITED_POST",
  NewPost = "NEW_POST",
}

export type BookingInput = {
  bookingResourceId: Scalars["ID"]["input"];
  end: Scalars["DateTime"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institutionId: Scalars["ID"]["input"];
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  repeatId?: InputMaybe<Scalars["ID"]["input"]>;
  start: Scalars["DateTime"]["input"];
  status: Scalars["Int"]["input"];
  title: Scalars["String"]["input"];
};

export type BookingMutation = {
  __typename?: "BookingMutation";
  /** @deprecated use saveBooking instead */
  bookResourceScreen?: Maybe<DefaultResponse>;
  /** @deprecated use saveSlottedBooking instead */
  bookSlottedResourceScreen?: Maybe<DefaultResponse>;
  cancelBooking?: Maybe<DefaultResponse>;
  /** @deprecated use cancelBooking instead */
  cancelBookingScreen?: Maybe<DefaultResponse>;
  cancelSlottedBooking?: Maybe<DefaultResponse>;
  /** @deprecated use cancelSlottedBooking instead */
  cancelSlottedBookingScreen?: Maybe<DefaultResponse>;
  deleteBooking?: Maybe<DefaultResponse>;
  deleteBookingResource?: Maybe<DefaultResponse>;
  deleteSlottedPreBooking?: Maybe<DefaultResponse>;
  saveBooking?: Maybe<DefaultResponse>;
  saveBookingResource?: Maybe<DefaultResponse>;
  saveNotificationSettings?: Maybe<DefaultResponse>;
  saveSlottedBooking?: Maybe<DefaultResponse>;
  saveSlottedPreBooking?: Maybe<DefaultResponse>;
};

export type BookingMutationBookResourceScreenArgs = {
  booking: BookingResourceBooking;
  participants: Array<ProfileInput>;
};

export type BookingMutationBookSlottedResourceScreenArgs = {
  bookingSlot: BookingResourceBookingSlot;
  participants: Array<ProfileInput>;
};

export type BookingMutationCancelBookingArgs = {
  bookingResourceBookingId: Scalars["ID"]["input"];
  profile?: InputMaybe<ScreenProfile>;
};

export type BookingMutationCancelBookingScreenArgs = {
  bookingResourceBookingId: Scalars["ID"]["input"];
  profile: ScreenProfile;
};

export type BookingMutationCancelSlottedBookingArgs = {
  bookingSlot: BookingResourceBookingSlot;
  profile?: InputMaybe<ScreenProfile>;
};

export type BookingMutationCancelSlottedBookingScreenArgs = {
  bookingSlot: BookingResourceBookingSlot;
  profile: ScreenProfile;
};

export type BookingMutationDeleteBookingArgs = {
  id: Scalars["ID"]["input"];
};

export type BookingMutationDeleteBookingResourceArgs = {
  id: Scalars["ID"]["input"];
};

export type BookingMutationDeleteSlottedPreBookingArgs = {
  id: Scalars["ID"]["input"];
};

export type BookingMutationSaveBookingArgs = {
  booking: BookingInput;
  participants?: InputMaybe<Array<ProfileInput>>;
};

export type BookingMutationSaveBookingResourceArgs = {
  bookingResource: BookingResourceInput;
};

export type BookingMutationSaveNotificationSettingsArgs = {
  settings: NotificationSettingsInput;
};

export type BookingMutationSaveSlottedBookingArgs = {
  bookingSlot: BookingResourceBookingSlot;
  participants?: InputMaybe<Array<ProfileInput>>;
};

export type BookingMutationSaveSlottedPreBookingArgs = {
  locked?: InputMaybe<Scalars["Boolean"]["input"]>;
  preBooking: BookingResourcePreBooking;
  profile?: InputMaybe<ScreenProfile>;
};

export type BookingResource = Node & {
  __typename?: "BookingResource";
  authentication: Booking_Authentication;
  bookings?: Maybe<Array<BookingSlot>>;
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  institution: Institution;
  institutions?: Maybe<Array<Institution>>;
  slots?: Maybe<Array<BookingSlot>>;
  slotted: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type BookingResourceSlotsArgs = {
  timezone?: Scalars["TimeZone"]["input"];
};

export type BookingResourceBooking = {
  bookingResourceId: Scalars["ID"]["input"];
  end: Scalars["DateTime"]["input"];
  start: Scalars["DateTime"]["input"];
  title: Scalars["String"]["input"];
};

export type BookingResourceBookingSlot = {
  bookingResourceId: Scalars["ID"]["input"];
  bookingResourceSlotId: Scalars["ID"]["input"];
  date: Scalars["Date"]["input"];
};

export type BookingResourceCalendar = {
  __typename?: "BookingResourceCalendar";
  date: Scalars["Date"]["output"];
  empty: Scalars["Boolean"]["output"];
};

export type BookingResourceInput = {
  authentication?: InputMaybe<Booking_Authentication>;
  category?: InputMaybe<Scalars["ID"]["input"]>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  slots?: InputMaybe<Array<InputMaybe<BookingResourceSlotInput>>>;
  slotted?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type BookingResourcePreBooking = {
  bookingResourceId: Scalars["ID"]["input"];
  bookingResourceSlotId: Scalars["ID"]["input"];
  day: Scalars["Int"]["input"];
};

export type BookingResourceSlotInput = {
  end?: InputMaybe<Scalars["Time"]["input"]>;
  slotId?: InputMaybe<Scalars["ID"]["input"]>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type BookingSlot = Node & {
  __typename?: "BookingSlot";
  description?: Maybe<Scalars["String"]["output"]>;
  end: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  resource: BookingResource;
  start: Scalars["DateTime"]["output"];
  state: Booking_Slot_State;
};

export enum Call_Status {
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  Finished = "FINISHED",
  Ringing = "RINGING",
  Unanswered = "UNANSWERED",
}

export enum Category_Type {
  Activity = "ACTIVITY",
  BookingResource = "BOOKING_RESOURCE",
  Gallery = "GALLERY",
  Meeting = "MEETING",
  News = "NEWS",
}

export enum Container_Type {
  Activity = "ACTIVITY",
  Agenda = "AGENDA",
  Archive = "ARCHIVE",
  Booking = "BOOKING",
  Club = "CLUB",
  CoreNews = "CORE_NEWS",
  Gallery = "GALLERY",
  Group = "GROUP",
  Institution = "INSTITUTION",
  Logo = "LOGO",
  Meal = "MEAL",
  MealDish = "MEAL_DISH",
  Meeting = "MEETING",
  News = "NEWS",
  Pdf = "PDF",
  People = "PEOPLE",
  Pictogram = "PICTOGRAM",
  Planner = "PLANNER",
}

export type Call = {
  __typename?: "Call";
  createdAt: Scalars["DateTime"]["output"];
  endedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  initiator: User;
  participants: Array<User>;
  roomToken: Scalars["String"]["output"];
  status: Call_Status;
};

export type CallMutation = {
  __typename?: "CallMutation";
  accept: CallResponse;
  decline?: Maybe<Call>;
  finish?: Maybe<Call>;
  initiate: CallResponse;
};

export type CallMutationAcceptArgs = {
  id: Scalars["ID"]["input"];
};

export type CallMutationDeclineArgs = {
  id: Scalars["ID"]["input"];
};

export type CallMutationFinishArgs = {
  id: Scalars["ID"]["input"];
};

export type CallMutationInitiateArgs = {
  participants: Array<Scalars["ID"]["input"]>;
};

export type CallResponse = {
  __typename?: "CallResponse";
  accessToken: Scalars["String"]["output"];
  call: Call;
};

export type Category = {
  __typename?: "Category";
  description?: Maybe<Scalars["String"]["output"]>;
  entities?: Maybe<EntityPager>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  title: Scalars["String"]["output"];
};

export type CategoryEntitiesArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CategoryInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CategoryMutation = {
  __typename?: "CategoryMutation";
  delete?: Maybe<DefaultResponse>;
  save?: Maybe<DefaultResponse>;
};

export type CategoryMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
  type: Category_Type;
};

export type CategoryMutationSaveArgs = {
  category: CategoryInput;
  type: Category_Type;
};

export type CategoryQuery = {
  __typename?: "CategoryQuery";
  get?: Maybe<Array<Maybe<Category>>>;
};

export type CategoryQueryGetArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  type: Category_Type;
};

export type Club = Node & {
  __typename?: "Club";
  color?: Maybe<Scalars["Color"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  logo: Picture;
  name: Scalars["String"]["output"];
};

export type Comment = Node & {
  __typename?: "Comment";
  author?: Maybe<Profile>;
  body: Scalars["String"]["output"];
  changed: Scalars["DateTime"]["output"];
  coverImage?: Maybe<Picture>;
  id: Scalars["ID"]["output"];
  isChanged: Scalars["Boolean"]["output"];
  reactions?: Maybe<Array<Reaction>>;
  time: Scalars["DateTime"]["output"];
};

export type ContactMutation = {
  __typename?: "ContactMutation";
  favorite?: Maybe<DefaultResponse>;
  unfavorite?: Maybe<DefaultResponse>;
};

export type ContactMutationFavoriteArgs = {
  id: Scalars["ID"]["input"];
  type: Profile_Type;
};

export type ContactMutationUnfavoriteArgs = {
  id: Scalars["ID"]["input"];
  type: Profile_Type;
};

export type CoreNews = Node & {
  __typename?: "CoreNews";
  author: CoreNewsAuthor;
  body: Scalars["String"]["output"];
  coverImage: Picture;
  documents?: Maybe<Array<Document>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  isFeatured: Scalars["Boolean"]["output"];
  isRead?: Maybe<Scalars["Boolean"]["output"]>;
  pictures?: Maybe<Array<Picture>>;
  showFrom: Scalars["DateTime"]["output"];
  status: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
};

export type CoreNewsAuthor = Node & {
  __typename?: "CoreNewsAuthor";
  id: Scalars["ID"]["output"];
  image: Picture;
  name: Scalars["String"]["output"];
  status: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type CoreNewsAuthorInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CoreNewsInput = {
  author?: InputMaybe<Scalars["ID"]["input"]>;
  body?: InputMaybe<Scalars["String"]["input"]>;
  documents?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  isFeatured?: InputMaybe<Scalars["Boolean"]["input"]>;
  pictures?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  showFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  videos?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CoreNewsMutation = {
  __typename?: "CoreNewsMutation";
  delete?: Maybe<DefaultResponse>;
  deleteAuthor?: Maybe<DefaultResponse>;
  markRead?: Maybe<DefaultResponse>;
  save?: Maybe<DefaultResponse>;
  saveAuthor?: Maybe<DefaultResponse>;
};

export type CoreNewsMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type CoreNewsMutationDeleteAuthorArgs = {
  id: Scalars["ID"]["input"];
};

export type CoreNewsMutationMarkReadArgs = {
  id: Scalars["ID"]["input"];
  isRead: Scalars["Boolean"]["input"];
};

export type CoreNewsMutationSaveArgs = {
  coreNews: CoreNewsInput;
};

export type CoreNewsMutationSaveAuthorArgs = {
  author?: InputMaybe<CoreNewsAuthorInput>;
};

export type CoreNewsQuery = {
  __typename?: "CoreNewsQuery";
  get?: Maybe<Array<CoreNews>>;
  getAsAdmin?: Maybe<Array<CoreNews>>;
  getAuthors?: Maybe<Array<CoreNewsAuthor>>;
};

export type CoreNewsQueryGetArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type CoreNewsQueryGetAsAdminArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type CoreNewsQueryGetAuthorsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export enum Day_Of_Week {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export enum Delete_Type {
  Series = "SERIES",
  Single = "SINGLE",
}

export enum Device_Environment {
  Debug = "DEBUG",
  Production = "PRODUCTION",
}

export enum Device_Token_Type {
  Apns = "APNS",
  ApnsVoip = "APNS_VOIP",
  Firebase = "FIREBASE",
}

export type DefaultResponse = {
  __typename?: "DefaultResponse";
  id?: Maybe<Scalars["ID"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type DeleteDepartmentResponse = {
  __typename?: "DeleteDepartmentResponse";
  dependencies?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type DeletePlannerTaskInput = {
  deleteCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  deleteType?: InputMaybe<Planner_Task_Delete_Type>;
  id: Scalars["ID"]["input"];
};

export type Department = Node & {
  __typename?: "Department";
  color?: Maybe<Scalars["Color"]["output"]>;
  contentProviders?: Maybe<Array<Maybe<DepartmentContentProvider>>>;
  employeeOnly: Scalars["Boolean"]["output"];
  employees?: Maybe<Array<Employee>>;
  /** @deprecated does not exist on department */
  icon?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  institution: Institution;
  /** @deprecated use institution instead */
  institutionId: Scalars["ID"]["output"];
  keycloakMapping?: Maybe<Scalars["String"]["output"]>;
  loginKey?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  presentation?: Maybe<DepartmentPresentation>;
  /** @deprecated does not exist any longer */
  screenOnly: Scalars["Boolean"]["output"];
  settings?: Maybe<DepartmentSettings>;
  shiftType?: Maybe<Shift_Type>;
  showShifts: Scalars["Boolean"]["output"];
};

export type DepartmentAppConfig = {
  __typename?: "DepartmentAppConfig";
  appModules?: Maybe<Array<App_Module>>;
  /** @deprecated Use appModules instead */
  modules?: Maybe<Array<Maybe<ModuleForApp>>>;
  /** @deprecated Use appModules instead */
  modulesList?: Maybe<Array<Module_Type>>;
};

export type DepartmentAppConfigInput = {
  modules?: InputMaybe<Array<InputMaybe<App_Module>>>;
};

export type DepartmentContentProvider = {
  __typename?: "DepartmentContentProvider";
  content: Module_Type;
  institution: Institution;
};

export type DepartmentExternalServices = {
  __typename?: "DepartmentExternalServices";
  vismaGatWsId?: Maybe<Scalars["ID"]["output"]>;
  vivendiWsId?: Maybe<Scalars["ID"]["output"]>;
};

export type DepartmentExternalServicesInput = {
  vismaGatWsId?: InputMaybe<Scalars["ID"]["input"]>;
  vivendiWsId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DepartmentInput = {
  color?: InputMaybe<Scalars["Color"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employeeOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  keycloakMapping?: InputMaybe<Scalars["String"]["input"]>;
  loginKey?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  settings?: InputMaybe<DepartmentSettingsInput>;
  showShifts?: InputMaybe<Scalars["Boolean"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DepartmentMealSettings = {
  __typename?: "DepartmentMealSettings";
  daysForward: Scalars["Int"]["output"];
  nextDay: Scalars["Time"]["output"];
  /** @deprecated Moved to institution level */
  signup: Scalars["Boolean"]["output"];
};

export type DepartmentMutation = {
  __typename?: "DepartmentMutation";
  delete?: Maybe<DeleteDepartmentResponse>;
  save?: Maybe<DefaultResponse>;
};

export type DepartmentMutationDeleteArgs = {
  confirm?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type DepartmentMutationSaveArgs = {
  department: DepartmentInput;
};

export type DepartmentPresentation = {
  __typename?: "DepartmentPresentation";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use picture instead */
  image: Scalars["String"]["output"];
  picture: Picture;
  title: Scalars["String"]["output"];
};

export type DepartmentScreenConfig = {
  __typename?: "DepartmentScreenConfig";
  carouselDuration?: Maybe<Scalars["Int"]["output"]>;
  departmentSwitcher: Scalars["Boolean"]["output"];
  footerConfig?: Maybe<Array<Maybe<Module_List>>>;
  gridSize?: Maybe<Scalars["Int"]["output"]>;
  modules?: Maybe<Array<Maybe<ModuleForScreen>>>;
  timeout?: Maybe<Scalars["Int"]["output"]>;
  tokenTTL?: Maybe<Scalars["Int"]["output"]>;
};

export type DepartmentScreenConfigInput = {
  departmentSwitcher?: InputMaybe<Scalars["Boolean"]["input"]>;
  footerConfig?: InputMaybe<Array<InputMaybe<Module_List>>>;
  gridSize?: InputMaybe<Scalars["Int"]["input"]>;
  modules?: InputMaybe<Array<InputMaybe<ModuleForScreenInput>>>;
  tokenTTL?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DepartmentSettings = {
  __typename?: "DepartmentSettings";
  appConfig?: Maybe<DepartmentAppConfig>;
  externalServices?: Maybe<DepartmentExternalServices>;
  meal?: Maybe<DepartmentMealSettings>;
  screenConfig?: Maybe<DepartmentScreenConfig>;
  shift?: Maybe<DepartmentShiftSettings>;
  simpleSchedulePlan?: Maybe<Array<SimpleSchedulePlanEntry>>;
  slideshow?: Maybe<DepartmentSlideshowSettings>;
};

export type DepartmentSettingsInput = {
  appConfig?: InputMaybe<DepartmentAppConfigInput>;
  externalServices?: InputMaybe<DepartmentExternalServicesInput>;
  screenConfig?: InputMaybe<DepartmentScreenConfigInput>;
};

export type DepartmentShiftSettings = {
  __typename?: "DepartmentShiftSettings";
  dayDisplay?: Maybe<Scalars["Int"]["output"]>;
  daysForward?: Maybe<Scalars["Int"]["output"]>;
  gfx?: Maybe<Scalars["Boolean"]["output"]>;
  showCancelledFp?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DepartmentSlideshowSettings = {
  __typename?: "DepartmentSlideshowSettings";
  duration?: Maybe<Scalars["Int"]["output"]>;
};

export type DeviceInput = {
  appId: App_Id;
  environment?: InputMaybe<Device_Environment>;
  model?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
  tokenType?: InputMaybe<Device_Token_Type>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  uuid?: InputMaybe<Scalars["String"]["input"]>;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type DeviceMutation = {
  __typename?: "DeviceMutation";
  deregister?: Maybe<DefaultResponse>;
  register?: Maybe<DefaultResponse>;
};

export type DeviceMutationDeregisterArgs = {
  appId?: InputMaybe<App_Id>;
  token: Scalars["String"]["input"];
};

export type DeviceMutationRegisterArgs = {
  input?: InputMaybe<DeviceInput>;
};

export type Document = Node & {
  __typename?: "Document";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type DocumentConnection = {
  __typename?: "DocumentConnection";
  edges: Array<DocumentEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DocumentEdge = {
  __typename?: "DocumentEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Document;
};

export enum Entity_Status {
  Active = "ACTIVE",
  Disabled = "DISABLED",
}

export type Employee = Node & {
  __typename?: "Employee";
  alias?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Does not exist on Employee */
  birthday?: Maybe<Scalars["Date"]["output"]>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use image instead */
  displayImage: Scalars["String"]["output"];
  /** @deprecated Use image instead */
  displayImageId?: Maybe<Scalars["ID"]["output"]>;
  displayName: Scalars["String"]["output"];
  /** @deprecated Use user.email instead */
  email?: Maybe<Scalars["String"]["output"]>;
  employeeTitle?: Maybe<EmployeeTitle>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  hasAccess: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  isFavorite?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use user.roles instead */
  isSuperuser?: Maybe<Scalars["Boolean"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobile?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  password?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  plannerFilter?: Maybe<PlannerFilter>;
  profileVideo?: Maybe<Video>;
  settings?: Maybe<ProfileSettings>;
  /** @deprecated Does not exist */
  shift?: Maybe<Shift>;
  /** @deprecated Does not exist on Employee */
  showBirthday?: Maybe<Scalars["Boolean"]["output"]>;
  showEmail?: Maybe<Scalars["Boolean"]["output"]>;
  showImage?: Maybe<Scalars["Boolean"]["output"]>;
  showLastName?: Maybe<Scalars["Boolean"]["output"]>;
  showMobile?: Maybe<Scalars["Boolean"]["output"]>;
  startScreen?: Maybe<Start_Screen>;
  statistics?: Maybe<ProfileStats>;
  status: Scalars["Boolean"]["output"];
  surname?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use employeeTitle instead */
  title?: Maybe<Scalars["String"]["output"]>;
  type: Profile_Type;
  user?: Maybe<User>;
  /** @deprecated Use settings {videoCall} instead */
  videoCallEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use settings {videoCall} instead */
  videoCallStatus?: Maybe<Video_Call_Status>;
};

export type EmployeeInput = {
  alias?: InputMaybe<Scalars["String"]["input"]>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  /** @deprecated Use user.email instead */
  email?: InputMaybe<Scalars["String"]["input"]>;
  employeeTitle?: InputMaybe<Scalars["ID"]["input"]>;
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  lastname?: InputMaybe<Scalars["String"]["input"]>;
  mobile?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  plannerFilter?: InputMaybe<Scalars["ID"]["input"]>;
  profileVideo?: InputMaybe<Scalars["ID"]["input"]>;
  showEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  showImage?: InputMaybe<Scalars["Boolean"]["input"]>;
  showLastname?: InputMaybe<Scalars["Boolean"]["input"]>;
  showMobile?: InputMaybe<Scalars["Boolean"]["input"]>;
  showPhone?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Use user.changeSettings instead */
  startScreen?: InputMaybe<Start_Screen>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
  video?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EmployeeTitle = {
  __typename?: "EmployeeTitle";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type EmployeeTitleInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type EntityFeedEdge = {
  __typename?: "EntityFeedEdge";
  cursor: Scalars["Cursor"]["output"];
  node: PagedEntity;
};

export type EntityPager = {
  __typename?: "EntityPager";
  edges: Array<EntityFeedEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type EntityPagerFilter = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sorting?: InputMaybe<EntityPagerSorting>;
  status?: InputMaybe<Array<Entity_Status>>;
};

export type EntityPagerSorting = {
  field: Sort_Field;
  order: Sort_Order;
};

export type EntityVisibility = {
  __typename?: "EntityVisibility";
  entityId: Scalars["ID"]["output"];
  entityType: Module_Type;
  institutionId: Scalars["ID"]["output"];
};

export type EventEntity =
  | BookingSlot
  | Meal
  | RepeatingActivity
  | RepeatingMeal
  | RepeatingMeeting
  | RepeatingPlannerTask
  | SingleActivity
  | SingleMeal
  | SingleMeeting
  | SinglePlannerTask;

export type EventPrice = {
  __typename?: "EventPrice";
  currency: Scalars["String"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  price?: Maybe<Scalars["Int"]["output"]>;
  profileType: Profile_Type;
};

export type ExternalServicesQuery = {
  __typename?: "ExternalServicesQuery";
  getTravelPlan?: Maybe<Array<Maybe<TravelPlan>>>;
  searchTravelPlanLocation?: Maybe<Array<Maybe<TravelPlanLocation>>>;
};

export type ExternalServicesQueryGetTravelPlanArgs = {
  id: Scalars["ID"]["input"];
};

export type ExternalServicesQuerySearchTravelPlanLocationArgs = {
  locationName: Scalars["String"]["input"];
};

export type Filter = {
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  groups?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  institutions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum Gallery_Media_Type {
  Image = "IMAGE",
  Video = "VIDEO",
}

export enum Grouptype {
  RelativeDepartment = "RELATIVE_DEPARTMENT",
  RelativeResident = "RELATIVE_RESIDENT",
  Standard = "STANDARD",
}

export enum Group_Connection {
  Activity = "ACTIVITY",
  Booking = "BOOKING",
  Document = "DOCUMENT",
  Gallery = "GALLERY",
  MealPlan = "MEAL_PLAN",
  News = "NEWS",
  SchedulePlan = "SCHEDULE_PLAN",
}

export enum Group_Post_Entity_Type {
  Activity = "ACTIVITY",
  Gallery = "GALLERY",
  Library = "LIBRARY",
  Meal = "MEAL",
  Meeting = "MEETING",
  News = "NEWS",
  Post = "POST",
}

export enum Group_Type {
  Connect = "CONNECT",
  RelativeDepartment = "RELATIVE_DEPARTMENT",
  RelativeResident = "RELATIVE_RESIDENT",
  Standard = "STANDARD",
}

export type Gallery = Node & {
  __typename?: "Gallery";
  category?: Maybe<Category>;
  coverImage: Picture;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  media?: Maybe<Array<GalleryMedia>>;
  pictures?: Maybe<Array<GalleryPicture>>;
  settings?: Maybe<GallerySettings>;
  showOnFrontpage: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<GalleryVideo>>;
};

export type GalleryInput = {
  category?: InputMaybe<Scalars["ID"]["input"]>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  groups?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  pictures?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  residents?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  settings?: InputMaybe<GallerySettingsInput>;
  showOnFrontpage?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  videos?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type GalleryMedia = GalleryPicture | GalleryVideo;

export type GalleryMutation = {
  __typename?: "GalleryMutation";
  delete?: Maybe<DefaultResponse>;
  save?: Maybe<DefaultResponse>;
};

export type GalleryMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type GalleryMutationSaveArgs = {
  gallery: GalleryInput;
};

export type GalleryPicture = Node & {
  __typename?: "GalleryPicture";
  blurhash?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  favorited?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  inMyArchive?: Maybe<Scalars["Boolean"]["output"]>;
  source: Scalars["String"]["output"];
  type: Gallery_Media_Type;
};

export type GallerySettings = {
  __typename?: "GallerySettings";
  dreambrokerUrl?: Maybe<Scalars["String"]["output"]>;
};

export type GallerySettingsInput = {
  dreambrokerUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type GalleryVideo = Node & {
  __typename?: "GalleryVideo";
  blurhash?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  favorited?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  provider?: Maybe<Video_Provider>;
  thumbnail?: Maybe<Scalars["String"]["output"]>;
  type: Gallery_Media_Type;
  url: Scalars["String"]["output"];
};

export type Group = Node & {
  __typename?: "Group";
  color?: Maybe<Scalars["Color"]["output"]>;
  contentProviders?: Maybe<Array<Maybe<GroupContentProvider>>>;
  description?: Maybe<Scalars["String"]["output"]>;
  documentsConnection: DocumentConnection;
  externalDescription?: Maybe<Scalars["String"]["output"]>;
  groupType: Grouptype;
  id: Scalars["ID"]["output"];
  logo: Picture;
  /** @deprecated Please use the contentProviders property instead */
  moduleTypes: Array<Module_Type>;
  name: Scalars["String"]["output"];
  participants?: Maybe<Array<Profile>>;
  pictures?: Maybe<Array<Picture>>;
  postsConnection: GroupPostConnection;
  /** @deprecated Please use groupType instead */
  type?: Maybe<Group_Type>;
};

export type GroupDocumentsConnectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GroupPostsConnectionArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GroupContentProvider = {
  __typename?: "GroupContentProvider";
  content?: Maybe<Array<Group_Connection>>;
  institution: Institution;
};

export type GroupContentProviderInput = {
  content?: InputMaybe<Array<Group_Connection>>;
  institution: Scalars["ID"]["input"];
};

export type GroupFeedConnection = {
  __typename?: "GroupFeedConnection";
  edges: Array<GroupFeedEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GroupFeedEdge = {
  __typename?: "GroupFeedEdge";
  cursor: Scalars["Cursor"]["output"];
  node: GroupPost;
};

export type GroupInput = {
  color?: InputMaybe<Scalars["String"]["input"]>;
  contentProviders?: InputMaybe<Array<GroupContentProviderInput>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  externalDescription?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  logo?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Grouptype>;
};

export type GroupMutation = {
  __typename?: "GroupMutation";
  addMember: DefaultResponse;
  deleteGroup?: Maybe<DefaultResponse>;
  removeMember: DefaultResponse;
  saveGroup: DefaultResponse;
};

export type GroupMutationAddMemberArgs = {
  groupId: Scalars["ID"]["input"];
  permission: Scalars["Int"]["input"];
  profile: ProfileInput;
};

export type GroupMutationDeleteGroupArgs = {
  id: Scalars["ID"]["input"];
};

export type GroupMutationRemoveMemberArgs = {
  groupId: Scalars["ID"]["input"];
  profile: ProfileInput;
};

export type GroupMutationSaveGroupArgs = {
  group: GroupInput;
};

export type GroupPost = Node & {
  __typename?: "GroupPost";
  author?: Maybe<Profile>;
  body: Scalars["String"]["output"];
  bumpType: Bump_Type;
  changed: Scalars["DateTime"]["output"];
  comments?: Maybe<Array<Comment>>;
  coverImage?: Maybe<Picture>;
  entity?: Maybe<GroupPostEntity>;
  entityId?: Maybe<Scalars["Int"]["output"]>;
  entityType: Group_Post_Entity_Type;
  group: Group;
  id: Scalars["ID"]["output"];
  isChanged: Scalars["Boolean"]["output"];
  reactions?: Maybe<Array<Reaction>>;
  time: Scalars["DateTime"]["output"];
  videoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type GroupPostConnection = {
  __typename?: "GroupPostConnection";
  edges: Array<GroupPostEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GroupPostEdge = {
  __typename?: "GroupPostEdge";
  cursor: Scalars["Cursor"]["output"];
  node: GroupPost;
};

export type GroupPostEntity =
  | Document
  | Gallery
  | Meal
  | News
  | RepeatingActivity
  | RepeatingMeal
  | RepeatingMeeting
  | RepeatingNews
  | SingleActivity
  | SingleMeal
  | SingleMeeting
  | SingleNews;

export enum Invitation_Status {
  Accepted = "ACCEPTED",
  None = "NONE",
  Pending = "PENDING",
  Rejected = "REJECTED",
}

export type ImageUpload = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  container: Container_Type;
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputNotificationSettingActivity = {
  cancelled: Scalars["Boolean"]["input"];
  /** @deprecated Not used */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Not used */
  reminders?: InputMaybe<Array<InputMaybe<InputReminder>>>;
  timeChanged: Scalars["Boolean"]["input"];
};

export type InputNotificationSettingBooking = {
  deleted: Scalars["Boolean"]["input"];
  /** @deprecated Not used */
  reminders?: InputMaybe<Array<InputMaybe<InputReminder>>>;
  timeChanged: Scalars["Boolean"]["input"];
};

export type InputNotificationSettingGroup = {
  comments: Scalars["Boolean"]["input"];
  join: Scalars["Boolean"]["input"];
  likes: Scalars["Boolean"]["input"];
  post: Scalars["Boolean"]["input"];
};

export type InputNotificationSettingMeeting = {
  cancelled: Scalars["Boolean"]["input"];
  /** @deprecated Not used */
  deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Not used */
  reminders?: InputMaybe<Array<InputMaybe<InputReminder>>>;
  timeChanged: Scalars["Boolean"]["input"];
};

export type InputNotificationSettingPlanner = {
  assignedToMe: Scalars["Boolean"]["input"];
  assignmentChanged: Scalars["Boolean"]["input"];
  assignmentCompleted: Scalars["Boolean"]["input"];
  assignmentOverdue: Scalars["Boolean"]["input"];
  reminders?: InputMaybe<Array<InputMaybe<InputReminder>>>;
};

export type InputReminder = {
  minutes: Scalars["Int"]["input"];
};

export type InputTextToSpeechFilter = {
  enabled: Scalars["Boolean"]["input"];
  speakingRate: Speaking_Rate;
};

export type Institution = Node & {
  __typename?: "Institution";
  activities?: Maybe<EntityPager>;
  address?: Maybe<Address>;
  bookings?: Maybe<EntityPager>;
  color?: Maybe<Scalars["Color"]["output"]>;
  connectEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  departments?: Maybe<Array<Department>>;
  employees?: Maybe<EntityPager>;
  externalContent?: Maybe<EntityPager>;
  externalDepartments?: Maybe<Array<Department>>;
  externalGroups?: Maybe<Array<Group>>;
  fkiEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  locale?: Maybe<Scalars["String"]["output"]>;
  logo: Picture;
  mealDishes?: Maybe<EntityPager>;
  meals?: Maybe<EntityPager>;
  meetingAgendaPointTemplates?: Maybe<EntityPager>;
  meetings?: Maybe<EntityPager>;
  name: Scalars["String"]["output"];
  news?: Maybe<EntityPager>;
  notificationSettings?: Maybe<InstitutionNotificationSettings>;
  phone?: Maybe<Scalars["String"]["output"]>;
  relatives?: Maybe<EntityPager>;
  residents?: Maybe<EntityPager>;
  settings: InstitutionSettings;
  /** @deprecated Use settings {showAllDepartments} instead */
  showAllDepartments: Scalars["Boolean"]["output"];
  slottedPreBookings?: Maybe<Array<SlottedPreBooking>>;
};

export type InstitutionActivitiesArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionBookingsArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionEmployeesArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionExternalContentArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
  type: Module_Type;
};

export type InstitutionExternalDepartmentsArgs = {
  type: Module_Type;
};

export type InstitutionExternalGroupsArgs = {
  type: Group_Connection;
};

export type InstitutionGroupsArgs = {
  type?: InputMaybe<Group_Connection>;
};

export type InstitutionMealDishesArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionMealsArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionMeetingAgendaPointTemplatesArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionMeetingsArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionNewsArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionRelativesArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionResidentsArgs = {
  filter?: InputMaybe<EntityPagerFilter>;
};

export type InstitutionSlottedPreBookingsArgs = {
  bookingResource: Scalars["ID"]["input"];
};

export type InstitutionAppSettingMeals = {
  __typename?: "InstitutionAppSettingMeals";
  daysForward: Scalars["Int"]["output"];
  departmentId: Scalars["Int"]["output"];
};

export type InstitutionAppSettingShift = {
  __typename?: "InstitutionAppSettingShift";
  dayDisplay?: Maybe<Scalars["Int"]["output"]>;
  daysForward?: Maybe<Scalars["Int"]["output"]>;
  departmentId?: Maybe<Scalars["Int"]["output"]>;
  gfx?: Maybe<Scalars["Boolean"]["output"]>;
  showCancelledFp?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InstitutionGeneralSettingsFeaturesInput = {
  employeeAdmins?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type InstitutionGeneralSettingsFkiInput = {
  mapping?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type InstitutionGeneralSettingsInput = {
  activityAlwaysShowAllUsersInSignupScreen?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  activityHideSignups?: InputMaybe<Scalars["Boolean"]["input"]>;
  autoRenewToken?: InputMaybe<Scalars["Boolean"]["input"]>;
  createMaxResidents?: InputMaybe<Scalars["Int"]["input"]>;
  features?: InputMaybe<InstitutionGeneralSettingsFeaturesInput>;
  fki?: InputMaybe<InstitutionGeneralSettingsFkiInput>;
  galleryPasswordProtected?: InputMaybe<Scalars["Boolean"]["input"]>;
  gdprShowPersonalImageDefault?: InputMaybe<Scalars["Boolean"]["input"]>;
  mitIdLogin?: InputMaybe<Scalars["Boolean"]["input"]>;
  myDay?: InputMaybe<InstitutionGeneralSettingsMyDayInput>;
  screenPasswordProtection?: InputMaybe<InstitutionGeneralSettingsScreenPasswordProtectionInput>;
  videoCall?: InputMaybe<InstitutionGeneralSettingsVideoCallInput>;
  vismaGatWs?: InputMaybe<Scalars["Boolean"]["input"]>;
  vivendi?: InputMaybe<InstitutionGeneralSettingsVivendiInput>;
};

export type InstitutionGeneralSettingsMyDayInput = {
  daysForward?: InputMaybe<Scalars["Int"]["input"]>;
  timeTimer?: InputMaybe<InstitutionGeneralSettingsMyDayTimeTimerInput>;
};

export type InstitutionGeneralSettingsMyDayTimeTimerInput = {
  defaultValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InstitutionGeneralSettingsScreenPasswordProtectionInput = {
  isProtected: Scalars["Boolean"]["input"];
  maxFailed: Scalars["Int"]["input"];
  userLockedOutInMinutes: Scalars["Int"]["input"];
};

export type InstitutionGeneralSettingsVideoCallInput = {
  employee?: InputMaybe<InstitutionGeneralSettingsVideoCallProfileInput>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  resident?: InputMaybe<InstitutionGeneralSettingsVideoCallProfileInput>;
};

export type InstitutionGeneralSettingsVideoCallProfileInput = {
  enabled: Scalars["Boolean"]["input"];
};

export type InstitutionGeneralSettingsVivendiInput = {
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  labelBlacklist?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type InstitutionInput = {
  connectEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  cvr?: InputMaybe<Scalars["String"]["input"]>;
  fkiEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  settings?: InputMaybe<InstitutionSettingsInput>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InstitutionManagerFeaturesEmployeeInput = {
  canCreateNew?: InputMaybe<Array<Scalars["String"]["input"]>>;
  profile?: InputMaybe<InstitutionManagerFeaturesEmployeeProfileInput>;
  security?: InputMaybe<InstitutionManagerFeaturesEmployeeSecurityInput>;
};

export type InstitutionManagerFeaturesEmployeeProfileInput = {
  alias?: InputMaybe<Array<Scalars["String"]["input"]>>;
  departments?: InputMaybe<Array<Scalars["String"]["input"]>>;
  description?: InputMaybe<Array<Scalars["String"]["input"]>>;
  email?: InputMaybe<Array<Scalars["String"]["input"]>>;
  externalId?: InputMaybe<Array<Scalars["String"]["input"]>>;
  firstName?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lastName?: InputMaybe<Array<Scalars["String"]["input"]>>;
  mobile?: InputMaybe<Array<Scalars["String"]["input"]>>;
  phone?: InputMaybe<Array<Scalars["String"]["input"]>>;
  showImage?: InputMaybe<Array<Scalars["String"]["input"]>>;
  title?: InputMaybe<Array<Scalars["String"]["input"]>>;
  useExternalMeals?: InputMaybe<Array<Scalars["String"]["input"]>>;
  useExternalMedia?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type InstitutionManagerFeaturesEmployeeSecurityInput = {
  associateNewEmployee?: InputMaybe<Array<Scalars["String"]["input"]>>;
  associateNewResident?: InputMaybe<Array<Scalars["String"]["input"]>>;
  downloadGalleries?: InputMaybe<Array<Scalars["String"]["input"]>>;
  password?: InputMaybe<Array<Scalars["String"]["input"]>>;
  screenPin?: InputMaybe<Array<Scalars["String"]["input"]>>;
  superuser?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type InstitutionManagerFeaturesInput = {
  employee?: InputMaybe<InstitutionManagerFeaturesEmployeeInput>;
};

export type InstitutionMutation = {
  __typename?: "InstitutionMutation";
  save?: Maybe<DefaultResponse>;
  saveEmployeeTitle?: Maybe<DefaultResponse>;
  setEntityVisibility?: Maybe<DefaultResponse>;
};

export type InstitutionMutationSaveArgs = {
  institution: InstitutionInput;
};

export type InstitutionMutationSaveEmployeeTitleArgs = {
  title: EmployeeTitleInput;
};

export type InstitutionMutationSetEntityVisibilityArgs = {
  entityId: Scalars["ID"]["input"];
  entityType: Module_Type;
  institutionId: Scalars["ID"]["input"];
  status: Scalars["Boolean"]["input"];
};

export type InstitutionNotificationSettings = {
  __typename?: "InstitutionNotificationSettings";
  activity?: Maybe<NotificationSettings>;
  booking?: Maybe<NotificationSettings>;
  meeting?: Maybe<NotificationSettings>;
};

export type InstitutionPlannerSettingsInput = {
  enabledEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabledResidents?: InputMaybe<Scalars["Boolean"]["input"]>;
  manager?: InputMaybe<InstitutionSettingPlannerManagerInput>;
  resident?: InputMaybe<ProfilePlannerSettingsInput>;
};

export type InstitutionQuery = {
  __typename?: "InstitutionQuery";
  get?: Maybe<Array<Institution>>;
  getEmployeeTitles?: Maybe<Array<EmployeeTitle>>;
  getEntityVisibility?: Maybe<Array<EntityVisibility>>;
  getMyInstitution: Institution;
};

export type InstitutionQueryGetArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type InstitutionQueryGetEntityVisibilityArgs = {
  entityType: Module_Type;
  institutionId: Scalars["ID"]["input"];
};

export type InstitutionSettingMyDay = {
  __typename?: "InstitutionSettingMyDay";
  daysForward: Scalars["Int"]["output"];
  timeTimer: InstitutionSettingMyDayTimeTimer;
};

export type InstitutionSettingMyDayTimeTimer = {
  __typename?: "InstitutionSettingMyDayTimeTimer";
  defaultValue: Scalars["Boolean"]["output"];
  enabled: Scalars["Boolean"]["output"];
};

export type InstitutionSettingPlanner = {
  __typename?: "InstitutionSettingPlanner";
  enabledEmployees: Scalars["Boolean"]["output"];
  enabledResidents: Scalars["Boolean"]["output"];
  manager?: Maybe<InstitutionSettingPlannerManager>;
  resident?: Maybe<ProfilePlannerAssignmentSettings>;
};

export type InstitutionSettingPlannerManager = {
  __typename?: "InstitutionSettingPlannerManager";
  showOverdue?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated use Institution { settings { myDay { timeTimer } } } */
  timeTimer?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InstitutionSettingPlannerManagerInput = {
  showOverdue?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated use InstitutionGeneralSettingsInput { InstitutionGeneralSettingsMyDayInput { timeTimer } } */
  timeTimer?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InstitutionSettingScreen = {
  __typename?: "InstitutionSettingScreen";
  activityHideSignups: Scalars["Boolean"]["output"];
  galleryPasswordProtected: Scalars["Boolean"]["output"];
  passwordProtection?: Maybe<InstitutionSettingScreenPassword>;
};

export type InstitutionSettingScreenPassword = {
  __typename?: "InstitutionSettingScreenPassword";
  isProtected: Scalars["Boolean"]["output"];
  maxFailed: Scalars["Int"]["output"];
  userLockedOutInMinutes: Scalars["Int"]["output"];
};

export type InstitutionSettings = {
  __typename?: "InstitutionSettings";
  autoRenewToken: Scalars["Boolean"]["output"];
  /** @deprecated Use Department {settings {meal}} instead */
  meal?: Maybe<Array<InstitutionAppSettingMeals>>;
  myDay: InstitutionSettingMyDay;
  planner: InstitutionSettingPlanner;
  screen: InstitutionSettingScreen;
  /** @deprecated Use Department {settings {shift}} instead */
  shift?: Maybe<Array<InstitutionAppSettingShift>>;
  showAllDepartments: Scalars["Boolean"]["output"];
  showResInfoDefault: Scalars["Boolean"]["output"];
  useExternalMeals: Scalars["Boolean"]["output"];
  useExternalMedia: Scalars["Boolean"]["output"];
  useExternalWorkSchedule: Scalars["Boolean"]["output"];
  vismaGatWs: Scalars["Boolean"]["output"];
  vivendiWs: Scalars["Boolean"]["output"];
};

export type InstitutionSettingsInput = {
  generalSettings?: InputMaybe<InstitutionGeneralSettingsInput>;
  managerFeatures?: InputMaybe<InstitutionManagerFeaturesInput>;
  plannerSettings?: InputMaybe<InstitutionPlannerSettingsInput>;
};

export enum Module_List {
  Activities = "ACTIVITIES",
  Booking = "BOOKING",
  ExternalActivities = "EXTERNAL_ACTIVITIES",
  Gallery = "GALLERY",
  JourneyPlanner = "JOURNEY_PLANNER",
  LaterWorkSchedule = "LATER_WORK_SCHEDULE",
  MealPlan = "MEAL_PLAN",
  Meetings = "MEETINGS",
  News = "NEWS",
  OurHome = "OUR_HOME",
  SimpleWorkSchedule = "SIMPLE_WORK_SCHEDULE",
  Slideshow = "SLIDESHOW",
  Weather = "WEATHER",
  WorkSchedule = "WORK_SCHEDULE",
}

export enum Module_Type {
  Activity = "ACTIVITY",
  Booking = "BOOKING",
  Gallery = "GALLERY",
  Groups = "GROUPS",
  Library = "LIBRARY",
  Meal = "MEAL",
  Meeting = "MEETING",
  MyDay = "MY_DAY",
  News = "NEWS",
  Profiles = "PROFILES",
  WhatsHappening = "WHATS_HAPPENING",
  WorkSchedule = "WORK_SCHEDULE",
}

export type Meal = Node & {
  __typename?: "Meal";
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  dishes?: Maybe<Array<MealDish>>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use pictures instead */
  image?: Maybe<Picture>;
  institution: Institution;
  /** @deprecated Doesn't exist */
  location?: Maybe<Scalars["String"]["output"]>;
  maxSignups?: Maybe<Scalars["Int"]["output"]>;
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  /** @deprecated Use dishes instead */
  parts?: Maybe<Array<MealPart>>;
  /** @deprecated Doesn't exist */
  pictograms?: Maybe<Array<Pictogram>>;
  pictures?: Maybe<Array<Picture>>;
  /** @deprecated Doesn't exist */
  price?: Maybe<Array<EventPrice>>;
  /** @deprecated Doesn't exist */
  read: Scalars["Boolean"]["output"];
  signupClose: Scalars["Int"]["output"];
  signupEnabled: Scalars["Boolean"]["output"];
  signupEnd?: Maybe<Scalars["DateTime"]["output"]>;
  signupPossible: Scalars["Boolean"]["output"];
  signupStart?: Maybe<Scalars["DateTime"]["output"]>;
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type MealCalendar = {
  __typename?: "MealCalendar";
  date: Scalars["Date"]["output"];
  empty?: Maybe<Scalars["Boolean"]["output"]>;
  participating?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MealDish = {
  __typename?: "MealDish";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  picture?: Maybe<Picture>;
  title: Scalars["String"]["output"];
};

export type MealDishInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  picture?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MealInput = {
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  documents?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  employeesResponsible?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  employeesSignedUp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  groups?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Use pictures instead */
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  maxSignup?: InputMaybe<Scalars["Int"]["input"]>;
  mealType?: InputMaybe<Scalars["ID"]["input"]>;
  pictures?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  repeat?: InputMaybe<Scalars["ID"]["input"]>;
  residentsResponsible?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  residentsSignedUp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  rset?: InputMaybe<RRuleSetInput>;
  signup?: InputMaybe<Scalars["Boolean"]["input"]>;
  signupClose?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updateGroupPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
  videos?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MealMutation = {
  __typename?: "MealMutation";
  deleteDish: DefaultResponse;
  deleteMeal: DefaultResponse;
  saveDish: DefaultResponse;
  saveMeal: DefaultResponse;
};

export type MealMutationDeleteDishArgs = {
  id: Scalars["ID"]["input"];
};

export type MealMutationDeleteMealArgs = {
  id: Scalars["ID"]["input"];
  type?: InputMaybe<Delete_Type>;
};

export type MealMutationSaveDishArgs = {
  dish: MealDishInput;
};

export type MealMutationSaveMealArgs = {
  dishes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  meal: MealInput;
};

export type MealPart = {
  __typename?: "MealPart";
  description?: Maybe<Scalars["String"]["output"]>;
  picture?: Maybe<Picture>;
  title: Scalars["String"]["output"];
};

export type MealQuery = {
  __typename?: "MealQuery";
  getMeals?: Maybe<Array<MealUnion>>;
  getMealsByFilters?: Maybe<Array<MealUnion>>;
};

export type MealQueryGetMealsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MealQueryGetMealsByFiltersArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
  filter: Filter;
};

export type MealSubscription = {
  id: Scalars["ID"]["input"];
};

export type MealUnion = RepeatingMeal | SingleMeal;

export type Meeting = RepeatingMeeting | SingleMeeting;

export type MeetingAgendaPoint = {
  __typename?: "MeetingAgendaPoint";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  picture?: Maybe<Picture>;
  title: Scalars["String"]["output"];
};

export type MeetingAgendaPointInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  picture?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MeetingAgendaPointTemplate = {
  __typename?: "MeetingAgendaPointTemplate";
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  picture?: Maybe<Picture>;
  title: Scalars["String"]["output"];
};

export type MeetingAgendaPointTemplateInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  picture?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MeetingCalendar = {
  __typename?: "MeetingCalendar";
  date: Scalars["Date"]["output"];
  empty?: Maybe<Scalars["Boolean"]["output"]>;
  participating?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MeetingInput = {
  agendaPoints?: InputMaybe<Array<MeetingAgendaPointInput>>;
  category?: InputMaybe<Scalars["ID"]["input"]>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employeesSignedUp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  location?: InputMaybe<Scalars["String"]["input"]>;
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  repeat?: InputMaybe<Scalars["ID"]["input"]>;
  residentsSignedUp?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  rset?: InputMaybe<RRuleSetInput>;
  signup?: InputMaybe<Scalars["Boolean"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  suggestionsByEmployees?: InputMaybe<Array<MeetingSuggestionInput>>;
  suggestionsByResidents?: InputMaybe<Array<MeetingSuggestionInput>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MeetingMutation = {
  __typename?: "MeetingMutation";
  cancelSignup?: Maybe<DefaultResponse>;
  /** @deprecated use cancelSignup instead */
  cancelSignupScreen?: Maybe<DefaultResponse>;
  cancelSuggestion?: Maybe<DefaultResponse>;
  /** @deprecated use cancelSuggestion instead */
  cancelSuggestionScreen?: Maybe<DefaultResponse>;
  delete?: Maybe<DefaultResponse>;
  deleteAgendaPointTemplate?: Maybe<DefaultResponse>;
  save?: Maybe<DefaultResponse>;
  saveAgendaPointTemplate?: Maybe<DefaultResponse>;
  saveNotificationSettings?: Maybe<DefaultResponse>;
  signup?: Maybe<DefaultResponse>;
  /** @deprecated use signup instead */
  signupScreen?: Maybe<DefaultResponse>;
  suggest?: Maybe<DefaultResponse>;
  /** @deprecated use suggest instead */
  suggestScreen?: Maybe<DefaultResponse>;
};

export type MeetingMutationCancelSignupArgs = {
  profile?: InputMaybe<ScreenProfile>;
  subscription: MeetingSubscription;
};

export type MeetingMutationCancelSignupScreenArgs = {
  profile: ScreenProfile;
  subscription: MeetingSubscription;
};

export type MeetingMutationCancelSuggestionArgs = {
  meetingSuggestionId: Scalars["ID"]["input"];
  profile?: InputMaybe<ScreenProfile>;
};

export type MeetingMutationCancelSuggestionScreenArgs = {
  meetingSuggestionId: Scalars["ID"]["input"];
  profile: ScreenProfile;
};

export type MeetingMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
  type?: InputMaybe<Delete_Type>;
};

export type MeetingMutationDeleteAgendaPointTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type MeetingMutationSaveArgs = {
  handleRepeats?: InputMaybe<Scalars["Boolean"]["input"]>;
  meeting: MeetingInput;
};

export type MeetingMutationSaveAgendaPointTemplateArgs = {
  agendaPoint: MeetingAgendaPointTemplateInput;
};

export type MeetingMutationSaveNotificationSettingsArgs = {
  settings: NotificationSettingsInput;
};

export type MeetingMutationSignupArgs = {
  profile?: InputMaybe<ScreenProfile>;
  subscription: MeetingSubscription;
};

export type MeetingMutationSignupScreenArgs = {
  profile: ScreenProfile;
  subscription: MeetingSubscription;
};

export type MeetingMutationSuggestArgs = {
  meetingId: Scalars["ID"]["input"];
  profile?: InputMaybe<ScreenProfile>;
  suggestion: Scalars["String"]["input"];
};

export type MeetingMutationSuggestScreenArgs = {
  meetingId: Scalars["ID"]["input"];
  profile: ScreenProfile;
  suggestion: Scalars["String"]["input"];
};

export type MeetingSubscription = {
  id: Scalars["ID"]["input"];
};

export type MeetingSuggestion = {
  __typename?: "MeetingSuggestion";
  id: Scalars["ID"]["output"];
  status?: Maybe<Scalars["Boolean"]["output"]>;
  suggester?: Maybe<Profile>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type MeetingSuggestionInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ModuleForApp = {
  __typename?: "ModuleForApp";
  id: Scalars["ID"]["output"];
  type?: Maybe<Module_List>;
};

export type ModuleForScreen = {
  __typename?: "ModuleForScreen";
  colSpan?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  rowSpan?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Module_List>;
};

export type ModuleForScreenInput = {
  colSpan: Scalars["String"]["input"];
  rowSpan: Scalars["String"]["input"];
  type?: InputMaybe<Module_List>;
};

export type Mutation = {
  __typename?: "Mutation";
  activity?: Maybe<ActivityMutation>;
  activityCancelSignup?: Maybe<DefaultResponse>;
  activityCancelSignupScreen?: Maybe<DefaultResponse>;
  activitySignup?: Maybe<DefaultResponse>;
  activitySignupScreen?: Maybe<DefaultResponse>;
  app?: Maybe<AppMutation>;
  approvePlannerTask?: Maybe<DefaultResponse>;
  archiveAdd?: Maybe<DefaultResponse>;
  archiveAddScreen?: Maybe<DefaultResponse>;
  archiveRemove?: Maybe<DefaultResponse>;
  archiveRemoveScreen?: Maybe<DefaultResponse>;
  archiveUpload?: Maybe<DefaultResponse>;
  booking?: Maybe<BookingMutation>;
  /** @deprecated Use booking {saveBooking} instead */
  bookingResourceBook?: Maybe<DefaultResponse>;
  /** @deprecated use booking {saveSlottedBooking} instead */
  bookingResourceBookSlot?: Maybe<DefaultResponse>;
  /** @deprecated Use booking {cancelBooking} instead */
  bookingResourceCancelBooking?: Maybe<DefaultResponse>;
  /** @deprecated use booking {cancelSlottedBooking} instead */
  bookingResourceCancelBookingSlot?: Maybe<DefaultResponse>;
  call?: Maybe<CallMutation>;
  category?: Maybe<CategoryMutation>;
  /** @deprecated Use device {register} instead */
  changeDeviceSettings?: Maybe<DefaultResponse>;
  /** @deprecated Use user {changeSettings} and user {saveProfile} instead */
  changeSettings?: Maybe<DefaultResponse>;
  completePlannerSubtask?: Maybe<PlannerTaskActionResponse>;
  completePlannerTask?: Maybe<PlannerTaskActionResponse>;
  contact?: Maybe<ContactMutation>;
  coreNews?: Maybe<CoreNewsMutation>;
  createPlannerTask?: Maybe<PlannerTaskActionResponse>;
  deleteComment?: Maybe<DefaultResponse>;
  deletePlannerTask?: Maybe<DefaultResponse>;
  deletePost?: Maybe<DefaultResponse>;
  deleteUser?: Maybe<DefaultResponse>;
  department?: Maybe<DepartmentMutation>;
  device?: Maybe<DeviceMutation>;
  editComment?: Maybe<DefaultResponse>;
  /** @deprecated Use department { save } instead */
  editDepartment?: Maybe<DefaultResponse>;
  editPlannerTask?: Maybe<PlannerTaskActionResponse>;
  editPost?: Maybe<DefaultResponse>;
  gallery?: Maybe<GalleryMutation>;
  group?: Maybe<GroupMutation>;
  institution?: Maybe<InstitutionMutation>;
  meal?: Maybe<MealMutation>;
  mealCancelSignup?: Maybe<DefaultResponse>;
  mealCancelSignupScreen?: Maybe<DefaultResponse>;
  mealSignup?: Maybe<DefaultResponse>;
  mealSignupScreen?: Maybe<DefaultResponse>;
  meeting?: Maybe<MeetingMutation>;
  /** @deprecated Use meeting {cancelSignup} instead */
  meetingCancelSignup?: Maybe<DefaultResponse>;
  /** @deprecated Use meeting {cancelSuggestion} instead */
  meetingCancelSuggestion?: Maybe<DefaultResponse>;
  /** @deprecated Use meeting {signup} instead */
  meetingSignup?: Maybe<DefaultResponse>;
  /** @deprecated Use meeting {suggest} instead */
  meetingSuggest?: Maybe<DefaultResponse>;
  news?: Maybe<NewsMutation>;
  notification?: Maybe<NotificationMutation>;
  planner?: Maybe<PlannerMutation>;
  postComment?: Maybe<DefaultResponse>;
  postPost?: Maybe<DefaultResponse>;
  reactComment?: Maybe<DefaultResponse>;
  reactPost?: Maybe<DefaultResponse>;
  rejectPlannerTask?: Maybe<DefaultResponse>;
  resource?: Maybe<ResourceMutation>;
  schedule?: Maybe<ScheduleMutation>;
  self?: Maybe<SelfMutation>;
  shift?: Maybe<ShiftMutation>;
  uncompletePlannerSubtask?: Maybe<PlannerTaskActionResponse>;
  uncompletePlannerTask?: Maybe<PlannerTaskActionResponse>;
  user?: Maybe<UserMutation>;
};

export type MutationActivityCancelSignupArgs = {
  subscription: ActivitySubscription;
};

export type MutationActivityCancelSignupScreenArgs = {
  profile: ScreenProfile;
  subscription: ActivitySubscription;
};

export type MutationActivitySignupArgs = {
  subscription: ActivitySubscription;
};

export type MutationActivitySignupScreenArgs = {
  profile: ScreenProfile;
  subscription: ActivitySubscription;
};

export type MutationApprovePlannerTaskArgs = {
  id: Scalars["ID"]["input"];
  isRepeat: Scalars["Boolean"]["input"];
};

export type MutationArchiveAddArgs = {
  resourceId: Scalars["ID"]["input"];
};

export type MutationArchiveAddScreenArgs = {
  profile: ScreenProfile;
  resourceId: Scalars["ID"]["input"];
};

export type MutationArchiveRemoveArgs = {
  resourceId: Scalars["ID"]["input"];
};

export type MutationArchiveRemoveScreenArgs = {
  profile: ScreenProfile;
  resourceId: Scalars["ID"]["input"];
};

export type MutationArchiveUploadArgs = {
  image: ImageUpload;
};

export type MutationBookingResourceBookArgs = {
  booking: BookingResourceBooking;
};

export type MutationBookingResourceBookSlotArgs = {
  bookingSlot: BookingResourceBookingSlot;
};

export type MutationBookingResourceCancelBookingArgs = {
  bookingResourceBookingId: Scalars["ID"]["input"];
};

export type MutationBookingResourceCancelBookingSlotArgs = {
  bookingSlot: BookingResourceBookingSlot;
};

export type MutationChangeDeviceSettingsArgs = {
  deviceToken: Scalars["String"]["input"];
  deviceType?: InputMaybe<Scalars["String"]["input"]>;
  model?: InputMaybe<Scalars["String"]["input"]>;
  receiveNotifications: Scalars["Boolean"]["input"];
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationChangeSettingsArgs = {
  email?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationActivity?: InputMaybe<InputNotificationSettingActivity>;
  notificationBooking?: InputMaybe<InputNotificationSettingBooking>;
  notificationGroup?: InputMaybe<InputNotificationSettingGroup>;
  notificationMeeting?: InputMaybe<InputNotificationSettingMeeting>;
  notificationPlanner?: InputMaybe<InputNotificationSettingPlanner>;
  push?: InputMaybe<Scalars["Boolean"]["input"]>;
  startScreen?: InputMaybe<Start_Screen>;
  textToSpeechFilter?: InputMaybe<InputTextToSpeechFilter>;
};

export type MutationCompletePlannerSubtaskArgs = {
  plannerSubtaskId: Scalars["ID"]["input"];
  plannerTaskId: Scalars["ID"]["input"];
};

export type MutationCompletePlannerTaskArgs = {
  plannerTaskId: Scalars["ID"]["input"];
};

export type MutationCreatePlannerTaskArgs = {
  plannerTask: PlannerTaskCreateInput;
};

export type MutationDeleteCommentArgs = {
  commentId: Scalars["ID"]["input"];
};

export type MutationDeletePlannerTaskArgs = {
  input: DeletePlannerTaskInput;
};

export type MutationDeletePostArgs = {
  postId: Scalars["ID"]["input"];
};

export type MutationDeleteUserArgs = {
  username: Scalars["String"]["input"];
};

export type MutationEditCommentArgs = {
  body: Scalars["String"]["input"];
  commentId: Scalars["ID"]["input"];
  coverImage?: InputMaybe<ImageUpload>;
};

export type MutationEditDepartmentArgs = {
  department: DepartmentInput;
};

export type MutationEditPlannerTaskArgs = {
  plannerTask: PlannerTaskEditInput;
  plannerTaskId: Scalars["ID"]["input"];
};

export type MutationEditPostArgs = {
  body: Scalars["String"]["input"];
  coverImage?: InputMaybe<ImageUpload>;
  postId: Scalars["ID"]["input"];
};

export type MutationMealCancelSignupArgs = {
  subscription: MealSubscription;
};

export type MutationMealCancelSignupScreenArgs = {
  profile: ScreenProfile;
  subscription: MealSubscription;
};

export type MutationMealSignupArgs = {
  subscription: MealSubscription;
};

export type MutationMealSignupScreenArgs = {
  profile: ScreenProfile;
  subscription: MealSubscription;
};

export type MutationMeetingCancelSignupArgs = {
  subscription: MeetingSubscription;
};

export type MutationMeetingCancelSuggestionArgs = {
  meetingSuggestionId: Scalars["ID"]["input"];
};

export type MutationMeetingSignupArgs = {
  subscription: MeetingSubscription;
};

export type MutationMeetingSuggestArgs = {
  meetingId: Scalars["ID"]["input"];
  suggestion: Scalars["String"]["input"];
};

export type MutationPostCommentArgs = {
  body: Scalars["String"]["input"];
  coverImage?: InputMaybe<ImageUpload>;
  postId: Scalars["ID"]["input"];
};

export type MutationPostPostArgs = {
  body: Scalars["String"]["input"];
  coverImage?: InputMaybe<ImageUpload>;
  groupId: Scalars["ID"]["input"];
};

export type MutationReactCommentArgs = {
  commentId: Scalars["ID"]["input"];
  type?: InputMaybe<Reaction_Type>;
};

export type MutationReactPostArgs = {
  postId: Scalars["ID"]["input"];
  type?: InputMaybe<Reaction_Type>;
};

export type MutationRejectPlannerTaskArgs = {
  id: Scalars["ID"]["input"];
  isRepeat: Scalars["Boolean"]["input"];
};

export type MutationUncompletePlannerSubtaskArgs = {
  plannerSubtaskId: Scalars["ID"]["input"];
  plannerTaskId: Scalars["ID"]["input"];
};

export type MutationUncompletePlannerTaskArgs = {
  plannerTaskId: Scalars["ID"]["input"];
};

export type MyDayCalendar = {
  __typename?: "MyDayCalendar";
  date: Scalars["Date"]["output"];
  empty?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum Notification_Source_Type {
  Group = "GROUP",
  Institution = "INSTITUTION",
}

export enum Notification_Type {
  Activity = "ACTIVITY",
  Booking = "BOOKING",
  Group = "GROUP",
  GroupPost = "GROUP_POST",
  Meeting = "MEETING",
  PlannerAssignment = "PLANNER_ASSIGNMENT",
}

export type News = Node & {
  __typename?: "News";
  body: Scalars["String"]["output"];
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  pictograms?: Maybe<Array<Pictogram>>;
  pictures?: Maybe<Array<Picture>>;
  published?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Doesnt exist */
  read: Scalars["Boolean"]["output"];
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
};

export type NewsInput = {
  category?: InputMaybe<Scalars["ID"]["input"]>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  documents?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  groups?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  pictograms?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  pictures?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  repeat?: InputMaybe<Scalars["ID"]["input"]>;
  rset?: InputMaybe<RRuleSetInput>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  updateGroupPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
  videos?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type NewsMutation = {
  __typename?: "NewsMutation";
  delete?: Maybe<DefaultResponse>;
  save?: Maybe<DefaultResponse>;
};

export type NewsMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
  type?: InputMaybe<Delete_Type>;
};

export type NewsMutationSaveArgs = {
  news: NewsInput;
};

export type NewsQuery = {
  __typename?: "NewsQuery";
  /** @deprecated use category.get instead */
  getCategories?: Maybe<Array<Category>>;
  getNews?: Maybe<Array<NewsUnion>>;
  getNewsByFilters?: Maybe<Array<NewsUnion>>;
};

export type NewsQueryGetCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  institutionId: Scalars["ID"]["input"];
};

export type NewsQueryGetNewsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type NewsQueryGetNewsByFiltersArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
  filter: Filter;
  visibility?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NewsUnion = RepeatingNews | SingleNews;

export type Node = {
  id: Scalars["ID"]["output"];
};

export type Notification = Node & {
  __typename?: "Notification";
  body?: Maybe<Scalars["String"]["output"]>;
  color?: Maybe<Scalars["String"]["output"]>;
  coverImage?: Maybe<Picture>;
  entityId?: Maybe<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  profileId?: Maybe<Scalars["ID"]["output"]>;
  profileType?: Maybe<Profile_Type>;
  read: Scalars["Boolean"]["output"];
  source?: Maybe<NotificationSource>;
  time: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: Notification_Type;
};

export type NotificationConnection = {
  __typename?: "NotificationConnection";
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type NotificationEdge = {
  __typename?: "NotificationEdge";
  cursor: Scalars["Cursor"]["output"];
  node: Notification;
};

export type NotificationMutation = {
  __typename?: "NotificationMutation";
  markAsRead?: Maybe<DefaultResponse>;
};

export type NotificationMutationMarkAsReadArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type NotificationQuery = {
  __typename?: "NotificationQuery";
  getNotifications: NotificationConnection;
};

export type NotificationQueryGetNotificationsArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  first: Scalars["Int"]["input"];
};

export type NotificationSetting = {
  __typename?: "NotificationSetting";
  activity: NotificationSettingActivity;
  booking: NotificationSettingBooking;
  email: Scalars["Boolean"]["output"];
  group: NotificationSettingGroup;
  meeting: NotificationSettingMeeting;
  planner: NotificationSettingPlanner;
  push: Scalars["Boolean"]["output"];
};

export type NotificationSettingActivity = {
  __typename?: "NotificationSettingActivity";
  cancelled: Scalars["Boolean"]["output"];
  /** @deprecated deleted trigger is no longer used */
  deleted: Scalars["Boolean"]["output"];
  reminders?: Maybe<Array<Maybe<Reminder>>>;
  timeChanged: Scalars["Boolean"]["output"];
};

export type NotificationSettingBooking = {
  __typename?: "NotificationSettingBooking";
  deleted: Scalars["Boolean"]["output"];
  reminders?: Maybe<Array<Maybe<Reminder>>>;
  timeChanged: Scalars["Boolean"]["output"];
};

export type NotificationSettingGroup = {
  __typename?: "NotificationSettingGroup";
  comments: Scalars["Boolean"]["output"];
  join: Scalars["Boolean"]["output"];
  likes: Scalars["Boolean"]["output"];
  post: Scalars["Boolean"]["output"];
};

export type NotificationSettingMeeting = {
  __typename?: "NotificationSettingMeeting";
  cancelled: Scalars["Boolean"]["output"];
  /** @deprecated deleted trigger is no longer used */
  deleted: Scalars["Boolean"]["output"];
  reminders?: Maybe<Array<Maybe<Reminder>>>;
  timeChanged: Scalars["Boolean"]["output"];
};

export type NotificationSettingPlanner = {
  __typename?: "NotificationSettingPlanner";
  assignedToMe: Scalars["Boolean"]["output"];
  assignmentChanged: Scalars["Boolean"]["output"];
  assignmentCompleted: Scalars["Boolean"]["output"];
  assignmentOverdue: Scalars["Boolean"]["output"];
  reminders?: Maybe<Array<Maybe<Reminder>>>;
};

export type NotificationSettings = {
  __typename?: "NotificationSettings";
  reminderFirst?: Maybe<Scalars["Int"]["output"]>;
  reminderSecond?: Maybe<Scalars["Int"]["output"]>;
  status: Scalars["Boolean"]["output"];
  triggerWhenCancelled: Scalars["Boolean"]["output"];
  triggerWhenTimeChange: Scalars["Boolean"]["output"];
};

export type NotificationSettingsInput = {
  entityId?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  reminderFirst?: InputMaybe<Scalars["Int"]["input"]>;
  reminderSecond?: InputMaybe<Scalars["Int"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenCancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenTimeChange?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type NotificationSource = {
  __typename?: "NotificationSource";
  color?: Maybe<Scalars["Color"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  type?: Maybe<Notification_Source_Type>;
};

export type NotificationsReadConnection = {
  __typename?: "NotificationsReadConnection";
  edges: Array<NotificationEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type NotificationsUnreadCount = {
  __typename?: "NotificationsUnreadCount";
  count: Scalars["Int"]["output"];
};

export enum Pictogram_Type {
  Icon = "ICON",
  Image = "IMAGE",
}

export enum Plannertask_Assignee_Type {
  Department = "DEPARTMENT",
  Employee = "EMPLOYEE",
  Resident = "RESIDENT",
}

export enum Planner_Notification_Type {
  Employee = "EMPLOYEE",
  Resident = "RESIDENT",
}

export enum Planner_Task_Delete_Type {
  OnlyInstance = "ONLY_INSTANCE",
  Series = "SERIES",
}

export enum Profile_Notification_Status {
  Active = "ACTIVE",
  Disabled = "DISABLED",
  Fallback = "FALLBACK",
}

export enum Profile_Type {
  Department = "DEPARTMENT",
  Employee = "EMPLOYEE",
  Guest = "GUEST",
  Relative = "RELATIVE",
  Resident = "RESIDENT",
}

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["Cursor"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor?: Maybe<Scalars["Cursor"]["output"]>;
};

export type PagedEntity =
  | BookingResource
  | BookingSlot
  | Employee
  | Gallery
  | Meal
  | MealDish
  | MeetingAgendaPointTemplate
  | News
  | Relative
  | RepeatingActivity
  | RepeatingMeal
  | RepeatingMeeting
  | RepeatingNews
  | Resident
  | SingleActivity
  | SingleMeal
  | SingleMeeting
  | SingleNews;

export type PcdMeal = {
  __typename?: "PcdMeal";
  courses: Array<PcdMealCourse>;
  date: Scalars["Date"]["output"];
};

export type PcdMealCourse = {
  __typename?: "PcdMealCourse";
  category: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type Pictogram = Node & {
  __typename?: "Pictogram";
  blurhash?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  source: Scalars["String"]["output"];
  type?: Maybe<Pictogram_Type>;
};

export type PictogramInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Picture = Node & {
  __typename?: "Picture";
  blurhash?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  inMyArchive?: Maybe<Scalars["Boolean"]["output"]>;
  source: Scalars["String"]["output"];
};

export type PlannerCategory = Node & {
  __typename?: "PlannerCategory";
  color: Scalars["Color"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type PlannerCategoryInput = {
  color?: InputMaybe<Scalars["Color"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlannerFilter = {
  __typename?: "PlannerFilter";
  assigneeTypes?: Maybe<Array<Plannertask_Assignee_Type>>;
  categories?: Maybe<Array<Scalars["ID"]["output"]>>;
  departments?: Maybe<Array<Scalars["ID"]["output"]>>;
  employees?: Maybe<Array<Scalars["ID"]["output"]>>;
  id?: Maybe<Scalars["ID"]["output"]>;
  residents?: Maybe<Array<Scalars["ID"]["output"]>>;
  title?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<User>;
};

export type PlannerFilterInput = {
  assigneeTypes?: InputMaybe<Array<Plannertask_Assignee_Type>>;
  categories?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  employees?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  residents?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PlannerMutation = {
  __typename?: "PlannerMutation";
  deleteFilter?: Maybe<DefaultResponse>;
  deleteTemplate?: Maybe<DefaultResponse>;
  saveCategory?: Maybe<DefaultResponse>;
  saveFilter?: Maybe<DefaultResponse>;
  saveTemplate?: Maybe<DefaultResponse>;
};

export type PlannerMutationDeleteFilterArgs = {
  id: Scalars["ID"]["input"];
};

export type PlannerMutationDeleteTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type PlannerMutationSaveCategoryArgs = {
  category: PlannerCategoryInput;
};

export type PlannerMutationSaveFilterArgs = {
  filter: PlannerFilterInput;
};

export type PlannerMutationSaveTemplateArgs = {
  template: PlannerTemplateInput;
};

export type PlannerNotificationSettingNotifications = {
  plannerFirst?: InputMaybe<Scalars["Int"]["input"]>;
  plannerFourth?: InputMaybe<Scalars["Int"]["input"]>;
  plannerSecond?: InputMaybe<Scalars["Int"]["input"]>;
  plannerThird?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PlannerNotificationSettingTriggers = {
  change: Scalars["Boolean"]["input"];
  complete: Scalars["Boolean"]["input"];
  create: Scalars["Boolean"]["input"];
  overdue: Scalars["Boolean"]["input"];
};

export type PlannerNotificationSettingsInput = {
  notificationType: Planner_Notification_Type;
  notifications: PlannerNotificationSettingNotifications;
  state: Scalars["String"]["input"];
  triggers: PlannerNotificationSettingTriggers;
};

export type PlannerQuery = {
  __typename?: "PlannerQuery";
  getCategories?: Maybe<Array<PlannerCategory>>;
  getFilters?: Maybe<Array<PlannerFilter>>;
  getTasksByFilters?: Maybe<Array<PlannerTask>>;
};

export type PlannerQueryGetTasksByFiltersArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
};

export type PlannerSubtask = Node & {
  __typename?: "PlannerSubtask";
  completed: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  pictogram?: Maybe<Pictogram>;
  picture?: Maybe<Picture>;
  sortOrder?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
};

export type PlannerSubtaskInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<ImageUpload>;
  pictogramId?: InputMaybe<Scalars["ID"]["input"]>;
  sortOrder?: InputMaybe<Scalars["Int"]["input"]>;
  template?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
};

export type PlannerTask = RepeatingPlannerTask | SinglePlannerTask;

export type PlannerTaskActionResponse = {
  __typename?: "PlannerTaskActionResponse";
  entity?: Maybe<PlannerTask>;
  id?: Maybe<Scalars["ID"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type PlannerTaskAssignee = Department | Employee | Resident;

export type PlannerTaskAssigneeInput = {
  id: Scalars["ID"]["input"];
  type: Plannertask_Assignee_Type;
};

export type PlannerTaskCreateInput = {
  approvalState?: InputMaybe<Approval_State>;
  assignees?: InputMaybe<Array<PlannerTaskAssigneeInput>>;
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end: Scalars["DateTime"]["input"];
  image?: InputMaybe<ImageUpload>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationSettings?: InputMaybe<Array<PlannerNotificationSettingsInput>>;
  pictogramId?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Use approvalState instead */
  private?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Use rset instead */
  rrule?: InputMaybe<Scalars["String"]["input"]>;
  rset?: InputMaybe<RRuleSetInput>;
  start: Scalars["DateTime"]["input"];
  subtasks?: InputMaybe<Array<PlannerSubtaskInput>>;
  title: Scalars["String"]["input"];
  visibleForResident?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PlannerTaskEditInput = {
  approvalState?: InputMaybe<Approval_State>;
  assignees?: InputMaybe<Array<PlannerTaskAssigneeInput>>;
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  end?: InputMaybe<Scalars["DateTime"]["input"]>;
  image?: InputMaybe<ImageUpload>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  notificationSettings?: InputMaybe<Array<PlannerNotificationSettingsInput>>;
  pictogramId?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Use approvalState instead */
  private?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Use rset instead */
  rrule?: InputMaybe<Scalars["String"]["input"]>;
  rset?: InputMaybe<RRuleSetInput>;
  start?: InputMaybe<Scalars["DateTime"]["input"]>;
  subtasks?: InputMaybe<Array<PlannerSubtaskInput>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  visibleForResident?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PlannerTemplate = {
  __typename?: "PlannerTemplate";
  category?: Maybe<PlannerCategory>;
  /** @deprecated Doesnt exist */
  description?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  pictogram?: Maybe<Pictogram>;
  private: Scalars["Boolean"]["output"];
  repeat?: Maybe<RepeatRule>;
  start?: Maybe<Scalars["Time"]["output"]>;
  subtasks?: Maybe<Array<PlannerTemplateSubtask>>;
  title: Scalars["String"]["output"];
};

export type PlannerTemplateInput = {
  category?: InputMaybe<Scalars["ID"]["input"]>;
  duration?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  pictogram?: InputMaybe<Scalars["ID"]["input"]>;
  rset?: InputMaybe<RRuleSetInput>;
  start?: InputMaybe<Scalars["Time"]["input"]>;
  subtasks?: InputMaybe<Array<PlannerSubtaskInput>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PlannerTemplateSubtask = {
  __typename?: "PlannerTemplateSubtask";
  pictogram?: Maybe<Pictogram>;
  picture?: Maybe<Picture>;
  title: Scalars["String"]["output"];
};

export type Profile = Employee | Relative | Resident;

export type ProfileAppSettings = {
  __typename?: "ProfileAppSettings";
  startScreen: Start_Screen;
  tts: TextToSpeechFilter;
};

export type ProfileAppSettingsInput = {
  startScreen?: InputMaybe<Start_Screen>;
  tts?: InputMaybe<InputTextToSpeechFilter>;
};

export type ProfileFavoriteCategories = {
  __typename?: "ProfileFavoriteCategories";
  entityType: Category_Type;
  ids: Array<Scalars["ID"]["output"]>;
};

export type ProfileFavoriteCategoriesInput = {
  entityType: Category_Type;
  ids: Array<Scalars["ID"]["input"]>;
};

export type ProfileFavorites = {
  __typename?: "ProfileFavorites";
  categories?: Maybe<Array<Maybe<ProfileFavoriteCategories>>>;
};

export type ProfileFavoritesInput = {
  categories?: InputMaybe<Array<InputMaybe<ProfileFavoriteCategoriesInput>>>;
};

export type ProfileGroupPermission = {
  __typename?: "ProfileGroupPermission";
  allowComment: Scalars["Boolean"]["output"];
  allowLike: Scalars["Boolean"]["output"];
  allowPost: Scalars["Boolean"]["output"];
  groupId: Scalars["String"]["output"];
};

export type ProfileGroupSettings = {
  __typename?: "ProfileGroupSettings";
  permissions?: Maybe<Array<ProfileGroupPermission>>;
};

export type ProfileInput = {
  id: Scalars["ID"]["input"];
  type: Profile_Type;
};

export type ProfileMyDaySettings = {
  __typename?: "ProfileMyDaySettings";
  daysForward?: Maybe<Scalars["Int"]["output"]>;
  timeTimer?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ProfileMyDaySettingsInput = {
  daysForward?: InputMaybe<Scalars["Int"]["input"]>;
  timeTimer?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileNotificationSettings = {
  __typename?: "ProfileNotificationSettings";
  activity?: Maybe<ProfileNotificationSettingsEntity>;
  booking?: Maybe<ProfileNotificationSettingsEntity>;
  general?: Maybe<ProfileNotificationSettingsGeneral>;
  group?: Maybe<ProfileNotificationSettingsGroup>;
  meeting?: Maybe<ProfileNotificationSettingsEntity>;
  planner?: Maybe<ProfileNotificationSettingsPlanner>;
};

export type ProfileNotificationSettingsEntity = {
  __typename?: "ProfileNotificationSettingsEntity";
  triggerWhenCancelled: Scalars["Boolean"]["output"];
  triggerWhenTimeChange: Scalars["Boolean"]["output"];
};

export type ProfileNotificationSettingsEntityInput = {
  triggerWhenCancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenTimeChange?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileNotificationSettingsGeneral = {
  __typename?: "ProfileNotificationSettingsGeneral";
  allowEdit: Scalars["Boolean"]["output"];
  email: Scalars["Boolean"]["output"];
  push: Scalars["Boolean"]["output"];
  status: Profile_Notification_Status;
};

export type ProfileNotificationSettingsGeneralInput = {
  allowEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
  email?: InputMaybe<Scalars["Boolean"]["input"]>;
  push?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Profile_Notification_Status>;
};

export type ProfileNotificationSettingsGroup = {
  __typename?: "ProfileNotificationSettingsGroup";
  triggerWhenBecomeMember: Scalars["Boolean"]["output"];
  triggerWhenCommentsOnOwnPost: Scalars["Boolean"]["output"];
  triggerWhenLikesOnOwnPostsAndComments: Scalars["Boolean"]["output"];
  triggerWhenOtherMemberPosts: Scalars["Boolean"]["output"];
};

export type ProfileNotificationSettingsGroupInput = {
  triggerWhenBecomeMember?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenCommentsOnOwnPost?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenLikesOnOwnPostsAndComments?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  triggerWhenOtherMemberPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfileNotificationSettingsInput = {
  activity?: InputMaybe<ProfileNotificationSettingsEntityInput>;
  booking?: InputMaybe<ProfileNotificationSettingsEntityInput>;
  general?: InputMaybe<ProfileNotificationSettingsGeneralInput>;
  group?: InputMaybe<ProfileNotificationSettingsGroupInput>;
  meeting?: InputMaybe<ProfileNotificationSettingsEntityInput>;
  planner?: InputMaybe<ProfileNotificationSettingsPlannerInput>;
};

export type ProfileNotificationSettingsPlanner = {
  __typename?: "ProfileNotificationSettingsPlanner";
  reminderFirst?: Maybe<Scalars["Int"]["output"]>;
  reminderFourth?: Maybe<Scalars["Int"]["output"]>;
  reminderSecond?: Maybe<Scalars["Int"]["output"]>;
  reminderThird?: Maybe<Scalars["Int"]["output"]>;
  triggerWhenAssignmentChange: Scalars["Boolean"]["output"];
  triggerWhenAssignmentComplete: Scalars["Boolean"]["output"];
  triggerWhenAssignmentOverdue: Scalars["Boolean"]["output"];
  triggerWhenNewAssignment: Scalars["Boolean"]["output"];
};

export type ProfileNotificationSettingsPlannerInput = {
  reminderFirst?: InputMaybe<Scalars["Int"]["input"]>;
  reminderFourth?: InputMaybe<Scalars["Int"]["input"]>;
  reminderSecond?: InputMaybe<Scalars["Int"]["input"]>;
  reminderThird?: InputMaybe<Scalars["Int"]["input"]>;
  triggerWhenAssignmentChange?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenAssignmentComplete?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenAssignmentOverdue?: InputMaybe<Scalars["Boolean"]["input"]>;
  triggerWhenNewAssignment?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfilePlannerAssignmentSettings = {
  __typename?: "ProfilePlannerAssignmentSettings";
  create: Scalars["Boolean"]["output"];
  edit: Scalars["Boolean"]["output"];
  inbox: Scalars["Boolean"]["output"];
  showAfterCompleted: Scalars["Boolean"]["output"];
  showDescription: Scalars["Boolean"]["output"];
  showOverdue: Scalars["Boolean"]["output"];
  showTime: Scalars["Boolean"]["output"];
  tts: Scalars["Boolean"]["output"];
};

export type ProfilePlannerAssignmentSettingsInput = {
  create?: InputMaybe<Scalars["Boolean"]["input"]>;
  edit?: InputMaybe<Scalars["Boolean"]["input"]>;
  inbox?: InputMaybe<Scalars["Boolean"]["input"]>;
  showAfterCompleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  showDescription?: InputMaybe<Scalars["Boolean"]["input"]>;
  showOverdue?: InputMaybe<Scalars["Boolean"]["input"]>;
  showTime?: InputMaybe<Scalars["Boolean"]["input"]>;
  tts?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfilePlannerSettings = {
  __typename?: "ProfilePlannerSettings";
  assignment?: Maybe<ProfilePlannerAssignmentSettings>;
};

export type ProfilePlannerSettingsInput = {
  assignment?: InputMaybe<ProfilePlannerAssignmentSettingsInput>;
};

export type ProfileSettings = {
  __typename?: "ProfileSettings";
  app?: Maybe<ProfileAppSettings>;
  favorites?: Maybe<ProfileFavorites>;
  groups?: Maybe<ProfileGroupSettings>;
  myDay?: Maybe<ProfileMyDaySettings>;
  notifications?: Maybe<ProfileNotificationSettings>;
  planner?: Maybe<ProfilePlannerSettings>;
  videoCall?: Maybe<ProfileVideoCallSettings>;
  vismaGatId?: Maybe<Scalars["ID"]["output"]>;
  vivendiId?: Maybe<Scalars["ID"]["output"]>;
};

export type ProfileSettingsInput = {
  app?: InputMaybe<ProfileAppSettingsInput>;
  favorites?: InputMaybe<ProfileFavoritesInput>;
  myDay?: InputMaybe<ProfileMyDaySettingsInput>;
  notifications?: InputMaybe<ProfileNotificationSettingsInput>;
  planner?: InputMaybe<ProfilePlannerSettingsInput>;
  videoCall?: InputMaybe<ProfileVideoCallSettingsInput>;
  vismaGatId?: InputMaybe<Scalars["ID"]["input"]>;
  vivendiId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ProfileStats = {
  __typename?: "ProfileStats";
  numActivitiesParticipating?: Maybe<Scalars["Int"]["output"]>;
  numActivitiesResponsible?: Maybe<Scalars["Int"]["output"]>;
  numBookings?: Maybe<Scalars["Int"]["output"]>;
  numMeals?: Maybe<Scalars["Int"]["output"]>;
  numWorkSchedules?: Maybe<Scalars["Int"]["output"]>;
};

export type ProfileVideoCallSettings = {
  __typename?: "ProfileVideoCallSettings";
  allowCallAll: Scalars["Boolean"]["output"];
  enabled: Scalars["Boolean"]["output"];
  status: Video_Call_Status;
};

export type ProfileVideoCallSettingsInput = {
  allowCallAll?: InputMaybe<Scalars["Boolean"]["input"]>;
  enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<Video_Call_Status>;
};

export type Query = {
  __typename?: "Query";
  /** @deprecated Use activity {getActivitiesByFilters} instead */
  activities?: Maybe<Array<Activity>>;
  activity?: Maybe<ActivityQuery>;
  activityCalendar?: Maybe<Array<ActivityCalendar>>;
  /** @deprecated Use activity {getActivities} instead */
  activityEntry?: Maybe<Activity>;
  /** @deprecated Use activity {getActivitiesByFilters} instead */
  activityRange?: Maybe<Array<Activity>>;
  appConnectionsScreen?: Maybe<Array<App>>;
  archive?: Maybe<ArchiveQuery>;
  auditLog?: Maybe<AuditLogQuery>;
  bookingResourceBookingsRange?: Maybe<Array<BookingSlot>>;
  bookingResourceCalendar?: Maybe<Array<BookingResourceCalendar>>;
  bookingResourceEntry?: Maybe<BookingResource>;
  bookingResources?: Maybe<Array<BookingResource>>;
  bookingSlotEntry?: Maybe<BookingSlot>;
  bookingSlots?: Maybe<Array<BookingSlot>>;
  category?: Maybe<CategoryQuery>;
  /** @deprecated Use user.getContacts instead */
  contacts?: Maybe<Array<Maybe<User>>>;
  coreNews?: Maybe<CoreNewsQuery>;
  department?: Maybe<Department>;
  departmentWeather?: Maybe<Scalars["String"]["output"]>;
  externalServices?: Maybe<ExternalServicesQuery>;
  galleries?: Maybe<Array<Gallery>>;
  galleriesExport: Scalars["String"]["output"];
  galleryEntry: Gallery;
  groupEntry?: Maybe<Group>;
  groupPostEntry?: Maybe<GroupPost>;
  /** @deprecated Use institutions.getMyInstitution instead */
  institution: Institution;
  institutions?: Maybe<InstitutionQuery>;
  meal?: Maybe<MealQuery>;
  mealCalendar?: Maybe<Array<MealCalendar>>;
  mealEntry?: Maybe<Meal>;
  mealRange?: Maybe<Array<Meal>>;
  meals?: Maybe<Array<Meal>>;
  meetingCalendar?: Maybe<Array<MeetingCalendar>>;
  meetingEntry?: Maybe<Meeting>;
  meetingRange?: Maybe<Array<Meeting>>;
  meetings?: Maybe<Array<Meeting>>;
  myArchive: Archive;
  myArchiveScreen: Archive;
  myBookings?: Maybe<Array<BookingSlot>>;
  myDay?: Maybe<Array<EventEntity>>;
  myDayCalendar: Array<MyDayCalendar>;
  /** @deprecated Use self {groups} instead */
  myGroups?: Maybe<Array<Group>>;
  myGroupsFeed: GroupFeedConnection;
  myProfiles?: Maybe<Array<Profile>>;
  /** @deprecated Use newsItem {getNewsByFilters} instead */
  news?: Maybe<Array<News>>;
  /** @deprecated Use newsItem {getNews} instead */
  newsEntry?: Maybe<News>;
  newsItem?: Maybe<NewsQuery>;
  node?: Maybe<Node>;
  notification?: Maybe<NotificationQuery>;
  notificationEntry?: Maybe<Notification>;
  /** @deprecated Use notification {getNotifications} instead */
  notificationsRead: NotificationsReadConnection;
  /** @deprecated Use notification {getNotifications} instead */
  notificationsUnread: Array<Notification>;
  notificationsUnreadCount: NotificationsUnreadCount;
  pcdMeals?: Maybe<Array<PcdMeal>>;
  pictograms?: Maybe<Array<Pictogram>>;
  planner?: Maybe<PlannerQuery>;
  /** @deprecated use planner {getCategories instead} */
  plannerCategories?: Maybe<Array<PlannerCategory>>;
  plannerTaskEntry?: Maybe<PlannerTask>;
  plannerTasksAwaitingApproval: Array<PlannerTask>;
  plannerTemplates?: Maybe<Array<PlannerTemplate>>;
  profileEntry?: Maybe<Profile>;
  profiles?: Maybe<Array<Profile>>;
  receiveNotificationsDevice?: Maybe<ReceiveNotificationsDevice>;
  repeat?: Maybe<RepeatQuery>;
  schedule?: Maybe<ScheduleQuery>;
  scheduleAvailableEmployees?: Maybe<Array<ScheduleAvailableEmployee>>;
  scheduleCalendar?: Maybe<Array<ScheduleCalendar>>;
  /** @deprecated Use schedule {shifts} instead */
  scheduleShifts?: Maybe<Array<ScheduleShift>>;
  self?: Maybe<SelfQuery>;
  settings?: Maybe<Settings>;
  tts: TextToSpeech;
  user?: Maybe<UserQuery>;
  whatsHappening?: Maybe<Array<EventEntity>>;
  whatsHappeningCalendar: Array<WhatsHappeningCalendar>;
};

export type QueryActivitiesArgs = {
  date: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryActivityCalendarArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryActivityEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryActivityRangeArgs = {
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryBookingResourceBookingsRangeArgs = {
  bookingResourceId: Scalars["ID"]["input"];
  from: Scalars["DateTime"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type QueryBookingResourceCalendarArgs = {
  bookFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  bookTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  bookingResourceId: Scalars["ID"]["input"];
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryBookingResourceEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryBookingResourcesArgs = {
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryBookingSlotEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryBookingSlotsArgs = {
  bookingResourceId: Scalars["ID"]["input"];
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryDepartmentArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDepartmentWeatherArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGalleriesArgs = {
  filter: Filter;
};

export type QueryGalleriesExportArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryGalleryEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGroupEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGroupPostEntryArgs = {
  groupPostId: Scalars["ID"]["input"];
};

export type QueryMealCalendarArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMealEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMealRangeArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMealsArgs = {
  date: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMeetingCalendarArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMeetingEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryMeetingRangeArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMeetingsArgs = {
  date: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMyArchiveScreenArgs = {
  profile: ScreenProfile;
};

export type QueryMyBookingsArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMyDayArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMyDayCalendarArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryMyGroupsFeedArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  first: Scalars["Int"]["input"];
};

export type QueryNewsArgs = {
  filter: Filter;
};

export type QueryNewsEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryNodeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryNotificationEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryNotificationsReadArgs = {
  after?: InputMaybe<Scalars["Cursor"]["input"]>;
  first: Scalars["Int"]["input"];
};

export type QueryPcdMealsArgs = {
  date?: InputMaybe<Scalars["Date"]["input"]>;
};

export type QueryPlannerTaskEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryProfileEntryArgs = {
  profileId: Scalars["ID"]["input"];
  profileType: Profile_Type;
};

export type QueryProfilesArgs = {
  filter: Filter;
};

export type QueryReceiveNotificationsDeviceArgs = {
  deviceToken: Scalars["String"]["input"];
};

export type QueryScheduleAvailableEmployeesArgs = {
  filter?: InputMaybe<Filter>;
  from: Scalars["DateTime"]["input"];
  to: Scalars["DateTime"]["input"];
};

export type QueryScheduleCalendarArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryScheduleShiftsArgs = {
  date: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryTtsArgs = {
  speakingRate?: InputMaybe<Speaking_Rate>;
  text: Scalars["String"]["input"];
};

export type QueryWhatsHappeningArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type QueryWhatsHappeningCalendarArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export enum Reaction_Type {
  Happy = "HAPPY",
  Heart = "HEART",
  Laugh = "LAUGH",
  Like = "LIKE",
  Sad = "SAD",
}

export enum Rrule_Day {
  Fr = "FR",
  Mo = "MO",
  Sa = "SA",
  Su = "SU",
  Th = "TH",
  Tu = "TU",
  We = "WE",
}

export enum Rrule_Frequency {
  Daily = "DAILY",
  Hourly = "HOURLY",
  Minutely = "MINUTELY",
  Monthly = "MONTHLY",
  Secondly = "SECONDLY",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
}

export enum Rrule_Month {
  April = "APRIL",
  August = "AUGUST",
  December = "DECEMBER",
  February = "FEBRUARY",
  January = "JANUARY",
  July = "JULY",
  June = "JUNE",
  March = "MARCH",
  May = "MAY",
  November = "NOVEMBER",
  October = "OCTOBER",
  September = "SEPTEMBER",
}

export type RRule = {
  __typename?: "RRule";
  BYDAY?: Maybe<Array<RRuleByDay>>;
  BYHOUR?: Maybe<Array<Scalars["Int"]["output"]>>;
  BYMINUTE?: Maybe<Array<Scalars["Int"]["output"]>>;
  BYMONTH?: Maybe<Array<Rrule_Month>>;
  BYMONTHDAY?: Maybe<Array<Scalars["Int"]["output"]>>;
  BYSECOND?: Maybe<Array<Scalars["Int"]["output"]>>;
  BYSETPOS?: Maybe<Array<Scalars["Int"]["output"]>>;
  BYWEEKNO?: Maybe<Array<Scalars["Int"]["output"]>>;
  BYYEARDAY?: Maybe<Array<Scalars["Int"]["output"]>>;
  COUNT?: Maybe<Scalars["Int"]["output"]>;
  DTSTART?: Maybe<Scalars["DateTime"]["output"]>;
  FREQ?: Maybe<Rrule_Frequency>;
  INTERVAL?: Maybe<Scalars["Int"]["output"]>;
  UNTIL?: Maybe<Scalars["DateTime"]["output"]>;
  WKST?: Maybe<Rrule_Day>;
};

export type RRuleByDay = {
  __typename?: "RRuleByDay";
  day: Rrule_Day;
  occurrence?: Maybe<Scalars["Int"]["output"]>;
};

export type RRuleByDayInput = {
  /** The day(s) of the week to apply the recurrence to from the following: MO, TU, WE, TH, FR, SA, SU. */
  day: Rrule_Day;
  /** For example: 1MO (the first Monday of the interval), 3MO (the third Monday), -1MO (the last Monday), and so on. */
  occurrence?: InputMaybe<Scalars["Int"]["input"]>;
};

/** https://github.com/rlanvin/php-rrule/wiki/RRule */
export type RRuleInput = {
  /** The day(s) of the week to apply the recurrence to */
  BYDAY?: InputMaybe<Array<RRuleByDayInput>>;
  /**  The hour(s) to apply the recurrence to, from 0 to 23. */
  BYHOUR?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** The minute(s) to apply the recurrence to, from 0 to 59.  */
  BYMINUTE?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** The month(s) to apply the recurrence to, from 1 (January) to 12 (December). */
  BYMONTH?: InputMaybe<Array<Rrule_Month>>;
  /** The day(s) of the month to apply the recurrence to, from 1 to 31 or -31 to -1. Negative values mean that the count starts from the end of the month, so -1 means "the last day the month".  */
  BYMONTHDAY?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** The second(s) to apply the recurrence to, from 0 to 60. Warning: leap second (i.e. second 60) support is not fully tested. */
  BYSECOND?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** The Nth occurrence(s) within the valid occurrences inside a frequency period.  Negative values mean that the count starts from the set. For example, a bysetpos of -1 if combined with a MONTHLY frequency, and a byweekday of 'MO,TU,WE,TH FR', will result in the last work day of every month. */
  BYSETPOS?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /**
   * The week number(s) to apply the recurrence to, from 1 to 53 or -53 to -1.
   * Negative values mean that the counting start from the end of the year, so -1 means "the last week of the year".
   * Week numbers have the meaning described in ISO8601, that is, the first week of the year is that containing at least four days of the new year.
   * Week numbers are affected by the WKST setting.
   * Warning: negative week numbers are not fully tested yet.
   */
  BYWEEKNO?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** The day(s) of the year to apply the recurrence to, from 1 to 366 or -366 to -1. Negative values mean that the count starts from the end of the year, so -1 means "the last day of the year". */
  BYYEARDAY?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  /** How many occurrences will be generated. */
  COUNT?: InputMaybe<Scalars["Int"]["input"]>;
  /** The recurrence start date and time. Unlike documented in the RFC, this is not necessarily the first recurrence instance, unless it does fit in the specified rule. */
  DTSTART?: InputMaybe<Scalars["DateTime"]["input"]>;
  FREQ?: InputMaybe<Rrule_Frequency>;
  /** The interval between each FREQUENCY iteration. For example, when using YEARLY, an interval of 2 means once every two years, but with HOURLY, it means once every two hours. Default is 1. */
  INTERVAL?: InputMaybe<Scalars["Int"]["input"]>;
  /** The limit of the recurrence. Accepts the same formats as DTSTART. If a recurrence instance happens to be the same the date given, this will be the last occurrence. */
  UNTIL?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** The week start day. Must be one of the following strings MO, TU, WE, TH, FR, SA, SU. This will affect recurrences based on weekly periods. Default is MO (Monday). */
  WKST?: InputMaybe<Rrule_Day>;
};

export type RRuleSet = {
  __typename?: "RRuleSet";
  excludedDates?: Maybe<Array<Scalars["DateTime"]["output"]>>;
  exrule?: Maybe<RRule>;
  rule: RRule;
};

export type RRuleSetInput = {
  excludedDates?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
  exrule?: InputMaybe<RRuleInput>;
  rule: RRuleInput;
};

export type Reaction = {
  __typename?: "Reaction";
  author?: Maybe<Profile>;
  type: Reaction_Type;
};

export type ReceiveNotificationsDevice = {
  __typename?: "ReceiveNotificationsDevice";
  receiveNotifications: Scalars["Boolean"]["output"];
};

export type Relative = {
  __typename?: "Relative";
  alias?: Maybe<Scalars["String"]["output"]>;
  commentEmployee?: Maybe<Scalars["String"]["output"]>;
  commentRelative?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use image instead */
  displayImage: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  hasAccess: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mobile?: Maybe<Scalars["String"]["output"]>;
  relationTo?: Maybe<Scalars["String"]["output"]>;
  relationType?: Maybe<Scalars["String"]["output"]>;
  residents?: Maybe<Array<Maybe<Resident>>>;
  settings?: Maybe<ProfileSettings>;
  showImage?: Maybe<Scalars["Boolean"]["output"]>;
  status?: Maybe<Scalars["Boolean"]["output"]>;
  type: Profile_Type;
};

export type RelativeInput = {
  alias?: InputMaybe<Scalars["String"]["input"]>;
  commentEmployee?: InputMaybe<Scalars["String"]["input"]>;
  commentRelative?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  lastname?: InputMaybe<Scalars["String"]["input"]>;
  mobile?: InputMaybe<Scalars["String"]["input"]>;
  relationTo?: InputMaybe<Scalars["String"]["input"]>;
  relationType?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Reminder = {
  __typename?: "Reminder";
  minutes: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type RepeatQuery = {
  __typename?: "RepeatQuery";
  getOccurrences?: Maybe<Array<Scalars["DateTime"]["output"]>>;
};

export type RepeatQueryGetOccurrencesArgs = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  rset: RRuleSetInput;
};

export type RepeatRule = {
  __typename?: "RepeatRule";
  /** @deprecated Not used */
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  rrule: Scalars["String"]["output"];
  /** Human-readable description of repeat rule, translated to institution's locale */
  rruleText: Scalars["String"]["output"];
  rset: RRuleSet;
};

export type RepeatingActivity = Node & {
  __typename?: "RepeatingActivity";
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  /** @deprecated Use category instead */
  club?: Maybe<Club>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  location?: Maybe<Scalars["String"]["output"]>;
  maxSignups?: Maybe<Scalars["Int"]["output"]>;
  notificationSettings?: Maybe<NotificationSettings>;
  notifyNokOnSignup: Scalars["Boolean"]["output"];
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  pictograms?: Maybe<Array<Pictogram>>;
  pictures?: Maybe<Array<Picture>>;
  price?: Maybe<Array<EventPrice>>;
  /** @deprecated Doesnt exist */
  read: Scalars["Boolean"]["output"];
  repeat: RepeatRule;
  responsible?: Maybe<Array<Profile>>;
  showDateEnd?: Maybe<Scalars["DateTime"]["output"]>;
  showDateStart?: Maybe<Scalars["DateTime"]["output"]>;
  showFrom?: Maybe<Scalars["Int"]["output"]>;
  signupClose?: Maybe<Scalars["Int"]["output"]>;
  signupEnabled: Scalars["Boolean"]["output"];
  signupEnd?: Maybe<Scalars["DateTime"]["output"]>;
  signupPossible: Scalars["Boolean"]["output"];
  signupStart?: Maybe<Scalars["DateTime"]["output"]>;
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type RepeatingMeal = Node & {
  __typename?: "RepeatingMeal";
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  dishes?: Maybe<Array<MealDish>>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use pictures instead */
  image?: Maybe<Picture>;
  institution: Institution;
  maxSignups?: Maybe<Scalars["Int"]["output"]>;
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  pictures?: Maybe<Array<Picture>>;
  repeat: RepeatRule;
  responsible?: Maybe<Array<Profile>>;
  signupClose: Scalars["Int"]["output"];
  signupEnabled: Scalars["Boolean"]["output"];
  signupEnd?: Maybe<Scalars["DateTime"]["output"]>;
  signupPossible: Scalars["Boolean"]["output"];
  signupStart?: Maybe<Scalars["DateTime"]["output"]>;
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type RepeatingMeeting = Node & {
  __typename?: "RepeatingMeeting";
  agendaPoints?: Maybe<Array<MeetingAgendaPoint>>;
  cancelled: Scalars["Boolean"]["output"];
  /** @deprecated Use meetingCategory instead */
  category?: Maybe<Scalars["String"]["output"]>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Doesn't exist */
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  /** @deprecated Doesn't exist */
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  institution: Institution;
  location?: Maybe<Scalars["String"]["output"]>;
  meetingCategory?: Maybe<Category>;
  notificationSettings?: Maybe<NotificationSettings>;
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  /** @deprecated Doesn't exist */
  pictograms?: Maybe<Array<Pictogram>>;
  /** @deprecated Doesn't exist */
  pictures?: Maybe<Array<Picture>>;
  repeat: RepeatRule;
  signupEnabled: Scalars["Boolean"]["output"];
  signupPossible: Scalars["Boolean"]["output"];
  startDate: Scalars["DateTime"]["output"];
  suggestions?: Maybe<Array<MeetingSuggestion>>;
  title: Scalars["String"]["output"];
  /** @deprecated Doesn't exist */
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type RepeatingMeetingSuggestionsArgs = {
  includeDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RepeatingNews = Node & {
  __typename?: "RepeatingNews";
  body: Scalars["String"]["output"];
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  pictograms?: Maybe<Array<Pictogram>>;
  pictures?: Maybe<Array<Picture>>;
  published?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Doesnt exist */
  read: Scalars["Boolean"]["output"];
  repeat: RepeatRule;
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
};

export type RepeatingPlannerTask = Node & {
  __typename?: "RepeatingPlannerTask";
  approvalState: Approval_State;
  assignees: Array<PlannerTaskAssignee>;
  category?: Maybe<PlannerCategory>;
  completed: Scalars["Boolean"]["output"];
  /** @deprecated Use assignees instead */
  department?: Maybe<Department>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use assignees instead */
  employee?: Maybe<Employee>;
  endDate: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  institution: Institution;
  pictogram?: Maybe<Pictogram>;
  picture?: Maybe<Picture>;
  private: Scalars["Boolean"]["output"];
  repeat: RepeatRule;
  repeatId: Scalars["ID"]["output"];
  /** @deprecated Use assignees instead */
  resident?: Maybe<Resident>;
  startDate: Scalars["DateTime"]["output"];
  subtasks?: Maybe<Array<PlannerSubtask>>;
  title: Scalars["String"]["output"];
  visibleForResident?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Resident = Node & {
  __typename?: "Resident";
  alias?: Maybe<Scalars["String"]["output"]>;
  birthday?: Maybe<Scalars["Date"]["output"]>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use image instead */
  displayImage: Scalars["String"]["output"];
  displayName: Scalars["String"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  hasAccess: Scalars["Boolean"]["output"];
  hasConnect: Scalars["Boolean"]["output"];
  homeDays?: Maybe<Array<Maybe<Day_Of_Week>>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  invitationStatus?: Maybe<Invitation_Status>;
  isFavorite?: Maybe<Scalars["Boolean"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mealDays?: Maybe<Array<Maybe<Day_Of_Week>>>;
  mobile?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  profileVideo?: Maybe<Video>;
  settings?: Maybe<ProfileSettings>;
  showBirthday?: Maybe<Scalars["Boolean"]["output"]>;
  showBirthyear?: Maybe<Scalars["Boolean"]["output"]>;
  showEmail?: Maybe<Scalars["Boolean"]["output"]>;
  showImage?: Maybe<Scalars["Boolean"]["output"]>;
  showInfoOnScreen?: Maybe<Scalars["Int"]["output"]>;
  showLastName?: Maybe<Scalars["Boolean"]["output"]>;
  showMobile?: Maybe<Scalars["Boolean"]["output"]>;
  status: Scalars["Boolean"]["output"];
  surname?: Maybe<Scalars["String"]["output"]>;
  type: Profile_Type;
  user?: Maybe<User>;
  /** @deprecated Use settings {videoCall} instead */
  videoCallEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use settings {videoCall} instead */
  videoCallStatus?: Maybe<Video_Call_Status>;
};

export type ResidentInput = {
  alias?: InputMaybe<Scalars["String"]["input"]>;
  birthday?: InputMaybe<Scalars["DateTime"]["input"]>;
  department?: InputMaybe<Scalars["ID"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstname?: InputMaybe<Scalars["String"]["input"]>;
  homeDays?: InputMaybe<Array<InputMaybe<Day_Of_Week>>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  image?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  invitationStatus?: InputMaybe<Invitation_Status>;
  lastname?: InputMaybe<Scalars["String"]["input"]>;
  mealDays?: InputMaybe<Array<InputMaybe<Day_Of_Week>>>;
  mobile?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  profileVideo?: InputMaybe<Scalars["ID"]["input"]>;
  relatives?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
  showBirthday?: InputMaybe<Scalars["Boolean"]["input"]>;
  showBirthyear?: InputMaybe<Scalars["Boolean"]["input"]>;
  showEmail?: InputMaybe<Scalars["Boolean"]["input"]>;
  showHomedays?: InputMaybe<Scalars["Boolean"]["input"]>;
  showImage?: InputMaybe<Scalars["Boolean"]["input"]>;
  showInfoOnScreen?: InputMaybe<Scalars["Int"]["input"]>;
  showLastname?: InputMaybe<Scalars["Boolean"]["input"]>;
  showMobile?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** @deprecated Use user.changeSettings instead */
  startScreen?: InputMaybe<Start_Screen>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  user?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ResourceInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  container?: InputMaybe<Container_Type>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResourceMutation = {
  __typename?: "ResourceMutation";
  save?: Maybe<DefaultResponse>;
  savePictogram?: Maybe<DefaultResponse>;
};

export type ResourceMutationSaveArgs = {
  resource?: InputMaybe<ResourceInput>;
};

export type ResourceMutationSavePictogramArgs = {
  pictogram: PictogramInput;
};

export enum Shift_Type {
  Normal = "NORMAL",
  Simple = "SIMPLE",
}

export enum Sort_Field {
  EndDate = "END_DATE",
  StartDate = "START_DATE",
}

export enum Sort_Order {
  Asc = "ASC",
  Desc = "DESC",
}

export enum Speaking_Rate {
  Fast = "FAST",
  Medium = "MEDIUM",
  Slow = "SLOW",
  XxFast = "XX_FAST",
  XxSlow = "XX_SLOW",
  XFast = "X_FAST",
  XSlow = "X_SLOW",
}

export enum Start_Screen {
  Modules = "MODULES",
  MyDay = "MY_DAY",
  WhatsHappening = "WHATS_HAPPENING",
}

export type ScheduleAvailableEmployee = {
  __typename?: "ScheduleAvailableEmployee";
  employeeId?: Maybe<Scalars["ID"]["output"]>;
  unavailableFrom?: Maybe<Scalars["DateTime"]["output"]>;
  unavailableReason?: Maybe<Scalars["String"]["output"]>;
  unavailableTo?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ScheduleCalendar = {
  __typename?: "ScheduleCalendar";
  date: Scalars["Date"]["output"];
  empty?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ScheduleMutation = {
  __typename?: "ScheduleMutation";
  deletePlan?: Maybe<DefaultResponse>;
  deleteShift?: Maybe<DefaultResponse>;
  savePlan?: Maybe<DefaultResponse>;
  saveShift?: Maybe<DefaultResponse>;
};

export type ScheduleMutationDeletePlanArgs = {
  id: Scalars["ID"]["input"];
};

export type ScheduleMutationDeleteShiftArgs = {
  id: Scalars["ID"]["input"];
};

export type ScheduleMutationSavePlanArgs = {
  schedulePlan: SchedulePlanInput;
};

export type ScheduleMutationSaveShiftArgs = {
  shift: ScheduleShiftInput;
};

export type SchedulePlanInput = {
  departments?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  employees?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  groups?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  repetitions?: InputMaybe<Scalars["Int"]["input"]>;
  startDate?: InputMaybe<Scalars["Date"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  weeks?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ScheduleQuery = {
  __typename?: "ScheduleQuery";
  shifts?: Maybe<Array<ScheduleShift>>;
};

export type ScheduleQueryShiftsArgs = {
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone?: Scalars["TimeZone"]["input"];
};

export type ScheduleShift = Node & {
  __typename?: "ScheduleShift";
  cancelled?: Maybe<Scalars["Boolean"]["output"]>;
  employee: Employee;
  end: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  nightShift?: Maybe<Scalars["Boolean"]["output"]>;
  start: Scalars["DateTime"]["output"];
  unavailable?: Maybe<Array<Maybe<UnavailableScheduleShift>>>;
};

export type ScheduleShiftInput = {
  cancelled?: InputMaybe<Scalars["Boolean"]["input"]>;
  employee?: InputMaybe<Scalars["ID"]["input"]>;
  /** @deprecated Use employee instead */
  employeeId?: InputMaybe<Scalars["ID"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  institution?: InputMaybe<Scalars["ID"]["input"]>;
  isRepeat?: InputMaybe<Scalars["Boolean"]["input"]>;
  nightShift?: InputMaybe<Scalars["Boolean"]["input"]>;
  repeat?: InputMaybe<Scalars["ID"]["input"]>;
  schedulePlan?: InputMaybe<Scalars["ID"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["Boolean"]["input"]>;
  unavailableEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  unavailableReason?: InputMaybe<Scalars["String"]["input"]>;
  unavailableStart?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ScreenProfile = {
  pin?: InputMaybe<Scalars["String"]["input"]>;
  profileId: Scalars["ID"]["input"];
  profileType: Profile_Type;
};

export type SelfMutation = {
  __typename?: "SelfMutation";
  /** @deprecated Use user { changeSettings } instead */
  changeCallStatus?: Maybe<DefaultResponse>;
};

export type SelfMutationChangeCallStatusArgs = {
  status?: InputMaybe<Video_Call_Status>;
};

export type SelfQuery = {
  __typename?: "SelfQuery";
  get: User;
  /** @deprecated Use groupType arg instead */
  groups: Array<Group>;
  institutions: Array<Institution>;
  myDay?: Maybe<Array<EventEntity>>;
  whatsHappening?: Maybe<Array<EventEntity>>;
};

export type SelfQueryGroupsArgs = {
  groupType?: InputMaybe<Grouptype>;
  type: Group_Type;
};

export type SelfQueryMyDayArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
  filter: Filter;
};

export type SelfQueryWhatsHappeningArgs = {
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
  filter: Filter;
};

export type Settings = {
  __typename?: "Settings";
  defaultDepartments?: Maybe<Array<Department>>;
  groups?: Maybe<Array<Group>>;
  institutions?: Maybe<Array<Institution>>;
  /** @deprecated Use profile { settings { notifications } } instead */
  notificationSetting: NotificationSetting;
  startScreen: Start_Screen;
  textToSpeechFilter: TextToSpeechFilter;
};

export type Shift = Node & {
  __typename?: "Shift";
  end?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  start?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ShiftMutation = {
  __typename?: "ShiftMutation";
  /** @deprecated Use schedule { deleteShift } instead */
  delete?: Maybe<DefaultResponse>;
  /** @deprecated Use schedule { saveShift } instead */
  update?: Maybe<DefaultResponse>;
};

export type ShiftMutationDeleteArgs = {
  id: Scalars["ID"]["input"];
};

export type ShiftMutationUpdateArgs = {
  shift: ScheduleShiftInput;
};

export type SimpleSchedulePlanEntry = {
  __typename?: "SimpleSchedulePlanEntry";
  endtime: Scalars["DateTime"]["output"];
  icon?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  starttime: Scalars["DateTime"]["output"];
};

export type SingleActivity = Node & {
  __typename?: "SingleActivity";
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  /** @deprecated Use category instead */
  club?: Maybe<Club>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  location?: Maybe<Scalars["String"]["output"]>;
  maxSignups?: Maybe<Scalars["Int"]["output"]>;
  notificationSettings?: Maybe<NotificationSettings>;
  notifyNokOnSignup: Scalars["Boolean"]["output"];
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  pictograms?: Maybe<Array<Pictogram>>;
  pictures?: Maybe<Array<Picture>>;
  price?: Maybe<Array<EventPrice>>;
  /** @deprecated Doesnt exist */
  read: Scalars["Boolean"]["output"];
  responsible?: Maybe<Array<Profile>>;
  showDateEnd?: Maybe<Scalars["DateTime"]["output"]>;
  showDateStart?: Maybe<Scalars["DateTime"]["output"]>;
  showFrom?: Maybe<Scalars["Int"]["output"]>;
  signupClose?: Maybe<Scalars["Int"]["output"]>;
  signupEnabled: Scalars["Boolean"]["output"];
  signupEnd?: Maybe<Scalars["DateTime"]["output"]>;
  signupPossible: Scalars["Boolean"]["output"];
  signupStart?: Maybe<Scalars["DateTime"]["output"]>;
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type SingleMeal = Node & {
  __typename?: "SingleMeal";
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  dishes?: Maybe<Array<MealDish>>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use pictures instead */
  image?: Maybe<Picture>;
  institution: Institution;
  maxSignups?: Maybe<Scalars["Int"]["output"]>;
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  pictures?: Maybe<Array<Picture>>;
  responsible?: Maybe<Array<Profile>>;
  signupClose: Scalars["Int"]["output"];
  signupEnabled: Scalars["Boolean"]["output"];
  signupEnd?: Maybe<Scalars["DateTime"]["output"]>;
  signupPossible: Scalars["Boolean"]["output"];
  signupStart?: Maybe<Scalars["DateTime"]["output"]>;
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type SingleMeeting = Node & {
  __typename?: "SingleMeeting";
  agendaPoints?: Maybe<Array<MeetingAgendaPoint>>;
  cancelled: Scalars["Boolean"]["output"];
  /** @deprecated Use meetingCategory instead */
  category?: Maybe<Scalars["String"]["output"]>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Doesn't exist */
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  /** @deprecated Doesn't exist */
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  institution: Institution;
  location?: Maybe<Scalars["String"]["output"]>;
  meetingCategory?: Maybe<Category>;
  notificationSettings?: Maybe<NotificationSettings>;
  participants?: Maybe<Array<Profile>>;
  participating: Scalars["Boolean"]["output"];
  /** @deprecated Doesn't exist */
  pictograms?: Maybe<Array<Pictogram>>;
  /** @deprecated Doesn't exist */
  pictures?: Maybe<Array<Picture>>;
  signupEnabled: Scalars["Boolean"]["output"];
  signupPossible: Scalars["Boolean"]["output"];
  startDate: Scalars["DateTime"]["output"];
  suggestions?: Maybe<Array<MeetingSuggestion>>;
  title: Scalars["String"]["output"];
  /** @deprecated Doesn't exist */
  videos?: Maybe<Array<Video>>;
  withdrawPossible: Scalars["Boolean"]["output"];
};

export type SingleMeetingSuggestionsArgs = {
  includeDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SingleNews = Node & {
  __typename?: "SingleNews";
  body: Scalars["String"]["output"];
  cancelled: Scalars["Boolean"]["output"];
  category?: Maybe<Category>;
  coverImage?: Maybe<Picture>;
  departments?: Maybe<Array<Department>>;
  documents?: Maybe<Array<Document>>;
  endDate: Scalars["DateTime"]["output"];
  groups?: Maybe<Array<Group>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<Picture>;
  institution: Institution;
  pictograms?: Maybe<Array<Pictogram>>;
  pictures?: Maybe<Array<Picture>>;
  published?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Doesnt exist */
  read: Scalars["Boolean"]["output"];
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  videos?: Maybe<Array<Video>>;
};

export type SinglePlannerTask = Node & {
  __typename?: "SinglePlannerTask";
  approvalState: Approval_State;
  assignees: Array<PlannerTaskAssignee>;
  category?: Maybe<PlannerCategory>;
  completed: Scalars["Boolean"]["output"];
  /** @deprecated Use assignees instead */
  department?: Maybe<Department>;
  description?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use assignees instead */
  employee?: Maybe<Employee>;
  endDate: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  institution: Institution;
  pictogram?: Maybe<Pictogram>;
  picture?: Maybe<Picture>;
  private: Scalars["Boolean"]["output"];
  /** @deprecated Use assignees instead */
  resident?: Maybe<Resident>;
  startDate: Scalars["DateTime"]["output"];
  subtasks?: Maybe<Array<PlannerSubtask>>;
  title: Scalars["String"]["output"];
  visibleForResident?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SlottedPreBooking = {
  __typename?: "SlottedPreBooking";
  id: Scalars["ID"]["output"];
  locked?: Maybe<Scalars["Boolean"]["output"]>;
  participants?: Maybe<Array<Profile>>;
  slotId: Scalars["ID"]["output"];
  weekDay: Scalars["Int"]["output"];
};

export type TextToSpeech = {
  __typename?: "TextToSpeech";
  /** An url to the required MP3 */
  source: Scalars["String"]["output"];
};

export type TextToSpeechFilter = {
  __typename?: "TextToSpeechFilter";
  enabled: Scalars["Boolean"]["output"];
  speakingRate: Speaking_Rate;
};

export type TravelPlan = {
  __typename?: "TravelPlan";
  cls?: Maybe<Scalars["String"]["output"]>;
  direction?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  rtTime?: Maybe<Scalars["String"]["output"]>;
  stop?: Maybe<Scalars["String"]["output"]>;
  time?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type TravelPlanLocation = {
  __typename?: "TravelPlanLocation";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export enum User_Roles {
  Admin = "ADMIN",
  Department = "DEPARTMENT",
  Employee = "EMPLOYEE",
  Nok = "NOK",
  Resident = "RESIDENT",
  Superuser = "SUPERUSER",
  Support = "SUPPORT",
  System = "SYSTEM",
}

export type UnavailableScheduleShift = {
  __typename?: "UnavailableScheduleShift";
  description?: Maybe<Scalars["String"]["output"]>;
  employee: Employee;
  end?: Maybe<Scalars["DateTime"]["output"]>;
  start?: Maybe<Scalars["DateTime"]["output"]>;
};

export type User = {
  __typename?: "User";
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  profiles?: Maybe<Array<Profile>>;
  roles?: Maybe<Array<UserRole>>;
  settings: UserSettings;
  username: Scalars["String"]["output"];
};

export type UserInput = {
  id: Scalars["ID"]["input"];
  settings?: InputMaybe<UserSettingsInput>;
};

export type UserMutation = {
  __typename?: "UserMutation";
  changeSettings?: Maybe<DefaultResponse>;
  deleteUser?: Maybe<DefaultResponse>;
  saveContacts?: Maybe<DefaultResponse>;
  saveProfile?: Maybe<DefaultResponse>;
  saveUser?: Maybe<DefaultResponse>;
  /** @deprecated use saveUser instead */
  update: DefaultResponse;
};

export type UserMutationChangeSettingsArgs = {
  profile?: InputMaybe<ProfileInput>;
  settings?: InputMaybe<ProfileSettingsInput>;
};

export type UserMutationDeleteUserArgs = {
  id: Scalars["ID"]["input"];
};

export type UserMutationSaveContactsArgs = {
  contacts: Array<Scalars["ID"]["input"]>;
  uid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UserMutationSaveProfileArgs = {
  employee?: InputMaybe<EmployeeInput>;
  relative?: InputMaybe<RelativeInput>;
  resident?: InputMaybe<ResidentInput>;
};

export type UserMutationSaveUserArgs = {
  user: UserSaveInput;
};

export type UserMutationUpdateArgs = {
  user: UserInput;
};

export type UserQuery = {
  __typename?: "UserQuery";
  getAccessToken?: Maybe<AccessToken>;
  getByEmailOrUsername?: Maybe<User>;
  getCalls?: Maybe<Array<Maybe<Call>>>;
  getContacts?: Maybe<Array<Maybe<User>>>;
  validatePin?: Maybe<DefaultResponse>;
};

export type UserQueryGetAccessTokenArgs = {
  ttl?: InputMaybe<Scalars["Int"]["input"]>;
  uid: Scalars["ID"]["input"];
};

export type UserQueryGetByEmailOrUsernameArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserQueryGetCallsArgs = {
  callIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type UserQueryGetContactsArgs = {
  accessCheck?: InputMaybe<Scalars["Boolean"]["input"]>;
  uid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UserQueryValidatePinArgs = {
  profile?: InputMaybe<ScreenProfile>;
};

export type UserRole = {
  __typename?: "UserRole";
  institution: Institution;
  role: User_Roles;
};

export type UserRoleInput = {
  institution: Scalars["ID"]["input"];
  role: User_Roles;
};

export type UserSaveInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  roles?: InputMaybe<Array<UserRoleInput>>;
  settings?: InputMaybe<UserSettingsInput>;
  username?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserSettings = {
  __typename?: "UserSettings";
  policies: UserSettingsPolicies;
};

export type UserSettingsInput = {
  policies: UserSettingsPoliciesInput;
};

export type UserSettingsPolicies = {
  __typename?: "UserSettingsPolicies";
  groupPolicyAccepted: Scalars["Boolean"]["output"];
  managerPolicyAccepted: Scalars["Boolean"]["output"];
  privacyPolicyAccepted: Scalars["Boolean"]["output"];
};

export type UserSettingsPoliciesInput = {
  groupPolicyAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  managerPolicyAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
  privacyPolicyAccepted?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The status in VideoKald */
export enum Video_Call_Status {
  Busy = "BUSY",
  Offline = "OFFLINE",
  Online = "ONLINE",
}

/** A list of the different allowed video providers */
export enum Video_Provider {
  Dreambroker = "DREAMBROKER",
  Vimeo = "VIMEO",
  Youtube = "YOUTUBE",
}

export type Video = Node & {
  __typename?: "Video";
  blurhash?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  provider?: Maybe<Video_Provider>;
  thumbnail?: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

/** A calendar entry for the what's happening screen. It takes into account if there are no events on the specified dates (empty = true) */
export type WhatsHappeningCalendar = {
  __typename?: "WhatsHappeningCalendar";
  date: Scalars["Date"]["output"];
  empty?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Activity_RepeatingActivity_Fragment = {
  __typename?: "RepeatingActivity";
  id: string;
  title: string;
  signupEnd?: any | null;
  signupClose?: number | null;
  startDate: any;
  endDate: any;
  showFrom?: number | null;
  maxSignups?: number | null;
  notifyNokOnSignup: boolean;
  cancelled: boolean;
  signupEnabled: boolean;
  read: boolean;
  description?: string | null;
  location?: string | null;
  participating: boolean;
  repeat: {
    __typename?: "RepeatRule";
    id: string;
    rset: { __typename?: "RRuleSet" } & RsetFragment;
  };
  notificationSettings?: {
    __typename?: "NotificationSettings";
    status: boolean;
    reminderFirst?: number | null;
    reminderSecond?: number | null;
  } | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
  videos?: Array<{ __typename?: "Video" } & VideoFragment> | null;
  club?: ({ __typename?: "Club" } & ClubFragment) | null;
  price?: Array<{ __typename?: "EventPrice" } & PriceFragment> | null;
  responsible?: Array<
    | ({ __typename?: "Employee" } & CompactProfile_Employee_Fragment)
    | ({ __typename?: "Relative" } & CompactProfile_Relative_Fragment)
    | ({ __typename?: "Resident" } & CompactProfile_Resident_Fragment)
  > | null;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  pictograms?: Array<{ __typename?: "Pictogram" } & PictogramFragment> | null;
  category?: { __typename?: "Category"; id: string; title: string } | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
};

export type Activity_SingleActivity_Fragment = {
  __typename?: "SingleActivity";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  showFrom?: number | null;
  signupEnabled: boolean;
  signupEnd?: any | null;
  signupClose?: number | null;
  maxSignups?: number | null;
  notifyNokOnSignup: boolean;
  cancelled: boolean;
  read: boolean;
  description?: string | null;
  location?: string | null;
  notificationSettings?: {
    __typename?: "NotificationSettings";
    status: boolean;
    reminderFirst?: number | null;
    reminderSecond?: number | null;
    triggerWhenCancelled: boolean;
    triggerWhenTimeChange: boolean;
  } | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
  price?: Array<{ __typename?: "EventPrice" } & PriceFragment> | null;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  pictograms?: Array<{ __typename?: "Pictogram" } & PictogramFragment> | null;
  responsible?: Array<
    | ({ __typename?: "Employee" } & CompactProfile_Employee_Fragment)
    | ({ __typename?: "Relative" } & CompactProfile_Relative_Fragment)
    | ({ __typename?: "Resident" } & CompactProfile_Resident_Fragment)
  > | null;
  participants?: Array<
    | ({ __typename?: "Employee" } & Participants_Employee_Fragment)
    | ({ __typename?: "Relative" } & Participants_Relative_Fragment)
    | ({ __typename?: "Resident" } & Participants_Resident_Fragment)
  > | null;
  videos?: Array<{ __typename?: "Video" } & VideoFragment> | null;
  category?: { __typename?: "Category"; id: string; title: string } | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
};

export type ActivityFragment =
  | Activity_RepeatingActivity_Fragment
  | Activity_SingleActivity_Fragment;

export type AgendaPointsFragment = {
  __typename?: "MeetingAgendaPoint";
  id: string;
  title: string;
  description?: string | null;
  picture?: ({ __typename?: "Picture" } & PictureFragment) | null;
};

export type CategoryFragment = {
  __typename?: "Category";
  id: string;
  title: string;
  description?: string | null;
  image?: {
    __typename?: "Picture";
    id: string;
    source: string;
    blurhash?: string | null;
  } | null;
};

export type ClubFragment = {
  __typename?: "Club";
  id: string;
  name: string;
  color?: any | null;
  logo: { __typename?: "Picture" } & PictureFragment;
};

export type CompactDepartmentFragment = {
  __typename?: "Department";
  id: string;
  color?: any | null;
  name: string;
};

export type CompactDocumentFragment = {
  __typename?: "Document";
  id: string;
  url: string;
  title: string;
};

export type CompactGroupFragment = {
  __typename?: "Group";
  id: string;
  color?: any | null;
  groupType: Grouptype;
};

export type CompactInstitutionFragment = {
  __typename?: "Institution";
  id: string;
  name: string;
  color?: any | null;
  locale?: string | null;
  logo: { __typename?: "Picture"; source: string };
};

export type CoreNewsFragment = {
  __typename?: "CoreNews";
  id: string;
  body: string;
  isFeatured: boolean;
  isRead?: boolean | null;
  showFrom: any;
  status: number;
  title: string;
  coverImage: { __typename?: "Picture" } & PictureFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  author: {
    __typename: "CoreNewsAuthor";
    id: string;
    title: string;
    name: string;
    status: boolean;
    image: { __typename?: "Picture" } & PictureFragment;
  };
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  videos?: Array<{ __typename?: "Video" } & VideoFragment> | null;
};

export type DepartmentFragment = {
  __typename?: "Department";
  id: string;
  institutionId: string;
  name: string;
  color?: any | null;
  screenOnly: boolean;
  settings?: {
    __typename?: "DepartmentSettings";
    meal?: {
      __typename?: "DepartmentMealSettings";
      daysForward: number;
      signup: boolean;
    } | null;
    shift?: {
      __typename?: "DepartmentShiftSettings";
      dayDisplay?: number | null;
      daysForward?: number | null;
      showGraphics?: boolean | null;
      showCancelled?: boolean | null;
    } | null;
    appConfig?: {
      __typename?: "DepartmentAppConfig";
      appModules?: Array<App_Module> | null;
    } | null;
    simpleSchedulePlan?: Array<{
      __typename?: "SimpleSchedulePlanEntry";
      name: string;
      icon?: string | null;
      startTime: any;
      endTime: any;
    }> | null;
  } | null;
};

export type DocumentFragment = {
  __typename?: "Document";
  id: string;
  url: string;
  title: string;
  description?: string | null;
};

export type InstitutionFragment = {
  __typename?: "Institution";
  id: string;
  name: string;
  color?: any | null;
  locale?: string | null;
  departments?: Array<
    { __typename?: "Department" } & DepartmentFragment
  > | null;
  settings: {
    __typename?: "InstitutionSettings";
    useExternalMedia: boolean;
    showAllDepartments: boolean;
    planner: {
      __typename?: "InstitutionSettingPlanner";
      enabledEmployees: boolean;
      enabledResidents: boolean;
    };
  };
};

export type Meal_RepeatingMeal_Fragment = {
  __typename?: "RepeatingMeal";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  description?: string | null;
  signupEnabled: boolean;
  signupEnd?: any | null;
  signupClose: number;
  maxSignups?: number | null;
  repeat: {
    __typename?: "RepeatRule";
    id: string;
    rset: { __typename?: "RRuleSet" } & RsetFragment;
  };
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  responsible?: Array<
    | ({ __typename?: "Employee" } & CompactProfile_Employee_Fragment)
    | ({ __typename?: "Relative" } & CompactProfile_Relative_Fragment)
    | ({ __typename?: "Resident" } & CompactProfile_Resident_Fragment)
  > | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
  dishes?: Array<{ __typename?: "MealDish" } & MealDishesFragment> | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
};

export type Meal_SingleMeal_Fragment = {
  __typename?: "SingleMeal";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  description?: string | null;
  signupEnabled: boolean;
  signupEnd?: any | null;
  signupClose: number;
  maxSignups?: number | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  responsible?: Array<
    | ({ __typename?: "Employee" } & CompactProfile_Employee_Fragment)
    | ({ __typename?: "Relative" } & CompactProfile_Relative_Fragment)
    | ({ __typename?: "Resident" } & CompactProfile_Resident_Fragment)
  > | null;
  participants?: Array<
    | ({ __typename?: "Employee" } & Participants_Employee_Fragment)
    | ({ __typename?: "Relative" } & Participants_Relative_Fragment)
    | ({ __typename?: "Resident" } & Participants_Resident_Fragment)
  > | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  dishes?: Array<{ __typename?: "MealDish" } & MealDishesFragment> | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
};

export type MealFragment =
  | Meal_RepeatingMeal_Fragment
  | Meal_SingleMeal_Fragment;

export type MealDishesFragment = {
  __typename?: "MealDish";
  id: string;
  title: string;
  description?: string | null;
  picture?: ({ __typename?: "Picture" } & PictureFragment) | null;
};

export type Meeting_RepeatingMeeting_Fragment = {
  __typename?: "RepeatingMeeting";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  signupEnabled: boolean;
  description?: string | null;
  location?: string | null;
  repeat: {
    __typename?: "RepeatRule";
    id: string;
    rset: { __typename?: "RRuleSet" } & RsetFragment;
  };
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  meetingCategory?: {
    __typename?: "Category";
    id: string;
    title: string;
  } | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
  notificationSettings?: {
    __typename?: "NotificationSettings";
    status: boolean;
    reminderFirst?: number | null;
    reminderSecond?: number | null;
  } | null;
  agendaPoints?: Array<
    { __typename?: "MeetingAgendaPoint" } & AgendaPointsFragment
  > | null;
  suggestions?: Array<
    { __typename?: "MeetingSuggestion" } & MeetingSuggestionsFragment
  > | null;
};

export type Meeting_SingleMeeting_Fragment = {
  __typename?: "SingleMeeting";
  id: string;
  title: string;
  signupEnabled: boolean;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  description?: string | null;
  location?: string | null;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  participants?: Array<
    | ({ __typename?: "Employee" } & Participants_Employee_Fragment)
    | ({ __typename?: "Relative" } & Participants_Relative_Fragment)
    | ({ __typename?: "Resident" } & Participants_Resident_Fragment)
  > | null;
  meetingCategory?: {
    __typename?: "Category";
    id: string;
    title: string;
  } | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  notificationSettings?: {
    __typename?: "NotificationSettings";
    status: boolean;
    reminderFirst?: number | null;
    reminderSecond?: number | null;
  } | null;
  agendaPoints?: Array<
    { __typename?: "MeetingAgendaPoint" } & AgendaPointsFragment
  > | null;
  suggestions?: Array<
    { __typename?: "MeetingSuggestion" } & MeetingSuggestionsFragment
  > | null;
};

export type MeetingFragment =
  | Meeting_RepeatingMeeting_Fragment
  | Meeting_SingleMeeting_Fragment;

export type MeetingSuggestionsFragment = {
  __typename?: "MeetingSuggestion";
  id: string;
  title?: string | null;
  status?: boolean | null;
  suggester?:
    | {
        __typename?: "Employee";
        displayName: string;
        image?: {
          __typename?: "Picture";
          source: string;
          blurhash?: string | null;
        } | null;
      }
    | {
        __typename?: "Relative";
        displayName: string;
        image?: {
          __typename?: "Picture";
          source: string;
          blurhash?: string | null;
        } | null;
      }
    | {
        __typename?: "Resident";
        displayName: string;
        image?: {
          __typename?: "Picture";
          source: string;
          blurhash?: string | null;
        } | null;
      }
    | null;
};

export type NewsFragment = {
  __typename?: "News";
  id: string;
  title: string;
  body: string;
  startDate: any;
  endDate: any;
  published?: any | null;
  read: boolean;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictograms?: Array<{ __typename?: "Pictogram" } & PictogramFragment> | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  videos?: Array<{ __typename?: "Video" } & VideoFragment> | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
  category?: { __typename?: "Category"; id: string; title: string } | null;
};

export type NewsUnion_BookingResource_Fragment = {
  __typename?: "BookingResource";
};

export type NewsUnion_BookingSlot_Fragment = { __typename?: "BookingSlot" };

export type NewsUnion_Employee_Fragment = { __typename?: "Employee" };

export type NewsUnion_Gallery_Fragment = { __typename?: "Gallery" };

export type NewsUnion_Meal_Fragment = { __typename?: "Meal" };

export type NewsUnion_MealDish_Fragment = { __typename?: "MealDish" };

export type NewsUnion_MeetingAgendaPointTemplate_Fragment = {
  __typename?: "MeetingAgendaPointTemplate";
};

export type NewsUnion_News_Fragment = { __typename?: "News" };

export type NewsUnion_Relative_Fragment = { __typename?: "Relative" };

export type NewsUnion_RepeatingActivity_Fragment = {
  __typename?: "RepeatingActivity";
};

export type NewsUnion_RepeatingMeal_Fragment = { __typename?: "RepeatingMeal" };

export type NewsUnion_RepeatingMeeting_Fragment = {
  __typename?: "RepeatingMeeting";
};

export type NewsUnion_RepeatingNews_Fragment = {
  __typename?: "RepeatingNews";
  id: string;
  title: string;
  body: string;
  startDate: any;
  endDate: any;
  published?: any | null;
  read: boolean;
  cancelled: boolean;
  repeat: {
    __typename?: "RepeatRule";
    id: string;
    rset: { __typename?: "RRuleSet" } & RsetFragment;
  };
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictograms?: Array<{ __typename?: "Pictogram" } & PictogramFragment> | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  videos?: Array<{ __typename?: "Video" } & VideoFragment> | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  category?: { __typename?: "Category"; id: string; title: string } | null;
};

export type NewsUnion_Resident_Fragment = { __typename?: "Resident" };

export type NewsUnion_SingleActivity_Fragment = {
  __typename?: "SingleActivity";
};

export type NewsUnion_SingleMeal_Fragment = { __typename?: "SingleMeal" };

export type NewsUnion_SingleMeeting_Fragment = { __typename?: "SingleMeeting" };

export type NewsUnion_SingleNews_Fragment = {
  __typename?: "SingleNews";
  id: string;
  title: string;
  body: string;
  startDate: any;
  endDate: any;
  published?: any | null;
  read: boolean;
  cancelled: boolean;
  institution: { __typename?: "Institution" } & CompactInstitutionFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictograms?: Array<{ __typename?: "Pictogram" } & PictogramFragment> | null;
  pictures?: Array<{ __typename?: "Picture" } & PictureFragment> | null;
  videos?: Array<{ __typename?: "Video" } & VideoFragment> | null;
  documents?: Array<{ __typename?: "Document" } & DocumentFragment> | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  category?: { __typename?: "Category"; id: string; title: string } | null;
};

export type NewsUnionFragment =
  | NewsUnion_BookingResource_Fragment
  | NewsUnion_BookingSlot_Fragment
  | NewsUnion_Employee_Fragment
  | NewsUnion_Gallery_Fragment
  | NewsUnion_Meal_Fragment
  | NewsUnion_MealDish_Fragment
  | NewsUnion_MeetingAgendaPointTemplate_Fragment
  | NewsUnion_News_Fragment
  | NewsUnion_Relative_Fragment
  | NewsUnion_RepeatingActivity_Fragment
  | NewsUnion_RepeatingMeal_Fragment
  | NewsUnion_RepeatingMeeting_Fragment
  | NewsUnion_RepeatingNews_Fragment
  | NewsUnion_Resident_Fragment
  | NewsUnion_SingleActivity_Fragment
  | NewsUnion_SingleMeal_Fragment
  | NewsUnion_SingleMeeting_Fragment
  | NewsUnion_SingleNews_Fragment;

export type NotificationSettingsFragment = {
  __typename?: "NotificationSettings";
  reminderFirst?: number | null;
  reminderSecond?: number | null;
  status: boolean;
  triggerWhenCancelled: boolean;
  triggerWhenTimeChange: boolean;
};

export type PageInfoFragment = {
  __typename?: "PageInfo";
  startCursor?: any | null;
  endCursor?: any | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type Participants_Employee_Fragment = {
  __typename?: "Employee";
  id: string;
  type: Profile_Type;
};

export type Participants_Relative_Fragment = {
  __typename?: "Relative";
  id: string;
  type: Profile_Type;
};

export type Participants_Resident_Fragment = {
  __typename?: "Resident";
  id: string;
  type: Profile_Type;
};

export type ParticipantsFragment =
  | Participants_Employee_Fragment
  | Participants_Relative_Fragment
  | Participants_Resident_Fragment;

export type PictogramFragment = {
  __typename?: "Pictogram";
  id: string;
  description?: string | null;
  source: string;
  type?: Pictogram_Type | null;
};

export type PictureFragment = {
  __typename?: "Picture";
  id: string;
  description?: string | null;
  source: string;
  blurhash?: string | null;
};

export type PlannerSubTaskFragment = {
  __typename?: "PlannerSubtask";
  id: string;
  title: string;
  completed: boolean;
  sortOrder?: number | null;
  picture?: { __typename?: "Picture"; id: string; source: string } | null;
  pictogram?: { __typename?: "Pictogram"; id: string; source: string } | null;
};

export type PlannerTask_RepeatingPlannerTask_Fragment = {
  __typename?: "RepeatingPlannerTask";
  id: string;
  title: string;
  description?: string | null;
  visibleForResident?: boolean | null;
  completed: boolean;
  startDate: any;
  endDate: any;
  approvalState: Approval_State;
  repeatId: string;
  type: "RepeatingPlannerTask";
  assignees: Array<
    | { __typename?: "Department"; id: string; type: "Department" }
    | { __typename?: "Employee"; id: string; type: "Employee" }
    | { __typename?: "Resident"; id: string; type: "Resident" }
  >;
  picture?: { __typename?: "Picture"; source: string } | null;
  pictogram?: { __typename?: "Pictogram"; source: string } | null;
  subtasks?: Array<
    { __typename?: "PlannerSubtask" } & PlannerSubTaskFragment
  > | null;
  category?: {
    __typename?: "PlannerCategory";
    id: string;
    color: any;
    title: string;
  } | null;
  repeat: {
    __typename?: "RepeatRule";
    id: string;
    rset: { __typename?: "RRuleSet" } & RsetFragment;
  };
};

export type PlannerTask_SinglePlannerTask_Fragment = {
  __typename?: "SinglePlannerTask";
  id: string;
  title: string;
  description?: string | null;
  visibleForResident?: boolean | null;
  completed: boolean;
  startDate: any;
  endDate: any;
  approvalState: Approval_State;
  type: "SinglePlannerTask";
  assignees: Array<
    | { __typename?: "Department"; id: string; type: "Department" }
    | { __typename?: "Employee"; id: string; type: "Employee" }
    | { __typename?: "Resident"; id: string; type: "Resident" }
  >;
  picture?: { __typename?: "Picture"; source: string } | null;
  pictogram?: { __typename?: "Pictogram"; source: string } | null;
  subtasks?: Array<
    { __typename?: "PlannerSubtask" } & PlannerSubTaskFragment
  > | null;
  category?: {
    __typename?: "PlannerCategory";
    color: any;
    id: string;
    title: string;
  } | null;
};

export type PlannerTaskFragment =
  | PlannerTask_RepeatingPlannerTask_Fragment
  | PlannerTask_SinglePlannerTask_Fragment;

export type PriceFragment = {
  __typename?: "EventPrice";
  price?: number | null;
  currency: string;
  profileType: Profile_Type;
  description?: string | null;
};

export type CompactEmployeeFragment = {
  __typename?: "Employee";
  id: string;
  type: Profile_Type;
  displayName: string;
  displayImage: string;
  showImage?: boolean | null;
  phone?: string | null;
  title?: string | null;
};

export type CompactResidentFragment = {
  __typename?: "Resident";
  id: string;
  type: Profile_Type;
  displayName: string;
  displayImage: string;
  showImage?: boolean | null;
};

export type RelativeFragment = {
  __typename?: "Relative";
  id: string;
  type: Profile_Type;
  displayName: string;
  displayImage: string;
  showImage?: boolean | null;
  email?: string | null;
  mobile?: string | null;
};

export type CompactProfile_Employee_Fragment = {
  __typename?: "Employee";
} & CompactEmployeeFragment;

export type CompactProfile_Relative_Fragment = {
  __typename?: "Relative";
} & RelativeFragment;

export type CompactProfile_Resident_Fragment = {
  __typename?: "Resident";
} & CompactResidentFragment;

export type CompactProfileFragment =
  | CompactProfile_Employee_Fragment
  | CompactProfile_Relative_Fragment
  | CompactProfile_Resident_Fragment;

export type RruleFragment = {
  __typename?: "RRule";
  BYHOUR?: Array<number> | null;
  BYMINUTE?: Array<number> | null;
  BYMONTH?: Array<Rrule_Month> | null;
  BYMONTHDAY?: Array<number> | null;
  BYSECOND?: Array<number> | null;
  BYSETPOS?: Array<number> | null;
  BYWEEKNO?: Array<number> | null;
  BYYEARDAY?: Array<number> | null;
  COUNT?: number | null;
  DTSTART?: any | null;
  FREQ?: Rrule_Frequency | null;
  INTERVAL?: number | null;
  UNTIL?: any | null;
  WKST?: Rrule_Day | null;
  BYDAY?: Array<{
    __typename?: "RRuleByDay";
    day: Rrule_Day;
    occurrence?: number | null;
  }> | null;
};

export type RsetFragment = {
  __typename?: "RRuleSet";
  excludedDates?: Array<any> | null;
  rule: { __typename?: "RRule" } & RruleFragment;
};

export type SummarizedActivities_RepeatingActivity_Fragment = {
  __typename?: "RepeatingActivity";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  showFrom?: number | null;
  repeat: { __typename?: "RepeatRule"; id: string };
  institution: { __typename?: "Institution" } & SummarizedInstitutionFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  participants?: Array<
    | ({ __typename?: "Employee" } & Participants_Employee_Fragment)
    | ({ __typename?: "Relative" } & Participants_Relative_Fragment)
    | ({ __typename?: "Resident" } & Participants_Resident_Fragment)
  > | null;
  category?: { __typename?: "Category"; id: string } | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<
    { __typename?: "Group"; id: string } & CompactGroupFragment
  > | null;
  documents?: Array<{ __typename?: "Document"; id: string }> | null;
  pictures?: Array<{ __typename?: "Picture"; id: string }> | null;
  videos?: Array<{ __typename?: "Video"; id: string }> | null;
};

export type SummarizedActivities_SingleActivity_Fragment = {
  __typename?: "SingleActivity";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  showFrom?: number | null;
  institution: { __typename?: "Institution" } & SummarizedInstitutionFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  participants?: Array<
    | ({ __typename?: "Employee" } & Participants_Employee_Fragment)
    | ({ __typename?: "Relative" } & Participants_Relative_Fragment)
    | ({ __typename?: "Resident" } & Participants_Resident_Fragment)
  > | null;
  category?: { __typename?: "Category"; id: string } | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<
    { __typename?: "Group"; id: string } & CompactGroupFragment
  > | null;
  documents?: Array<{ __typename?: "Document"; id: string }> | null;
  pictures?: Array<{ __typename?: "Picture"; id: string }> | null;
  videos?: Array<{ __typename?: "Video"; id: string }> | null;
};

export type SummarizedActivitiesFragment =
  | SummarizedActivities_RepeatingActivity_Fragment
  | SummarizedActivities_SingleActivity_Fragment;

export type SummarizedInstitutionFragment = {
  __typename?: "Institution";
  id: string;
  name: string;
  color?: any | null;
  logo: { __typename?: "Picture"; source: string };
};

export type SummarizedMeals_RepeatingMeal_Fragment = {
  __typename?: "RepeatingMeal";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictures?: Array<{ __typename?: "Picture"; id: string }> | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
  repeat: { __typename?: "RepeatRule"; id: string };
};

export type SummarizedMeals_SingleMeal_Fragment = {
  __typename?: "SingleMeal";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  pictures?: Array<{ __typename?: "Picture"; id: string }> | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
};

export type SummarizedMealsFragment =
  | SummarizedMeals_RepeatingMeal_Fragment
  | SummarizedMeals_SingleMeal_Fragment;

export type SummarizedMeetings_RepeatingMeeting_Fragment = {
  __typename?: "RepeatingMeeting";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  meetingCategory?: { __typename?: "Category"; id: string } | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
  repeat: { __typename?: "RepeatRule"; id: string };
};

export type SummarizedMeetings_SingleMeeting_Fragment = {
  __typename?: "SingleMeeting";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  coverImage?: ({ __typename?: "Picture" } & PictureFragment) | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  meetingCategory?: { __typename?: "Category"; id: string } | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  participants?: Array<
    | { __typename?: "Employee"; id: string }
    | { __typename?: "Relative"; id: string }
    | { __typename?: "Resident"; id: string }
  > | null;
};

export type SummarizedMeetingsFragment =
  | SummarizedMeetings_RepeatingMeeting_Fragment
  | SummarizedMeetings_SingleMeeting_Fragment;

export type SummarizedNewsUnion_BookingResource_Fragment = {
  __typename?: "BookingResource";
};

export type SummarizedNewsUnion_BookingSlot_Fragment = {
  __typename?: "BookingSlot";
};

export type SummarizedNewsUnion_Employee_Fragment = { __typename?: "Employee" };

export type SummarizedNewsUnion_Gallery_Fragment = { __typename?: "Gallery" };

export type SummarizedNewsUnion_Meal_Fragment = { __typename?: "Meal" };

export type SummarizedNewsUnion_MealDish_Fragment = { __typename?: "MealDish" };

export type SummarizedNewsUnion_MeetingAgendaPointTemplate_Fragment = {
  __typename?: "MeetingAgendaPointTemplate";
};

export type SummarizedNewsUnion_News_Fragment = { __typename?: "News" };

export type SummarizedNewsUnion_Relative_Fragment = { __typename?: "Relative" };

export type SummarizedNewsUnion_RepeatingActivity_Fragment = {
  __typename?: "RepeatingActivity";
};

export type SummarizedNewsUnion_RepeatingMeal_Fragment = {
  __typename?: "RepeatingMeal";
};

export type SummarizedNewsUnion_RepeatingMeeting_Fragment = {
  __typename?: "RepeatingMeeting";
};

export type SummarizedNewsUnion_RepeatingNews_Fragment = {
  __typename?: "RepeatingNews";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  institution: { __typename?: "Institution" } & SummarizedInstitutionFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  category?: { __typename?: "Category"; id: string } | null;
  repeat: { __typename?: "RepeatRule"; id: string };
  documents?: Array<{ __typename?: "Document"; id: string }> | null;
  pictures?: Array<{ __typename?: "Picture"; id: string }> | null;
  videos?: Array<{ __typename?: "Video"; id: string }> | null;
};

export type SummarizedNewsUnion_Resident_Fragment = { __typename?: "Resident" };

export type SummarizedNewsUnion_SingleActivity_Fragment = {
  __typename?: "SingleActivity";
};

export type SummarizedNewsUnion_SingleMeal_Fragment = {
  __typename?: "SingleMeal";
};

export type SummarizedNewsUnion_SingleMeeting_Fragment = {
  __typename?: "SingleMeeting";
};

export type SummarizedNewsUnion_SingleNews_Fragment = {
  __typename?: "SingleNews";
  id: string;
  title: string;
  startDate: any;
  endDate: any;
  cancelled: boolean;
  institution: { __typename?: "Institution" } & SummarizedInstitutionFragment;
  image?: ({ __typename?: "Picture" } & PictureFragment) | null;
  departments?: Array<
    { __typename?: "Department" } & CompactDepartmentFragment
  > | null;
  groups?: Array<{ __typename?: "Group" } & CompactGroupFragment> | null;
  category?: { __typename?: "Category"; id: string } | null;
  documents?: Array<{ __typename?: "Document"; id: string }> | null;
  pictures?: Array<{ __typename?: "Picture"; id: string }> | null;
  videos?: Array<{ __typename?: "Video"; id: string }> | null;
};

export type SummarizedNewsUnionFragment =
  | SummarizedNewsUnion_BookingResource_Fragment
  | SummarizedNewsUnion_BookingSlot_Fragment
  | SummarizedNewsUnion_Employee_Fragment
  | SummarizedNewsUnion_Gallery_Fragment
  | SummarizedNewsUnion_Meal_Fragment
  | SummarizedNewsUnion_MealDish_Fragment
  | SummarizedNewsUnion_MeetingAgendaPointTemplate_Fragment
  | SummarizedNewsUnion_News_Fragment
  | SummarizedNewsUnion_Relative_Fragment
  | SummarizedNewsUnion_RepeatingActivity_Fragment
  | SummarizedNewsUnion_RepeatingMeal_Fragment
  | SummarizedNewsUnion_RepeatingMeeting_Fragment
  | SummarizedNewsUnion_RepeatingNews_Fragment
  | SummarizedNewsUnion_Resident_Fragment
  | SummarizedNewsUnion_SingleActivity_Fragment
  | SummarizedNewsUnion_SingleMeal_Fragment
  | SummarizedNewsUnion_SingleMeeting_Fragment
  | SummarizedNewsUnion_SingleNews_Fragment;

export type VideoFragment = {
  __typename?: "Video";
  id: string;
  provider?: Video_Provider | null;
  url: string;
  description?: string | null;
  thumbnail?: string | null;
};

export type DeleteActivityMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  type: Delete_Type;
}>;

export type DeleteActivityMutation = {
  __typename?: "Mutation";
  activity?: {
    __typename?: "ActivityMutation";
    delete?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveActivityMutationVariables = Exact<{
  activity: ActivityInput;
}>;

export type SaveActivityMutation = {
  __typename?: "Mutation";
  activity?: {
    __typename?: "ActivityMutation";
    save?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveActivityNotificationMutationVariables = Exact<{
  settings: NotificationSettingsInput;
}>;

export type SaveActivityNotificationMutation = {
  __typename?: "Mutation";
  activity?: {
    __typename?: "ActivityMutation";
    saveNotificationSettings?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      message?: string | null;
      success: boolean;
    } | null;
  } | null;
};

export type SaveResourceMutationVariables = Exact<{
  resource: ResourceInput;
}>;

export type SaveResourceMutation = {
  __typename?: "Mutation";
  resource?: {
    __typename?: "ResourceMutation";
    save?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  type: Category_Type;
}>;

export type DeleteCategoryMutation = {
  __typename?: "Mutation";
  category?: {
    __typename?: "CategoryMutation";
    delete?: {
      __typename?: "DefaultResponse";
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveCategoryMutationVariables = Exact<{
  category: CategoryInput;
  type: Category_Type;
}>;

export type SaveCategoryMutation = {
  __typename?: "Mutation";
  category?: {
    __typename?: "CategoryMutation";
    save?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type EditDepartmentMutationVariables = Exact<{
  department: DepartmentInput;
}>;

export type EditDepartmentMutation = {
  __typename?: "Mutation";
  editDepartment?: {
    __typename?: "DefaultResponse";
    id?: string | null;
    message?: string | null;
    success: boolean;
  } | null;
};

export type MarkReadMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  isRead: Scalars["Boolean"]["input"];
}>;

export type MarkReadMutation = {
  __typename?: "Mutation";
  coreNews?: {
    __typename?: "CoreNewsMutation";
    markRead?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveAuthorMutationVariables = Exact<{
  author: CoreNewsAuthorInput;
}>;

export type SaveAuthorMutation = {
  __typename?: "Mutation";
  coreNews?: {
    __typename?: "CoreNewsMutation";
    saveAuthor?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveCoreNewsMutationVariables = Exact<{
  coreNews: CoreNewsInput;
}>;

export type SaveCoreNewsMutation = {
  __typename?: "Mutation";
  coreNews?: {
    __typename?: "CoreNewsMutation";
    save?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveEmployeeMutationVariables = Exact<{
  employee: EmployeeInput;
}>;

export type SaveEmployeeMutation = {
  __typename?: "Mutation";
  user?: {
    __typename?: "UserMutation";
    saveProfile?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveEmployeeTitleMutationVariables = Exact<{
  title: EmployeeTitleInput;
}>;

export type SaveEmployeeTitleMutation = {
  __typename?: "Mutation";
  institution?: {
    __typename?: "InstitutionMutation";
    saveEmployeeTitle?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type DeleteMealDishMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteMealDishMutation = {
  __typename?: "Mutation";
  meal?: {
    __typename?: "MealMutation";
    deleteDish: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    };
  } | null;
};

export type DeleteMealMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  type?: InputMaybe<Delete_Type>;
}>;

export type DeleteMealMutation = {
  __typename?: "Mutation";
  meal?: {
    __typename?: "MealMutation";
    deleteMeal: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    };
  } | null;
};

export type SaveMealDishMutationVariables = Exact<{
  dish: MealDishInput;
}>;

export type SaveMealDishMutation = {
  __typename?: "Mutation";
  meal?: {
    __typename?: "MealMutation";
    saveDish: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    };
  } | null;
};

export type SaveMealMutationVariables = Exact<{
  meal: MealInput;
  dishes?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type SaveMealMutation = {
  __typename?: "Mutation";
  meal?: {
    __typename?: "MealMutation";
    saveMeal: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    };
  } | null;
};

export type DeleteMeetingAgendaPointTemplateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteMeetingAgendaPointTemplateMutation = {
  __typename?: "Mutation";
  meeting?: {
    __typename?: "MeetingMutation";
    deleteAgendaPointTemplate?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type DeleteMeetingMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  type?: InputMaybe<Delete_Type>;
}>;

export type DeleteMeetingMutation = {
  __typename?: "Mutation";
  meeting?: {
    __typename?: "MeetingMutation";
    delete?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveMeetingAgendaPointTemplateMutationVariables = Exact<{
  agendaPoint: MeetingAgendaPointTemplateInput;
}>;

export type SaveMeetingAgendaPointTemplateMutation = {
  __typename?: "Mutation";
  meeting?: {
    __typename?: "MeetingMutation";
    saveAgendaPointTemplate?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveMeetingMutationVariables = Exact<{
  meeting: MeetingInput;
}>;

export type SaveMeetingMutation = {
  __typename?: "Mutation";
  meeting?: {
    __typename?: "MeetingMutation";
    save?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type DeleteNewsMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  type: Delete_Type;
}>;

export type DeleteNewsMutation = {
  __typename?: "Mutation";
  news?: {
    __typename?: "NewsMutation";
    delete?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SaveNewsMutationVariables = Exact<{
  news: NewsInput;
}>;

export type SaveNewsMutation = {
  __typename?: "Mutation";
  news?: {
    __typename?: "NewsMutation";
    save?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SavePictogramMutationVariables = Exact<{
  pictogram: PictogramInput;
}>;

export type SavePictogramMutation = {
  __typename?: "Mutation";
  resource?: {
    __typename?: "ResourceMutation";
    savePictogram?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
    } | null;
  } | null;
};

export type CompletePlannerSubtaskMutationVariables = Exact<{
  plannerTaskId: Scalars["ID"]["input"];
  plannerSubtaskId: Scalars["ID"]["input"];
}>;

export type CompletePlannerSubtaskMutation = {
  __typename?: "Mutation";
  completePlannerSubtask?: {
    __typename?: "PlannerTaskActionResponse";
    id?: string | null;
    success: boolean;
  } | null;
};

export type DeletePlannerFilterMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeletePlannerFilterMutation = {
  __typename?: "Mutation";
  planner?: {
    __typename?: "PlannerMutation";
    deleteFilter?: { __typename?: "DefaultResponse"; success: boolean } | null;
  } | null;
};

export type DeletePlannerTemplateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeletePlannerTemplateMutation = {
  __typename?: "Mutation";
  planner?: {
    __typename?: "PlannerMutation";
    deleteTemplate?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SavePlannerCategoryMutationVariables = Exact<{
  category: PlannerCategoryInput;
}>;

export type SavePlannerCategoryMutation = {
  __typename?: "Mutation";
  planner?: {
    __typename?: "PlannerMutation";
    saveCategory?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      message?: string | null;
      success: boolean;
    } | null;
  } | null;
};

export type SavePlannerFilterMutationVariables = Exact<{
  filter: PlannerFilterInput;
}>;

export type SavePlannerFilterMutation = {
  __typename?: "Mutation";
  planner?: {
    __typename?: "PlannerMutation";
    saveFilter?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SavePlannerTemplateMutationVariables = Exact<{
  template: PlannerTemplateInput;
}>;

export type SavePlannerTemplateMutation = {
  __typename?: "Mutation";
  planner?: {
    __typename?: "PlannerMutation";
    saveTemplate?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type UncompletePlannerSubtaskMutationVariables = Exact<{
  plannerTaskId: Scalars["ID"]["input"];
  plannerSubtaskId: Scalars["ID"]["input"];
}>;

export type UncompletePlannerSubtaskMutation = {
  __typename?: "Mutation";
  uncompletePlannerSubtask?: {
    __typename?: "PlannerTaskActionResponse";
    id?: string | null;
    success: boolean;
  } | null;
};

export type SaveProfileMutationVariables = Exact<{
  employee?: InputMaybe<EmployeeInput>;
  relative?: InputMaybe<RelativeInput>;
  resident?: InputMaybe<ResidentInput>;
}>;

export type SaveProfileMutation = {
  __typename?: "Mutation";
  user?: {
    __typename?: "UserMutation";
    saveProfile?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteUserMutation = {
  __typename?: "Mutation";
  user?: {
    __typename?: "UserMutation";
    deleteUser?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      message?: string | null;
      success: boolean;
    } | null;
  } | null;
};

export type GetEmployeeStatisticsQueryVariables = Exact<{
  filter: EntityPagerFilter;
}>;

export type GetEmployeeStatisticsQuery = {
  __typename?: "Query";
  self?: {
    __typename?: "SelfQuery";
    institutions: Array<{
      __typename?: "Institution";
      employees?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | {
                __typename?: "Employee";
                id: string;
                statistics?: {
                  __typename?: "ProfileStats";
                  numBookings?: number | null;
                  numMeals?: number | null;
                  numWorkSchedules?: number | null;
                  numActivitiesResponsible?: number | null;
                  numActivitiesParticipating?: number | null;
                } | null;
              }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
      } | null;
    }>;
  } | null;
};

export type SaveUserMutationVariables = Exact<{
  user: UserSaveInput;
}>;

export type SaveUserMutation = {
  __typename?: "Mutation";
  user?: {
    __typename?: "UserMutation";
    saveUser?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      message?: string | null;
      success: boolean;
    } | null;
  } | null;
};

export type GetExternalActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
  type: Module_Type;
}>;

export type GetExternalActivitiesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | ({
                __typename?: "RepeatingActivity";
              } & Activity_RepeatingActivity_Fragment)
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | ({
                __typename?: "SingleActivity";
              } & Activity_SingleActivity_Fragment)
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetInternalActivitiesOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetInternalActivitiesOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      activities?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | ({
                __typename?: "RepeatingActivity";
              } & Activity_RepeatingActivity_Fragment)
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | ({
                __typename?: "SingleActivity";
              } & Activity_SingleActivity_Fragment)
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedExternalActivitiesQueryVariables = Exact<{
  type: Module_Type;
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedExternalActivitiesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | ({
                __typename?: "RepeatingActivity";
              } & SummarizedActivities_RepeatingActivity_Fragment)
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | ({
                __typename?: "SingleActivity";
              } & SummarizedActivities_SingleActivity_Fragment)
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedInternalActivitiesQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedInternalActivitiesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      activities?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | ({
                __typename?: "RepeatingActivity";
              } & SummarizedActivities_RepeatingActivity_Fragment)
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | ({
                __typename?: "SingleActivity";
              } & SummarizedActivities_SingleActivity_Fragment)
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedBookingsOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedBookingsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      bookings?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | {
                __typename?: "BookingSlot";
                id: string;
                description?: string | null;
                start: any;
                end: any;
                resource: {
                  __typename?: "BookingResource";
                  coverImage?: {
                    __typename?: "Picture";
                    source: string;
                    blurhash?: string | null;
                  } | null;
                  departments?: Array<
                    { __typename?: "Department" } & CompactDepartmentFragment
                  > | null;
                };
                participants?: Array<
                  | { __typename?: "Employee"; id: string }
                  | { __typename?: "Relative"; id: string }
                  | { __typename?: "Resident"; id: string }
                > | null;
              }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetCategoriesQueryVariables = Exact<{
  type: Category_Type;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type GetCategoriesQuery = {
  __typename?: "Query";
  category?: {
    __typename?: "CategoryQuery";
    get?: Array<{
      __typename?: "Category";
      id: string;
      title: string;
      description?: string | null;
      image?: {
        __typename?: "Picture";
        id: string;
        source: string;
        blurhash?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetEventCountOnRelatedCategoryQueryVariables = Exact<{
  type: Category_Type;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type GetEventCountOnRelatedCategoryQuery = {
  __typename?: "Query";
  category?: {
    __typename?: "CategoryQuery";
    get?: Array<{
      __typename?: "Category";
      entities?: {
        __typename?: "EntityPager";
        totalCount?: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetDepartmentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetDepartmentQuery = {
  __typename?: "Query";
  department?: {
    __typename?: "Department";
    settings?: {
      __typename?: "DepartmentSettings";
      appConfig?: {
        __typename?: "DepartmentAppConfig";
        appModules?: Array<App_Module> | null;
      } | null;
      screenConfig?: {
        __typename?: "DepartmentScreenConfig";
        footerConfig?: Array<Module_List | null> | null;
        gridSize?: number | null;
        modules?: Array<{
          __typename?: "ModuleForScreen";
          colSpan?: string | null;
          id: string;
          rowSpan?: string | null;
          type?: Module_List | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type InstitutionByIdQueryQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
}>;

export type InstitutionByIdQueryQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    get?: Array<{
      __typename?: "Institution";
      name: string;
      id: string;
      departments?: Array<{
        __typename?: "Department";
        name: string;
        id: string;
      }> | null;
    }> | null;
  } | null;
};

export type InstitutionQueryQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
}>;

export type InstitutionQueryQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    get?: Array<{
      __typename?: "Institution";
      name: string;
      id: string;
      locale?: string | null;
    }> | null;
  } | null;
};

export type GetCoreNewsAsAdminQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
}>;

export type GetCoreNewsAsAdminQuery = {
  __typename?: "Query";
  coreNews?: {
    __typename?: "CoreNewsQuery";
    getAsAdmin?: Array<{ __typename?: "CoreNews" } & CoreNewsFragment> | null;
  } | null;
};

export type GetCoreNewsAuthorsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
}>;

export type GetCoreNewsAuthorsQuery = {
  __typename?: "Query";
  coreNews?: {
    __typename?: "CoreNewsQuery";
    getAuthors?: Array<{
      __typename?: "CoreNewsAuthor";
      id: string;
      title: string;
      name: string;
      status: boolean;
      image: { __typename?: "Picture" } & PictureFragment;
    }> | null;
  } | null;
};

export type GetCoreNewsQueryVariables = Exact<{
  ids?: InputMaybe<
    | Array<InputMaybe<Scalars["ID"]["input"]>>
    | InputMaybe<Scalars["ID"]["input"]>
  >;
}>;

export type GetCoreNewsQuery = {
  __typename?: "Query";
  coreNews?: {
    __typename?: "CoreNewsQuery";
    get?: Array<{ __typename?: "CoreNews" } & CoreNewsFragment> | null;
  } | null;
};

export type GetDepartmentListQueryVariables = Exact<{ [key: string]: never }>;

export type GetDepartmentListQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      id: string;
      departments?: Array<{
        __typename?: "Department";
        id: string;
        name: string;
        color?: any | null;
        contentProviders?: Array<{
          __typename?: "DepartmentContentProvider";
          content: Module_Type;
          institution: { __typename?: "Institution"; id: string };
        } | null> | null;
      }> | null;
    };
  } | null;
};

export type GetExternalDepartmentListQueryVariables = Exact<{
  type: Module_Type;
}>;

export type GetExternalDepartmentListQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalDepartments?: Array<{
        __typename?: "Department";
        id: string;
        name: string;
        color?: any | null;
        institution: { __typename?: "Institution"; id: string; name: string };
      }> | null;
    };
  } | null;
};

export type GetInstitutionsEmployeesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetInstitutionsEmployeesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      id: string;
      locale?: string | null;
      employees?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | {
                __typename?: "Employee";
                id: string;
                name?: string | null;
                surname?: string | null;
                email?: string | null;
                displayName: string;
                firstName?: string | null;
                lastName?: string | null;
                mobile?: string | null;
                phone?: string | null;
                title?: string | null;
                type: Profile_Type;
                alias?: string | null;
                description?: string | null;
                showImage?: boolean | null;
                isSuperuser?: boolean | null;
                image?: {
                  __typename?: "Picture";
                  id: string;
                  source: string;
                  blurhash?: string | null;
                } | null;
                employeeTitle?: {
                  __typename?: "EmployeeTitle";
                  id: string;
                } | null;
                user?: {
                  __typename?: "User";
                  id: string;
                  email?: string | null;
                  username: string;
                } | null;
              }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
      } | null;
    };
  } | null;
};

export type GetEmployeesTitleQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmployeesTitleQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getEmployeeTitles?: Array<{
      __typename?: "EmployeeTitle";
      id: string;
      title: string;
      description?: string | null;
    }> | null;
  } | null;
};

export type GetExternalEntityVisibilityQueryVariables = Exact<{
  entityType: Module_Type;
  institutionId: Scalars["ID"]["input"];
}>;

export type GetExternalEntityVisibilityQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getEntityVisibility?: Array<{
      __typename?: "EntityVisibility";
      entityId: string;
      entityType: Module_Type;
      institutionId: string;
    }> | null;
  } | null;
};

export type SetExternalEntityVisibilityMutationVariables = Exact<{
  entityId: Scalars["ID"]["input"];
  entityType: Module_Type;
  institutionId: Scalars["ID"]["input"];
  status: Scalars["Boolean"]["input"];
}>;

export type SetExternalEntityVisibilityMutation = {
  __typename?: "Mutation";
  institution?: {
    __typename?: "InstitutionMutation";
    setEntityVisibility?: {
      __typename?: "DefaultResponse";
      id?: string | null;
      success: boolean;
    } | null;
  } | null;
};

export type GetExternalGroupListQueryVariables = Exact<{
  type: Group_Connection;
}>;

export type GetExternalGroupListQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalGroups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        color?: any | null;
        groupType: Grouptype;
      }> | null;
    };
  } | null;
};

export type GetGroupListQueryVariables = Exact<{ [key: string]: never }>;

export type GetGroupListQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      id: string;
      groups?: Array<{
        __typename?: "Group";
        id: string;
        name: string;
        color?: any | null;
        groupType: Grouptype;
        moduleTypes: Array<Module_Type>;
        contentProviders?: Array<{
          __typename?: "GroupContentProvider";
          content?: Array<Group_Connection> | null;
          institution: { __typename?: "Institution"; id: string };
        } | null> | null;
      }> | null;
    };
  } | null;
};

export type GetAllInstitutionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllInstitutionsQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    get?: Array<{
      __typename?: "Institution";
      id: string;
      name: string;
    }> | null;
  } | null;
};

export type GetExternalMealsOnMyInstitutionQueryVariables = Exact<{
  type: Module_Type;
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetExternalMealsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | ({ __typename?: "RepeatingMeal" } & Meal_RepeatingMeal_Fragment)
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | ({ __typename?: "SingleMeal" } & Meal_SingleMeal_Fragment)
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetInternalMealsOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetInternalMealsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      meals?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | ({ __typename?: "RepeatingMeal" } & Meal_RepeatingMeal_Fragment)
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | ({ __typename?: "SingleMeal" } & Meal_SingleMeal_Fragment)
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetMealDishesQueryVariables = Exact<{ [key: string]: never }>;

export type GetMealDishesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      id: string;
      name: string;
      mealDishes?: {
        __typename?: "EntityPager";
        totalCount?: number | null;
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | {
                __typename?: "MealDish";
                id: string;
                title: string;
                description?: string | null;
                picture?: ({ __typename?: "Picture" } & PictureFragment) | null;
              }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
      } | null;
    };
  } | null;
};

export type GetSummarizedExternalMealsQueryVariables = Exact<{
  type: Module_Type;
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedExternalMealsQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | ({
                __typename?: "RepeatingMeal";
              } & SummarizedMeals_RepeatingMeal_Fragment)
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | ({
                __typename?: "SingleMeal";
              } & SummarizedMeals_SingleMeal_Fragment)
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedMealsOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedMealsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      meals?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | ({
                __typename?: "RepeatingMeal";
              } & SummarizedMeals_RepeatingMeal_Fragment)
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | ({
                __typename?: "SingleMeal";
              } & SummarizedMeals_SingleMeal_Fragment)
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetInternalMeetingsOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetInternalMeetingsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      meetings?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | ({
                __typename?: "RepeatingMeeting";
              } & Meeting_RepeatingMeeting_Fragment)
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | ({
                __typename?: "SingleMeeting";
              } & Meeting_SingleMeeting_Fragment)
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetMeetingAgendaPointTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetMeetingAgendaPointTemplatesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      meetingAgendaPointTemplates?: {
        __typename?: "EntityPager";
        totalCount?: number | null;
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | {
                __typename?: "MeetingAgendaPointTemplate";
                id: string;
                title: string;
                description?: string | null;
                picture?: {
                  __typename?: "Picture";
                  id: string;
                  source: string;
                } | null;
              }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
      } | null;
    };
  } | null;
};

export type GetSummarizedExternalMeetingsQueryVariables = Exact<{
  type: Module_Type;
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedExternalMeetingsQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | ({
                __typename?: "RepeatingMeeting";
              } & SummarizedMeetings_RepeatingMeeting_Fragment)
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | ({
                __typename?: "SingleMeeting";
              } & SummarizedMeetings_SingleMeeting_Fragment)
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedMeetingsOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedMeetingsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      meetings?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | ({
                __typename?: "RepeatingMeeting";
              } & SummarizedMeetings_RepeatingMeeting_Fragment)
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | ({
                __typename?: "SingleMeeting";
              } & SummarizedMeetings_SingleMeeting_Fragment)
            | { __typename?: "SingleNews" };
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetExternalNewsQueryVariables = Exact<{
  type: Module_Type;
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetExternalNewsQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | ({
                __typename?: "BookingResource";
              } & NewsUnion_BookingResource_Fragment)
            | ({ __typename?: "BookingSlot" } & NewsUnion_BookingSlot_Fragment)
            | ({ __typename?: "Employee" } & NewsUnion_Employee_Fragment)
            | ({ __typename?: "Gallery" } & NewsUnion_Gallery_Fragment)
            | ({ __typename?: "Meal" } & NewsUnion_Meal_Fragment)
            | ({ __typename?: "MealDish" } & NewsUnion_MealDish_Fragment)
            | ({
                __typename?: "MeetingAgendaPointTemplate";
              } & NewsUnion_MeetingAgendaPointTemplate_Fragment)
            | ({ __typename?: "News" } & NewsUnion_News_Fragment)
            | ({ __typename?: "Relative" } & NewsUnion_Relative_Fragment)
            | ({
                __typename?: "RepeatingActivity";
              } & NewsUnion_RepeatingActivity_Fragment)
            | ({
                __typename?: "RepeatingMeal";
              } & NewsUnion_RepeatingMeal_Fragment)
            | ({
                __typename?: "RepeatingMeeting";
              } & NewsUnion_RepeatingMeeting_Fragment)
            | ({
                __typename?: "RepeatingNews";
              } & NewsUnion_RepeatingNews_Fragment)
            | ({ __typename?: "Resident" } & NewsUnion_Resident_Fragment)
            | ({
                __typename?: "SingleActivity";
              } & NewsUnion_SingleActivity_Fragment)
            | ({ __typename?: "SingleMeal" } & NewsUnion_SingleMeal_Fragment)
            | ({
                __typename?: "SingleMeeting";
              } & NewsUnion_SingleMeeting_Fragment)
            | ({ __typename?: "SingleNews" } & NewsUnion_SingleNews_Fragment);
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetInternalNewsOnMyInstitutionQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetInternalNewsOnMyInstitutionQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      news?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | ({
                __typename?: "BookingResource";
              } & NewsUnion_BookingResource_Fragment)
            | ({ __typename?: "BookingSlot" } & NewsUnion_BookingSlot_Fragment)
            | ({ __typename?: "Employee" } & NewsUnion_Employee_Fragment)
            | ({ __typename?: "Gallery" } & NewsUnion_Gallery_Fragment)
            | ({ __typename?: "Meal" } & NewsUnion_Meal_Fragment)
            | ({ __typename?: "MealDish" } & NewsUnion_MealDish_Fragment)
            | ({
                __typename?: "MeetingAgendaPointTemplate";
              } & NewsUnion_MeetingAgendaPointTemplate_Fragment)
            | ({ __typename?: "News" } & NewsUnion_News_Fragment)
            | ({ __typename?: "Relative" } & NewsUnion_Relative_Fragment)
            | ({
                __typename?: "RepeatingActivity";
              } & NewsUnion_RepeatingActivity_Fragment)
            | ({
                __typename?: "RepeatingMeal";
              } & NewsUnion_RepeatingMeal_Fragment)
            | ({
                __typename?: "RepeatingMeeting";
              } & NewsUnion_RepeatingMeeting_Fragment)
            | ({
                __typename?: "RepeatingNews";
              } & NewsUnion_RepeatingNews_Fragment)
            | ({ __typename?: "Resident" } & NewsUnion_Resident_Fragment)
            | ({
                __typename?: "SingleActivity";
              } & NewsUnion_SingleActivity_Fragment)
            | ({ __typename?: "SingleMeal" } & NewsUnion_SingleMeal_Fragment)
            | ({
                __typename?: "SingleMeeting";
              } & NewsUnion_SingleMeeting_Fragment)
            | ({ __typename?: "SingleNews" } & NewsUnion_SingleNews_Fragment);
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedExternalNewsQueryVariables = Exact<{
  type: Module_Type;
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedExternalNewsQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      externalContent?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | ({
                __typename?: "BookingResource";
              } & SummarizedNewsUnion_BookingResource_Fragment)
            | ({
                __typename?: "BookingSlot";
              } & SummarizedNewsUnion_BookingSlot_Fragment)
            | ({
                __typename?: "Employee";
              } & SummarizedNewsUnion_Employee_Fragment)
            | ({
                __typename?: "Gallery";
              } & SummarizedNewsUnion_Gallery_Fragment)
            | ({ __typename?: "Meal" } & SummarizedNewsUnion_Meal_Fragment)
            | ({
                __typename?: "MealDish";
              } & SummarizedNewsUnion_MealDish_Fragment)
            | ({
                __typename?: "MeetingAgendaPointTemplate";
              } & SummarizedNewsUnion_MeetingAgendaPointTemplate_Fragment)
            | ({ __typename?: "News" } & SummarizedNewsUnion_News_Fragment)
            | ({
                __typename?: "Relative";
              } & SummarizedNewsUnion_Relative_Fragment)
            | ({
                __typename?: "RepeatingActivity";
              } & SummarizedNewsUnion_RepeatingActivity_Fragment)
            | ({
                __typename?: "RepeatingMeal";
              } & SummarizedNewsUnion_RepeatingMeal_Fragment)
            | ({
                __typename?: "RepeatingMeeting";
              } & SummarizedNewsUnion_RepeatingMeeting_Fragment)
            | ({
                __typename?: "RepeatingNews";
              } & SummarizedNewsUnion_RepeatingNews_Fragment)
            | ({
                __typename?: "Resident";
              } & SummarizedNewsUnion_Resident_Fragment)
            | ({
                __typename?: "SingleActivity";
              } & SummarizedNewsUnion_SingleActivity_Fragment)
            | ({
                __typename?: "SingleMeal";
              } & SummarizedNewsUnion_SingleMeal_Fragment)
            | ({
                __typename?: "SingleMeeting";
              } & SummarizedNewsUnion_SingleMeeting_Fragment)
            | ({
                __typename?: "SingleNews";
              } & SummarizedNewsUnion_SingleNews_Fragment);
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type GetSummarizedInternalNewsQueryVariables = Exact<{
  filter?: InputMaybe<EntityPagerFilter>;
}>;

export type GetSummarizedInternalNewsQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      news?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | ({
                __typename?: "BookingResource";
              } & SummarizedNewsUnion_BookingResource_Fragment)
            | ({
                __typename?: "BookingSlot";
              } & SummarizedNewsUnion_BookingSlot_Fragment)
            | ({
                __typename?: "Employee";
              } & SummarizedNewsUnion_Employee_Fragment)
            | ({
                __typename?: "Gallery";
              } & SummarizedNewsUnion_Gallery_Fragment)
            | ({ __typename?: "Meal" } & SummarizedNewsUnion_Meal_Fragment)
            | ({
                __typename?: "MealDish";
              } & SummarizedNewsUnion_MealDish_Fragment)
            | ({
                __typename?: "MeetingAgendaPointTemplate";
              } & SummarizedNewsUnion_MeetingAgendaPointTemplate_Fragment)
            | ({ __typename?: "News" } & SummarizedNewsUnion_News_Fragment)
            | ({
                __typename?: "Relative";
              } & SummarizedNewsUnion_Relative_Fragment)
            | ({
                __typename?: "RepeatingActivity";
              } & SummarizedNewsUnion_RepeatingActivity_Fragment)
            | ({
                __typename?: "RepeatingMeal";
              } & SummarizedNewsUnion_RepeatingMeal_Fragment)
            | ({
                __typename?: "RepeatingMeeting";
              } & SummarizedNewsUnion_RepeatingMeeting_Fragment)
            | ({
                __typename?: "RepeatingNews";
              } & SummarizedNewsUnion_RepeatingNews_Fragment)
            | ({
                __typename?: "Resident";
              } & SummarizedNewsUnion_Resident_Fragment)
            | ({
                __typename?: "SingleActivity";
              } & SummarizedNewsUnion_SingleActivity_Fragment)
            | ({
                __typename?: "SingleMeal";
              } & SummarizedNewsUnion_SingleMeal_Fragment)
            | ({
                __typename?: "SingleMeeting";
              } & SummarizedNewsUnion_SingleMeeting_Fragment)
            | ({
                __typename?: "SingleNews";
              } & SummarizedNewsUnion_SingleNews_Fragment);
        }>;
        pageInfo: { __typename?: "PageInfo" } & PageInfoFragment;
      } | null;
    };
  } | null;
};

export type NewsEntryQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type NewsEntryQuery = {
  __typename?: "Query";
  newsEntry?: ({ __typename?: "News" } & NewsFragment) | null;
};

export type GetPictogramsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPictogramsQuery = {
  __typename?: "Query";
  pictograms?: Array<{
    __typename?: "Pictogram";
    id: string;
    source: string;
    description?: string | null;
  }> | null;
};

export type AuditLogQueryQueryVariables = Exact<{
  filters?: InputMaybe<AuditLogFilter>;
}>;

export type AuditLogQueryQuery = {
  __typename?: "Query";
  auditLog?: {
    __typename?: "AuditLogQuery";
    getByFilters: Array<{
      __typename?: "AuditLog";
      created: any;
      entityId: string;
      entityType: string;
      event: Audit_Event_Type;
      profileId?: string | null;
      profileType?: Profile_Type | null;
    }>;
  } | null;
};

export type PlannerTaskActionResponseFragment = {
  __typename?: "PlannerTaskActionResponse";
  id?: string | null;
  success: boolean;
  message?: string | null;
};

export type CreatePlannerTaskMutationVariables = Exact<{
  plannerTask: PlannerTaskCreateInput;
}>;

export type CreatePlannerTaskMutation = {
  __typename?: "Mutation";
  createPlannerTask?:
    | ({
        __typename?: "PlannerTaskActionResponse";
      } & PlannerTaskActionResponseFragment)
    | null;
};

export type DeleteTaskMutationVariables = Exact<{
  input: DeletePlannerTaskInput;
}>;

export type DeleteTaskMutation = {
  __typename?: "Mutation";
  deletePlannerTask?: {
    __typename?: "DefaultResponse";
    id?: string | null;
    success: boolean;
    message?: string | null;
  } | null;
};

export type EditPlannerTaskMutationVariables = Exact<{
  plannerTaskId: Scalars["ID"]["input"];
  plannerTask: PlannerTaskEditInput;
}>;

export type EditPlannerTaskMutation = {
  __typename?: "Mutation";
  editPlannerTask?:
    | ({
        __typename?: "PlannerTaskActionResponse";
      } & PlannerTaskActionResponseFragment)
    | null;
};

export type EntitiesAvailabilityQueryVariables = Exact<{
  filter: Filter;
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  timezone: Scalars["TimeZone"]["input"];
}>;

export type EntitiesAvailabilityQuery = {
  __typename?: "Query";
  meetingRange?: Array<
    | {
        __typename?: "RepeatingMeeting";
        id: string;
        title: string;
        startDate: any;
        endDate: any;
      }
    | {
        __typename?: "SingleMeeting";
        id: string;
        title: string;
        startDate: any;
        endDate: any;
      }
  > | null;
  activityRange?: Array<
    | {
        __typename?: "RepeatingActivity";
        id: string;
        title: string;
        startDate: any;
        endDate: any;
      }
    | {
        __typename?: "SingleActivity";
        id: string;
        title: string;
        startDate: any;
        endDate: any;
      }
  > | null;
  mealRange?: Array<{
    __typename?: "Meal";
    id: string;
    title: string;
    startDate: any;
    endDate: any;
  }> | null;
};

export type GetActorsQueryVariables = Exact<{
  filter: Filter;
}>;

export type GetActorsQuery = {
  __typename?: "Query";
  profiles?: Array<
    | {
        __typename?: "Employee";
        id: string;
        displayImage: string;
        displayName: string;
        firstName?: string | null;
        lastName?: string | null;
        type: Profile_Type;
        settings?: {
          __typename?: "ProfileSettings";
          planner?: {
            __typename?: "ProfilePlannerSettings";
            assignment?: {
              __typename?: "ProfilePlannerAssignmentSettings";
              inbox: boolean;
            } | null;
          } | null;
        } | null;
      }
    | { __typename?: "Relative" }
    | {
        __typename?: "Resident";
        id: string;
        displayImage: string;
        displayName: string;
        firstName?: string | null;
        lastName?: string | null;
        type: Profile_Type;
        settings?: {
          __typename?: "ProfileSettings";
          planner?: {
            __typename?: "ProfilePlannerSettings";
            assignment?: {
              __typename?: "ProfilePlannerAssignmentSettings";
              inbox: boolean;
            } | null;
          } | null;
        } | null;
      }
  > | null;
  institution: {
    __typename?: "Institution";
    departments?: Array<{
      __typename?: "Department";
      color?: any | null;
      id: string;
      name: string;
      screenOnly: boolean;
    }> | null;
  };
};

export type GetPlannerCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPlannerCategoriesQuery = {
  __typename?: "Query";
  planner?: {
    __typename?: "PlannerQuery";
    getCategories?: Array<{
      __typename?: "PlannerCategory";
      id: string;
      title: string;
      color: any;
    }> | null;
  } | null;
};

export type GetPlannerFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlannerFiltersQuery = {
  __typename?: "Query";
  planner?: {
    __typename?: "PlannerQuery";
    getFilters?: Array<{
      __typename?: "PlannerFilter";
      id?: string | null;
      title?: string | null;
      assigneeTypes?: Array<Plannertask_Assignee_Type> | null;
      categories?: Array<string> | null;
      departments?: Array<string> | null;
      employees?: Array<string> | null;
      residents?: Array<string> | null;
      user?: { __typename?: "User"; id: string } | null;
    }> | null;
  } | null;
};

export type GetPlannerSubTasksQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetPlannerSubTasksQuery = {
  __typename?: "Query";
  plannerTaskEntry?:
    | {
        __typename?: "RepeatingPlannerTask";
        id: string;
        subtasks?: Array<{
          __typename?: "PlannerSubtask";
          id: string;
          title: string;
          completed: boolean;
          sortOrder?: number | null;
          picture?: {
            __typename?: "Picture";
            id: string;
            source: string;
          } | null;
          pictogram?: {
            __typename?: "Pictogram";
            id: string;
            source: string;
          } | null;
        }> | null;
      }
    | {
        __typename?: "SinglePlannerTask";
        id: string;
        subtasks?: Array<{
          __typename?: "PlannerSubtask";
          id: string;
          title: string;
          completed: boolean;
          sortOrder?: number | null;
          picture?: {
            __typename?: "Picture";
            id: string;
            source: string;
          } | null;
          pictogram?: {
            __typename?: "Pictogram";
            id: string;
            source: string;
          } | null;
        }> | null;
      }
    | null;
};

export type GetPlannerTasksQueryVariables = Exact<{
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
}>;

export type GetPlannerTasksQuery = {
  __typename?: "Query";
  planner?: {
    __typename?: "PlannerQuery";
    getTasksByFilters?: Array<
      | ({
          __typename?: "RepeatingPlannerTask";
        } & PlannerTask_RepeatingPlannerTask_Fragment)
      | ({
          __typename?: "SinglePlannerTask";
        } & PlannerTask_SinglePlannerTask_Fragment)
    > | null;
  } | null;
};

export type GetPlannerTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPlannerTemplatesQuery = {
  __typename?: "Query";
  plannerTemplates?: Array<{
    __typename?: "PlannerTemplate";
    id: string;
    title: string;
    duration?: number | null;
    private: boolean;
    start?: any | null;
    category?: {
      __typename?: "PlannerCategory";
      id: string;
      color: any;
      title: string;
    } | null;
    image?: {
      __typename?: "Picture";
      id: string;
      description?: string | null;
      source: string;
      blurhash?: string | null;
    } | null;
    pictogram?: {
      __typename?: "Pictogram";
      id: string;
      description?: string | null;
      source: string;
    } | null;
    subtasks?: Array<{
      __typename?: "PlannerTemplateSubtask";
      title: string;
    }> | null;
    repeat?: {
      __typename?: "RepeatRule";
      id: string;
      rset: { __typename?: "RRuleSet" } & RsetFragment;
    } | null;
  }> | null;
};

export type GetSinglePlannerTaskQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetSinglePlannerTaskQuery = {
  __typename?: "Query";
  plannerTaskEntry?:
    | ({
        __typename?: "RepeatingPlannerTask";
      } & PlannerTask_RepeatingPlannerTask_Fragment)
    | ({
        __typename?: "SinglePlannerTask";
      } & PlannerTask_SinglePlannerTask_Fragment)
    | null;
};

export type PlannerCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type PlannerCategoriesQuery = {
  __typename?: "Query";
  plannerCategories?: Array<{
    __typename?: "PlannerCategory";
    id: string;
    title: string;
    color: any;
  }> | null;
};

export type ScheduleAvailableEmployeesQueryVariables = Exact<{
  filter: Filter;
  dateFrom: Scalars["DateTime"]["input"];
  dateTo: Scalars["DateTime"]["input"];
}>;

export type ScheduleAvailableEmployeesQuery = {
  __typename?: "Query";
  scheduleAvailableEmployees?: Array<{
    __typename?: "ScheduleAvailableEmployee";
    employeeId?: string | null;
    unavailableFrom?: any | null;
    unavailableTo?: any | null;
    unavailableReason?: string | null;
  }> | null;
};

export type SettingsQueryVariables = Exact<{ [key: string]: never }>;

export type SettingsQuery = {
  __typename?: "Query";
  settings?: {
    __typename?: "Settings";
    institutions?: Array<{
      __typename?: "Institution";
      id: string;
      settings: {
        __typename?: "InstitutionSettings";
        vismaGatWs: boolean;
        planner: {
          __typename?: "InstitutionSettingPlanner";
          manager?: {
            __typename?: "InstitutionSettingPlannerManager";
            showOverdue?: boolean | null;
          } | null;
        };
      };
    }> | null;
  } | null;
};

export type GetProfilesQueryVariables = Exact<{
  filter: EntityPagerFilter;
}>;

export type GetProfilesQuery = {
  __typename?: "Query";
  institutions?: {
    __typename?: "InstitutionQuery";
    getMyInstitution: {
      __typename?: "Institution";
      employees?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | {
                __typename?: "Employee";
                id: string;
                name?: string | null;
                surname?: string | null;
                type: Profile_Type;
                image?: {
                  __typename?: "Picture";
                  source: string;
                  blurhash?: string | null;
                } | null;
                departments?: Array<{
                  __typename?: "Department";
                  id: string;
                  name: string;
                  color?: any | null;
                }> | null;
              }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | { __typename?: "Resident" }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
      } | null;
      residents?: {
        __typename?: "EntityPager";
        edges: Array<{
          __typename?: "EntityFeedEdge";
          node:
            | { __typename?: "BookingResource" }
            | { __typename?: "BookingSlot" }
            | { __typename?: "Employee" }
            | { __typename?: "Gallery" }
            | { __typename?: "Meal" }
            | { __typename?: "MealDish" }
            | { __typename?: "MeetingAgendaPointTemplate" }
            | { __typename?: "News" }
            | { __typename?: "Relative" }
            | { __typename?: "RepeatingActivity" }
            | { __typename?: "RepeatingMeal" }
            | { __typename?: "RepeatingMeeting" }
            | { __typename?: "RepeatingNews" }
            | {
                __typename?: "Resident";
                id: string;
                name?: string | null;
                surname?: string | null;
                image?: {
                  __typename?: "Picture";
                  source: string;
                  blurhash?: string | null;
                } | null;
                departments?: Array<{
                  __typename?: "Department";
                  id: string;
                  name: string;
                  color?: any | null;
                }> | null;
              }
            | { __typename?: "SingleActivity" }
            | { __typename?: "SingleMeal" }
            | { __typename?: "SingleMeeting" }
            | { __typename?: "SingleNews" };
        }>;
      } | null;
    };
  } | null;
};

export type GetRepeatOccurrencesQueryVariables = Exact<{
  rset: RRuleSetInput;
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type GetRepeatOccurrencesQuery = {
  __typename?: "Query";
  repeat?: {
    __typename?: "RepeatQuery";
    getOccurrences?: Array<any> | null;
  } | null;
};

export type DeleteUserByUsernameMutationVariables = Exact<{
  username: Scalars["String"]["input"];
}>;

export type DeleteUserByUsernameMutation = {
  __typename?: "Mutation";
  deleteUser?: {
    __typename?: "DefaultResponse";
    id?: string | null;
    success: boolean;
    message?: string | null;
  } | null;
};

export type GetByEmailOrUsernameQueryVariables = Exact<{
  email?: InputMaybe<Scalars["String"]["input"]>;
  username?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetByEmailOrUsernameQuery = {
  __typename?: "Query";
  user?: {
    __typename?: "UserQuery";
    getByEmailOrUsername?: { __typename?: "User"; id: string } | null;
  } | null;
};

export type GetSelfQueryQueryVariables = Exact<{ [key: string]: never }>;

export type GetSelfQueryQuery = {
  __typename?: "Query";
  self?: {
    __typename?: "SelfQuery";
    institutions: Array<{
      __typename?: "Institution";
      id: string;
      name: string;
      locale?: string | null;
      settings: {
        __typename?: "InstitutionSettings";
        useExternalWorkSchedule: boolean;
        planner: {
          __typename?: "InstitutionSettingPlanner";
          enabledEmployees: boolean;
        };
      };
    }>;
    get: {
      __typename?: "User";
      id: string;
      email?: string | null;
      roles?: Array<{
        __typename?: "UserRole";
        role: User_Roles;
        institution: { __typename?: "Institution"; id: string };
      }> | null;
      settings: {
        __typename?: "UserSettings";
        policies: {
          __typename?: "UserSettingsPolicies";
          managerPolicyAccepted: boolean;
        };
      };
      profiles?: Array<
        | {
            __typename?: "Employee";
            id: string;
            type: Profile_Type;
            image?: {
              __typename?: "Picture";
              source: string;
              blurhash?: string | null;
            } | null;
            plannerFilter?: {
              __typename?: "PlannerFilter";
              id?: string | null;
            } | null;
            institution: {
              __typename?: "Institution";
              id: string;
              name: string;
              locale?: string | null;
              notificationSettings?: {
                __typename?: "InstitutionNotificationSettings";
                activity?:
                  | ({
                      __typename?: "NotificationSettings";
                    } & NotificationSettingsFragment)
                  | null;
              } | null;
            };
          }
        | { __typename?: "Relative" }
        | { __typename?: "Resident" }
      > | null;
    };
  } | null;
};

export type GetShiftsQueryQueryVariables = Exact<{
  dateFrom: Scalars["Date"]["input"];
  dateTo: Scalars["Date"]["input"];
  filter: Filter;
  timezone: Scalars["TimeZone"]["input"];
}>;

export type GetShiftsQueryQuery = {
  __typename?: "Query";
  schedule?: {
    __typename?: "ScheduleQuery";
    shifts?: Array<{
      __typename?: "ScheduleShift";
      cancelled?: boolean | null;
      end: any;
      id: string;
      nightShift?: boolean | null;
      start: any;
      employee: {
        __typename?: "Employee";
        displayImage: string;
        displayName: string;
        showImage?: boolean | null;
        id: string;
        shift?: {
          __typename?: "Shift";
          end?: any | null;
          id: string;
          start?: any | null;
        } | null;
      };
      unavailable?: Array<{
        __typename?: "UnavailableScheduleShift";
        description?: string | null;
        end?: any | null;
        start?: any | null;
      } | null> | null;
    }> | null;
  } | null;
};

export const DocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DocumentFragment, unknown>;
export const CompactInstitutionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactInstitutionFragment, unknown>;
export const PriceFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "price" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventPrice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "profileType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PriceFragment, unknown>;
export const PictureFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PictureFragment, unknown>;
export const PictogramFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PictogramFragment, unknown>;
export const CompactEmployeeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactEmployeeFragment, unknown>;
export const CompactResidentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactResidentFragment, unknown>;
export const RelativeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RelativeFragment, unknown>;
export const CompactProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactProfileFragment, unknown>;
export const ParticipantsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ParticipantsFragment, unknown>;
export const VideoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VideoFragment, unknown>;
export const CompactDepartmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactDepartmentFragment, unknown>;
export const CompactGroupFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactGroupFragment, unknown>;
export const RruleFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RruleFragment, unknown>;
export const RsetFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RsetFragment, unknown>;
export const ClubFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "club" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Club" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClubFragment, unknown>;
export const ActivityFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "activity" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Activity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notifyNokOnSignup" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggerWhenCancelled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggerWhenTimeChange" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "price" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notifyNokOnSignup" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "club" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "club" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "price" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participating" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "price" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventPrice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "profileType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "club" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Club" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ActivityFragment, unknown>;
export const CategoryFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "category" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Category" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "blurhash" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CategoryFragment, unknown>;
export const CompactDocumentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDocument" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompactDocumentFragment, unknown>;
export const CoreNewsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "coreNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoreNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "isFeatured" } },
          { kind: "Field", name: { kind: "Name", value: "isRead" } },
          { kind: "Field", name: { kind: "Name", value: "showFrom" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coverImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "author" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "document" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "videos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "video" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoreNewsFragment, unknown>;
export const DepartmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "department" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "institutionId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "screenOnly" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meal" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysForward" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shift" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dayDisplay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysForward" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "showGraphics" },
                        name: { kind: "Name", value: "gfx" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "showCancelled" },
                        name: { kind: "Name", value: "showCancelledFp" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appModules" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "simpleSchedulePlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "startTime" },
                        name: { kind: "Name", value: "starttime" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "endTime" },
                        name: { kind: "Name", value: "endtime" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DepartmentFragment, unknown>;
export const InstitutionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "institution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "departments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "department" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "planner" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabledEmployees" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "enabledResidents" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "useExternalMedia" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "showAllDepartments" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "department" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "institutionId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "screenOnly" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meal" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysForward" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shift" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dayDisplay" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "daysForward" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "showGraphics" },
                        name: { kind: "Name", value: "gfx" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "showCancelled" },
                        name: { kind: "Name", value: "showCancelledFp" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "appConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appModules" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "simpleSchedulePlan" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "startTime" },
                        name: { kind: "Name", value: "starttime" },
                      },
                      {
                        kind: "Field",
                        alias: { kind: "Name", value: "endTime" },
                        name: { kind: "Name", value: "endtime" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "icon" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InstitutionFragment, unknown>;
export const MealDishesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "mealDishes" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealDish" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealDishesFragment, unknown>;
export const MealFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealUnion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dishes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "mealDishes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dishes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "mealDishes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "mealDishes" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealDish" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MealFragment, unknown>;
export const AgendaPointsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "agendaPoints" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MeetingAgendaPoint" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgendaPointsFragment, unknown>;
export const MeetingSuggestionsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meetingSuggestions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MeetingSuggestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "suggester" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Employee" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Relative" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Resident" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingSuggestionsFragment, unknown>;
export const MeetingFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meeting" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Meeting" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agendaPoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "agendaPoints" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "suggestions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDisabled" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "meetingSuggestions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agendaPoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "agendaPoints" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "suggestions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDisabled" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "meetingSuggestions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "agendaPoints" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MeetingAgendaPoint" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meetingSuggestions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MeetingSuggestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "suggester" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Employee" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Relative" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Resident" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeetingFragment, unknown>;
export const NewsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "news" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "News" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictograms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "pictogram" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "videos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "video" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "document" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "departments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "compactDepartment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "groups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "compactGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "institution" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "compactInstitution" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsFragment, unknown>;
export const NewsUnionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "newsUnion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PagedEntity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsUnionFragment, unknown>;
export const NotificationSettingsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "notificationSettings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "NotificationSettings" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reminderFirst" } },
          { kind: "Field", name: { kind: "Name", value: "reminderSecond" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggerWhenCancelled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggerWhenTimeChange" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationSettingsFragment, unknown>;
export const PageInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageInfoFragment, unknown>;
export const PlannerSubTaskFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerSubTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerSubtask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictogram" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlannerSubTaskFragment, unknown>;
export const PlannerTaskFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SinglePlannerTask" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "type" },
                  name: { kind: "Name", value: "__typename" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignees" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Department" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForResident" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "picture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerSubTask" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completed" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvalState" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingPlannerTask" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "type" },
                  name: { kind: "Name", value: "__typename" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignees" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Department" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForResident" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "picture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerSubTask" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completed" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvalState" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "repeatId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerSubTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerSubtask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictogram" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlannerTaskFragment, unknown>;
export const SummarizedInstitutionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SummarizedInstitutionFragment, unknown>;
export const SummarizedActivitiesFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedActivities" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Activity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SummarizedActivitiesFragment, unknown>;
export const SummarizedMealsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedMeals" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealUnion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SummarizedMealsFragment, unknown>;
export const SummarizedMeetingsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedMeetings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Meeting" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SummarizedMeetingsFragment, unknown>;
export const SummarizedNewsUnionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedNewsUnion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PagedEntity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SummarizedNewsUnionFragment, unknown>;
export const PlannerTaskActionResponseFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerTaskActionResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerTaskActionResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PlannerTaskActionResponseFragment, unknown>;
export const DeleteActivityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteActivity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DELETE_TYPE" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delete" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteActivityMutation,
  DeleteActivityMutationVariables
>;
export const SaveActivityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveActivity" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "activity" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ActivityInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "save" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "activity" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "activity" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveActivityMutation,
  SaveActivityMutationVariables
>;
export const SaveActivityNotificationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveActivityNotification" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "settings" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NotificationSettingsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "activity" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveNotificationSettings" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "settings" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "settings" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveActivityNotificationMutation,
  SaveActivityNotificationMutationVariables
>;
export const SaveResourceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveResource" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resource" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ResourceInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "save" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "resource" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "resource" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveResourceMutation,
  SaveResourceMutationVariables
>;
export const DeleteCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CATEGORY_TYPE" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delete" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCategoryMutation,
  DeleteCategoryMutationVariables
>;
export const SaveCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CategoryInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CATEGORY_TYPE" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "save" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveCategoryMutation,
  SaveCategoryMutationVariables
>;
export const EditDepartmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "editDepartment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "department" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DepartmentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "editDepartment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "department" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "department" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditDepartmentMutation,
  EditDepartmentMutationVariables
>;
export const MarkReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "markRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isRead" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coreNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "markRead" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "isRead" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "isRead" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkReadMutation, MarkReadMutationVariables>;
export const SaveAuthorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveAuthor" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "author" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoreNewsAuthorInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coreNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveAuthor" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "author" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "author" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveAuthorMutation, SaveAuthorMutationVariables>;
export const SaveCoreNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveCoreNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "coreNews" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CoreNewsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coreNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "save" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "coreNews" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "coreNews" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveCoreNewsMutation,
  SaveCoreNewsMutationVariables
>;
export const SaveEmployeeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveEmployee" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "employee" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EmployeeInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveProfile" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "employee" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "employee" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveEmployeeMutation,
  SaveEmployeeMutationVariables
>;
export const SaveEmployeeTitleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveEmployeeTitle" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "title" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EmployeeTitleInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institution" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveEmployeeTitle" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "title" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "title" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveEmployeeTitleMutation,
  SaveEmployeeTitleMutationVariables
>;
export const DeleteMealDishDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMealDish" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meal" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleteDish" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMealDishMutation,
  DeleteMealDishMutationVariables
>;
export const DeleteMealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DELETE_TYPE" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meal" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleteMeal" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteMealMutation, DeleteMealMutationVariables>;
export const SaveMealDishDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveMealDish" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "dish" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MealDishInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meal" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveDish" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dish" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dish" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveMealDishMutation,
  SaveMealDishMutationVariables
>;
export const SaveMealDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveMeal" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "meal" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MealInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dishes" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meal" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveMeal" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "meal" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "meal" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dishes" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dishes" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveMealMutation, SaveMealMutationVariables>;
export const DeleteMeetingAgendaPointTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMeetingAgendaPointTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleteAgendaPointTemplate" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMeetingAgendaPointTemplateMutation,
  DeleteMeetingAgendaPointTemplateMutationVariables
>;
export const DeleteMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DELETE_TYPE" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delete" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMeetingMutation,
  DeleteMeetingMutationVariables
>;
export const SaveMeetingAgendaPointTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveMeetingAgendaPointTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "agendaPoint" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MeetingAgendaPointTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveAgendaPointTemplate" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "agendaPoint" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "agendaPoint" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveMeetingAgendaPointTemplateMutation,
  SaveMeetingAgendaPointTemplateMutationVariables
>;
export const SaveMeetingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveMeeting" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "meeting" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MeetingInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meeting" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "save" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "meeting" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "meeting" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveMeetingMutation, SaveMeetingMutationVariables>;
export const DeleteNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DELETE_TYPE" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "delete" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteNewsMutation, DeleteNewsMutationVariables>;
export const SaveNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "news" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "NewsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "news" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "save" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "news" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "news" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveNewsMutation, SaveNewsMutationVariables>;
export const SavePictogramDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "savePictogram" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pictogram" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PictogramInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resource" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "savePictogram" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "pictogram" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SavePictogramMutation,
  SavePictogramMutationVariables
>;
export const CompletePlannerSubtaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "completePlannerSubtask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerTaskId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerSubtaskId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "completePlannerSubtask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerTaskId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerTaskId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerSubtaskId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerSubtaskId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompletePlannerSubtaskMutation,
  CompletePlannerSubtaskMutationVariables
>;
export const DeletePlannerFilterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePlannerFilter" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleteFilter" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePlannerFilterMutation,
  DeletePlannerFilterMutationVariables
>;
export const DeletePlannerTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deletePlannerTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleteTemplate" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeletePlannerTemplateMutation,
  DeletePlannerTemplateMutationVariables
>;
export const SavePlannerCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "savePlannerCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "category" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlannerCategoryInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveCategory" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "category" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "category" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SavePlannerCategoryMutation,
  SavePlannerCategoryMutationVariables
>;
export const SavePlannerFilterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "savePlannerFilter" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlannerFilterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveFilter" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filter" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "filter" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SavePlannerFilterMutation,
  SavePlannerFilterMutationVariables
>;
export const SavePlannerTemplateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "savePlannerTemplate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "template" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlannerTemplateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveTemplate" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "template" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "template" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SavePlannerTemplateMutation,
  SavePlannerTemplateMutationVariables
>;
export const UncompletePlannerSubtaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "uncompletePlannerSubtask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerTaskId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerSubtaskId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "uncompletePlannerSubtask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerTaskId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerTaskId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerSubtaskId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerSubtaskId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UncompletePlannerSubtaskMutation,
  UncompletePlannerSubtaskMutationVariables
>;
export const SaveProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "employee" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EmployeeInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "relative" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "RelativeInput" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resident" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ResidentInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveProfile" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "employee" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "employee" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "relative" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "relative" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "resident" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "resident" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveProfileMutation, SaveProfileMutationVariables>;
export const DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deleteUser" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "id" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "id" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetEmployeeStatisticsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getEmployeeStatistics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EntityPagerFilter" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "self" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institutions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employees" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Employee",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "statistics",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "numBookings",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "numMeals",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "numWorkSchedules",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "numActivitiesResponsible",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "numActivitiesParticipating",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmployeeStatisticsQuery,
  GetEmployeeStatisticsQueryVariables
>;
export const SaveUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "saveUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "user" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UserSaveInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "saveUser" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "user" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "user" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveUserMutation, SaveUserMutationVariables>;
export const GetExternalActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "activity",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "price" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventPrice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "profileType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "club" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Club" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "activity" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Activity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notifyNokOnSignup" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggerWhenCancelled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggerWhenTimeChange" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "price" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notifyNokOnSignup" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "club" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "club" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "price" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participating" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalActivitiesQuery,
  GetExternalActivitiesQueryVariables
>;
export const GetInternalActivitiesOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInternalActivitiesOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "activity",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "price" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "EventPrice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "price" } },
          { kind: "Field", name: { kind: "Name", value: "currency" } },
          { kind: "Field", name: { kind: "Name", value: "profileType" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "club" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Club" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "activity" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Activity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notifyNokOnSignup" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggerWhenCancelled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "triggerWhenTimeChange" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "price" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notifyNokOnSignup" },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "club" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "club" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "price" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participating" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternalActivitiesOnMyInstitutionQuery,
  GetInternalActivitiesOnMyInstitutionQueryVariables
>;
export const GetSummarizedExternalActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedExternalActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedActivities",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedActivities" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Activity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedExternalActivitiesQuery,
  GetSummarizedExternalActivitiesQueryVariables
>;
export const GetSummarizedInternalActivitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedInternalActivities" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedActivities",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedActivities" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Activity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingActivity" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "showFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedInternalActivitiesQuery,
  GetSummarizedInternalActivitiesQueryVariables
>;
export const GetSummarizedBookingsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedBookingsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bookings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "BookingSlot",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "resource",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "coverImage",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "source",
                                                            },
                                                          },
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "blurhash",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "departments",
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                              kind: "Name",
                                                              value:
                                                                "compactDepartment",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "start",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "end",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "participants",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Employee",
                                                        },
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Relative",
                                                        },
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: {
                                                          kind: "Name",
                                                          value: "Resident",
                                                        },
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "id",
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedBookingsOnMyInstitutionQuery,
  GetSummarizedBookingsOnMyInstitutionQueryVariables
>;
export const GetCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CATEGORY_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetEventCountOnRelatedCategoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getEventCountOnRelatedCategory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CATEGORY_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "type" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "type" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entities" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "first" },
                            value: { kind: "IntValue", value: "1" },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalCount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEventCountOnRelatedCategoryQuery,
  GetEventCountOnRelatedCategoryQueryVariables
>;
export const GetDepartmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getDepartment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "department" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "settings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appConfig" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "appModules" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "screenConfig" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "footerConfig" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gridSize" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "modules" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "colSpan" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "rowSpan" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDepartmentQuery, GetDepartmentQueryVariables>;
export const InstitutionByIdQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "institutionByIdQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "departments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InstitutionByIdQueryQuery,
  InstitutionByIdQueryQueryVariables
>;
export const InstitutionQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "institutionQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locale" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InstitutionQueryQuery,
  InstitutionQueryQueryVariables
>;
export const GetCoreNewsAsAdminDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCoreNewsAsAdmin" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coreNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getAsAdmin" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "coreNews" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "coreNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoreNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "isFeatured" } },
          { kind: "Field", name: { kind: "Name", value: "isRead" } },
          { kind: "Field", name: { kind: "Name", value: "showFrom" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coverImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "author" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "document" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "videos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "video" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCoreNewsAsAdminQuery,
  GetCoreNewsAsAdminQueryVariables
>;
export const GetCoreNewsAuthorsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCoreNewsAuthors" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coreNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getAuthors" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "picture" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCoreNewsAuthorsQuery,
  GetCoreNewsAuthorsQueryVariables
>;
export const GetCoreNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCoreNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "ListType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "coreNews" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "ids" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "coreNews" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "coreNews" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CoreNews" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "isFeatured" } },
          { kind: "Field", name: { kind: "Name", value: "isRead" } },
          { kind: "Field", name: { kind: "Name", value: "showFrom" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "coverImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "author" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "document" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "videos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "video" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCoreNewsQuery, GetCoreNewsQueryVariables>;
export const GetDepartmentListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getDepartmentList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "departments" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "color" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contentProviders" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "institution",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDepartmentListQuery,
  GetDepartmentListQueryVariables
>;
export const GetExternalDepartmentListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalDepartmentList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalDepartments" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "color" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "institution" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalDepartmentListQuery,
  GetExternalDepartmentListQueryVariables
>;
export const GetInstitutionsEmployeesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInstitutionsEmployees" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locale" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employees" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Employee",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "surname",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "email",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "image",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "source",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "blurhash",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "displayName",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "firstName",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "lastName",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "mobile",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "phone",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "type",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "alias",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "showImage",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "isSuperuser",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "employeeTitle",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "user",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "email",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "username",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInstitutionsEmployeesQuery,
  GetInstitutionsEmployeesQueryVariables
>;
export const GetEmployeesTitleDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getEmployeesTitle" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getEmployeeTitles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEmployeesTitleQuery,
  GetEmployeesTitleQueryVariables
>;
export const GetExternalEntityVisibilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalEntityVisibility" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entityType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "institutionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getEntityVisibility" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "entityType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "entityType" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "institutionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "institutionId" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "institutionId" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalEntityVisibilityQuery,
  GetExternalEntityVisibilityQueryVariables
>;
export const SetExternalEntityVisibilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "setExternalEntityVisibility" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entityId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "entityType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "institutionId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institution" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "setEntityVisibility" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "entityId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "entityId" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "entityType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "entityType" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "institutionId" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "institutionId" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "status" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "success" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetExternalEntityVisibilityMutation,
  SetExternalEntityVisibilityMutationVariables
>;
export const GetExternalGroupListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalGroupList" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "GROUP_CONNECTION" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalGroups" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "color" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupType" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalGroupListQuery,
  GetExternalGroupListQueryVariables
>;
export const GetGroupListDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getGroupList" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "groups" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "color" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "groupType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "moduleTypes" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contentProviders" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "content" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "institution",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGroupListQuery, GetGroupListQueryVariables>;
export const GetAllInstitutionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getAllInstitutions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "ids" },
                      value: { kind: "ListValue", values: [] },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAllInstitutionsQuery,
  GetAllInstitutionsQueryVariables
>;
export const GetExternalMealsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalMealsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "meal" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "mealDishes" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealDish" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealUnion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dishes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "mealDishes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dishes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "mealDishes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalMealsOnMyInstitutionQuery,
  GetExternalMealsOnMyInstitutionQueryVariables
>;
export const GetInternalMealsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInternalMealsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meals" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: { kind: "Name", value: "meal" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactEmployee" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Employee" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactResident" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Resident" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "relative" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Relative" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "displayName" } },
          { kind: "Field", name: { kind: "Name", value: "displayImage" } },
          { kind: "Field", name: { kind: "Name", value: "showImage" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "mobile" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactEmployee" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "compactResident" },
          },
          { kind: "FragmentSpread", name: { kind: "Name", value: "relative" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "mealDishes" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealDish" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meal" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealUnion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dishes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "mealDishes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "signupEnd" } },
                { kind: "Field", name: { kind: "Name", value: "signupClose" } },
                { kind: "Field", name: { kind: "Name", value: "maxSignups" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "responsible" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactProfile" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dishes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "mealDishes" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternalMealsOnMyInstitutionQuery,
  GetInternalMealsOnMyInstitutionQueryVariables
>;
export const GetMealDishesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMealDishes" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mealDishes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "MealDish",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "picture",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value: "picture",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalCount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMealDishesQuery, GetMealDishesQueryVariables>;
export const GetSummarizedExternalMealsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedExternalMeals" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedMeals",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedMeals" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealUnion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedExternalMealsQuery,
  GetSummarizedExternalMealsQueryVariables
>;
export const GetSummarizedMealsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedMealsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meals" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedMeals",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedMeals" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MealUnion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeal" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedMealsOnMyInstitutionQuery,
  GetSummarizedMealsOnMyInstitutionQueryVariables
>;
export const GetInternalMeetingsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInternalMeetingsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meetings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "meeting",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "participants" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Profile" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Employee" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Relative" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "Resident" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "agendaPoints" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MeetingAgendaPoint" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meetingSuggestions" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MeetingSuggestion" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "suggester" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Employee" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Relative" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Resident" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "source" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "blurhash" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "meeting" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Meeting" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "participants" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agendaPoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "agendaPoints" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "suggestions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDisabled" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "meetingSuggestions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "signupEnabled" },
                },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "location" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "notificationSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderFirst" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminderSecond" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agendaPoints" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "agendaPoints" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "suggestions" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "includeDisabled" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "meetingSuggestions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternalMeetingsOnMyInstitutionQuery,
  GetInternalMeetingsOnMyInstitutionQueryVariables
>;
export const GetMeetingAgendaPointTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getMeetingAgendaPointTemplates" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "meetingAgendaPointTemplates",
                        },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value:
                                                "MeetingAgendaPointTemplate",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "picture",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "source",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "totalCount" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMeetingAgendaPointTemplatesQuery,
  GetMeetingAgendaPointTemplatesQueryVariables
>;
export const GetSummarizedExternalMeetingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedExternalMeetings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedMeetings",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedMeetings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Meeting" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedExternalMeetingsQuery,
  GetSummarizedExternalMeetingsQueryVariables
>;
export const GetSummarizedMeetingsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedMeetingsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meetings" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedMeetings",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedMeetings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Meeting" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingMeeting" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingCategory" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "participants" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Relative" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedMeetingsOnMyInstitutionQuery,
  GetSummarizedMeetingsOnMyInstitutionQueryVariables
>;
export const GetExternalNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getExternalNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "newsUnion",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "newsUnion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PagedEntity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExternalNewsQuery,
  GetExternalNewsQueryVariables
>;
export const GetInternalNewsOnMyInstitutionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInternalNewsOnMyInstitution" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "news" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "newsUnion",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "newsUnion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PagedEntity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "published" } },
                { kind: "Field", name: { kind: "Name", value: "read" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictograms" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "pictogram" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "video" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "document" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInternalNewsOnMyInstitutionQuery,
  GetInternalNewsOnMyInstitutionQueryVariables
>;
export const GetSummarizedExternalNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedExternalNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "type" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MODULE_TYPE" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalContent" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "type" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "type" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedNewsUnion",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedNewsUnion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PagedEntity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedExternalNewsQuery,
  GetSummarizedExternalNewsQueryVariables
>;
export const GetSummarizedInternalNewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSummarizedInternalNews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "EntityPagerFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "news" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "FragmentSpread",
                                          name: {
                                            kind: "Name",
                                            value: "summarizedNewsUnion",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pageInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "pageInfo" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "summarizedNewsUnion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PagedEntity" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SingleNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingNews" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                { kind: "Field", name: { kind: "Name", value: "cancelled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "summarizedInstitution" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "picture" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactDepartment" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "groups" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "compactGroup" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "documents" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictures" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videos" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pageInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PageInfo" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "startCursor" } },
          { kind: "Field", name: { kind: "Name", value: "endCursor" } },
          { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
          { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSummarizedInternalNewsQuery,
  GetSummarizedInternalNewsQueryVariables
>;
export const NewsEntryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "NewsEntry" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "newsEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "news" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "picture" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Picture" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "blurhash" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "pictogram" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Pictogram" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "source" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "video" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Video" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "provider" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "thumbnail" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "document" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Document" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "url" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactDepartment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Department" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactGroup" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Group" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "groupType" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "compactInstitution" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Institution" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "locale" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "news" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "News" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "startDate" } },
          { kind: "Field", name: { kind: "Name", value: "endDate" } },
          { kind: "Field", name: { kind: "Name", value: "published" } },
          { kind: "Field", name: { kind: "Name", value: "read" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "image" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictograms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "pictogram" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictures" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "picture" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "videos" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "video" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "documents" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "document" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "departments" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "compactDepartment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "groups" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "compactGroup" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "institution" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "compactInstitution" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "category" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NewsEntryQuery, NewsEntryQueryVariables>;
export const GetPictogramsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPictograms" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "pictograms" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPictogramsQuery, GetPictogramsQueryVariables>;
export const AuditLogQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AuditLogQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AuditLogFilter" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "auditLog" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getByFilters" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filters" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "filters" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "created" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "entityType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "event" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profileId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profileType" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AuditLogQueryQuery, AuditLogQueryQueryVariables>;
export const CreatePlannerTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreatePlannerTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerTask" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlannerTaskCreateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createPlannerTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerTask" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerTask" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "plannerTaskActionResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerTaskActionResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerTaskActionResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePlannerTaskMutation,
  CreatePlannerTaskMutationVariables
>;
export const DeleteTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeletePlannerTaskInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deletePlannerTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const EditPlannerTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "EditPlannerTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerTaskId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "plannerTask" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PlannerTaskEditInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "editPlannerTask" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerTaskId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerTaskId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "plannerTask" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "plannerTask" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "plannerTaskActionResponse" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerTaskActionResponse" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerTaskActionResponse" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "success" } },
          { kind: "Field", name: { kind: "Name", value: "message" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EditPlannerTaskMutation,
  EditPlannerTaskMutationVariables
>;
export const EntitiesAvailabilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "entitiesAvailability" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Filter" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TimeZone" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "meetingRange" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateFrom" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateFrom" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateTo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateTo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SingleMeeting" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RepeatingMeeting" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "activityRange" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateFrom" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateFrom" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateTo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateTo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SingleActivity" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RepeatingActivity" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mealRange" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateFrom" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateFrom" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "dateTo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateTo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntitiesAvailabilityQuery,
  EntitiesAvailabilityQueryVariables
>;
export const GetActorsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActors" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Filter" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "profiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Employee" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayImage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "planner" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "assignment" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "inbox",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "Resident" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayImage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "planner" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "assignment" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "inbox",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "institution" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departments" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "screenOnly" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActorsQuery, GetActorsQueryVariables>;
export const GetPlannerCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPlannerCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getCategories" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlannerCategoriesQuery,
  GetPlannerCategoriesQueryVariables
>;
export const GetPlannerFiltersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPlannerFilters" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getFilters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "assigneeTypes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "categories" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "departments" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employees" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "residents" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlannerFiltersQuery,
  GetPlannerFiltersQueryVariables
>;
export const GetPlannerSubTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPlannerSubTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plannerTaskEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SinglePlannerTask" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subtasks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completed" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sortOrder" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "picture" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pictogram" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "RepeatingPlannerTask" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subtasks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "completed" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sortOrder" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "picture" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pictogram" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "source" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlannerSubTasksQuery,
  GetPlannerSubTasksQueryVariables
>;
export const GetPlannerTasksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPlannerTasks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "planner" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getTasksByFilters" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerTask" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerSubTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerSubtask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictogram" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SinglePlannerTask" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "type" },
                  name: { kind: "Name", value: "__typename" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignees" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Department" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForResident" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "picture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerSubTask" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completed" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvalState" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingPlannerTask" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "type" },
                  name: { kind: "Name", value: "__typename" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignees" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Department" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForResident" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "picture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerSubTask" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completed" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvalState" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "repeatId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlannerTasksQuery,
  GetPlannerTasksQueryVariables
>;
export const GetPlannerTemplatesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getPlannerTemplates" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plannerTemplates" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "image" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "blurhash" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "private" } },
                { kind: "Field", name: { kind: "Name", value: "start" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetPlannerTemplatesQuery,
  GetPlannerTemplatesQueryVariables
>;
export const GetSinglePlannerTaskDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSinglePlannerTask" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plannerTaskEntry" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "plannerTask" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerSubTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerSubtask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "completed" } },
          { kind: "Field", name: { kind: "Name", value: "sortOrder" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "picture" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "pictogram" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "source" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rrule" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRule" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "BYDAY" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "day" } },
                { kind: "Field", name: { kind: "Name", value: "occurrence" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "BYHOUR" } },
          { kind: "Field", name: { kind: "Name", value: "BYMINUTE" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTH" } },
          { kind: "Field", name: { kind: "Name", value: "BYMONTHDAY" } },
          { kind: "Field", name: { kind: "Name", value: "BYSECOND" } },
          { kind: "Field", name: { kind: "Name", value: "BYSETPOS" } },
          { kind: "Field", name: { kind: "Name", value: "BYWEEKNO" } },
          { kind: "Field", name: { kind: "Name", value: "BYYEARDAY" } },
          { kind: "Field", name: { kind: "Name", value: "COUNT" } },
          { kind: "Field", name: { kind: "Name", value: "DTSTART" } },
          { kind: "Field", name: { kind: "Name", value: "FREQ" } },
          { kind: "Field", name: { kind: "Name", value: "INTERVAL" } },
          { kind: "Field", name: { kind: "Name", value: "UNTIL" } },
          { kind: "Field", name: { kind: "Name", value: "WKST" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "rset" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RRuleSet" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "excludedDates" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "rule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "rrule" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "plannerTask" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "PlannerTask" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "SinglePlannerTask" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "type" },
                  name: { kind: "Name", value: "__typename" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignees" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Department" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForResident" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "picture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerSubTask" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completed" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvalState" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: { kind: "Name", value: "RepeatingPlannerTask" },
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "type" },
                  name: { kind: "Name", value: "__typename" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "assignees" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Department" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Employee" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "Resident" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              alias: { kind: "Name", value: "type" },
                              name: { kind: "Name", value: "__typename" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "visibleForResident" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "picture" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pictogram" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtasks" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "plannerSubTask" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "completed" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "approvalState" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "category" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "color" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "repeatId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "repeat" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rset" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "rset" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSinglePlannerTaskQuery,
  GetSinglePlannerTaskQueryVariables
>;
export const PlannerCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PlannerCategories" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "plannerCategories" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "color" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PlannerCategoriesQuery,
  PlannerCategoriesQueryVariables
>;
export const ScheduleAvailableEmployeesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "scheduleAvailableEmployees" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Filter" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTime" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DateTime" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "scheduleAvailableEmployees" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filter" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "from" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateFrom" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "to" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "dateTo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "employeeId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unavailableFrom" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unavailableTo" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "unavailableReason" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ScheduleAvailableEmployeesQuery,
  ScheduleAvailableEmployeesQueryVariables
>;
export const SettingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "settings" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "settings" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institutions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "vismaGatWs" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "planner" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "manager" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "showOverdue",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SettingsQuery, SettingsQueryVariables>;
export const GetProfilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getProfiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EntityPagerFilter" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "institutions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getMyInstitution" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employees" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Employee",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "surname",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "type",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "image",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "source",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "blurhash",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "departments",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "name",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "color",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "residents" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "filter" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "filter" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edges" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "node" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "InlineFragment",
                                          typeCondition: {
                                            kind: "NamedType",
                                            name: {
                                              kind: "Name",
                                              value: "Resident",
                                            },
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "surname",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "image",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "source",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "blurhash",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "departments",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "name",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "color",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProfilesQuery, GetProfilesQueryVariables>;
export const GetRepeatOccurrencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getRepeatOccurrences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "rset" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RRuleSetInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "repeat" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getOccurrences" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "rset" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "rset" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRepeatOccurrencesQuery,
  GetRepeatOccurrencesQueryVariables
>;
export const DeleteUserByUsernameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteUserByUsername" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "username" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "username" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "username" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "success" } },
                { kind: "Field", name: { kind: "Name", value: "message" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteUserByUsernameMutation,
  DeleteUserByUsernameMutationVariables
>;
export const GetByEmailOrUsernameDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getByEmailOrUsername" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "username" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "getByEmailOrUsername" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "email" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "email" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "username" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "username" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetByEmailOrUsernameQuery,
  GetByEmailOrUsernameQueryVariables
>;
export const GetSelfQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getSelfQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "self" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "institutions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locale" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "useExternalWorkSchedule",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "planner" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "enabledEmployees",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "get" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "institution" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "role" },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "settings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "policies" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "managerPolicyAccepted",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "profiles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "Employee" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "image" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "source",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "blurhash",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "plannerFilter",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "institution",
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "locale",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "notificationSettings",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "activity",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "FragmentSpread",
                                                      name: {
                                                        kind: "Name",
                                                        value:
                                                          "notificationSettings",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "notificationSettings" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "NotificationSettings" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "reminderFirst" } },
          { kind: "Field", name: { kind: "Name", value: "reminderSecond" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggerWhenCancelled" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "triggerWhenTimeChange" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSelfQueryQuery, GetSelfQueryQueryVariables>;
export const GetShiftsQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getShiftsQuery" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateFrom" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "dateTo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Date" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filter" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Filter" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "TimeZone" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "schedule" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shifts" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateFrom" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateFrom" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "dateTo" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "dateTo" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filter" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "filter" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "timezone" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "timezone" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cancelled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "employee" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayImage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "displayName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "showImage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "shift" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "end" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "start" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "end" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nightShift" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "start" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unavailable" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "end" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "start" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShiftsQueryQuery, GetShiftsQueryQueryVariables>;
